/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Recap
 * OpenAPI spec version: 1
 */
import * as zod from 'zod';

export const appearanceColorsLightRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const appearanceColorsDarkRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const appearanceIsDarkDerivationEnabledDefault = true;
export const Appearance = zod.object({
    theme: zod.enum(['classic', 'terracotta', 'graphite', 'navy', 'slate', 'indigo']),
    layout: zod.enum(['flat', 'tinted_rail', 'canvas', 'inset', 'dark_frame']),
    headline_font: zod.enum(['inter', 'fraunces', 'newsreader', 'hanken_grotesk', 'bricolage_grotesque']),
    colors_light: zod.record(zod.string(), zod.string().regex(appearanceColorsLightRegExpOne)),
    colors_dark: zod.record(zod.string(), zod.string().regex(appearanceColorsDarkRegExpOne)),
    is_dark_derivation_enabled: zod.boolean().default(appearanceIsDarkDerivationEnabledDefault),
});

export type Appearance = zod.input<typeof Appearance>;
export type AppearanceOutput = zod.output<typeof Appearance>;

export const Language = zod.enum(['de', 'en']);

export type Language = zod.input<typeof Language>;
export type LanguageOutput = zod.output<typeof Language>;

export const OwnedWorkspace = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
});

export type OwnedWorkspace = zod.input<typeof OwnedWorkspace>;
export type OwnedWorkspaceOutput = zod.output<typeof OwnedWorkspace>;

export const SsoProvider = zod.enum(['google']);

export type SsoProvider = zod.input<typeof SsoProvider>;
export type SsoProviderOutput = zod.output<typeof SsoProvider>;

export const SsoIdentity = zod.object({
    id: zod.uuid(),
    provider: zod.enum(['google']),
    email: zod.email(),
});

export type SsoIdentity = zod.input<typeof SsoIdentity>;
export type SsoIdentityOutput = zod.output<typeof SsoIdentity>;

export const UserPermissions = zod.object({
    can_delete_account: zod.boolean(),
    can_create_workspace: zod.boolean(),
});

export type UserPermissions = zod.input<typeof UserPermissions>;
export type UserPermissionsOutput = zod.output<typeof UserPermissions>;

export const userAppearanceOneColorsLightRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const userAppearanceOneColorsDarkRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const userAppearanceOneIsDarkDerivationEnabledDefault = true;
export const User = zod.object({
    id: zod.uuid(),
    first_name: zod.string(),
    last_name: zod.string(),
    display_name: zod.string(),
    email: zod.email(),
    avatar_url: zod.union([zod.string(), zod.null()]),
    is_disabled: zod.boolean(),
    is_deleted: zod.boolean(),
    is_api: zod.boolean(),
    language: zod.enum(['de', 'en']),
    appearance: zod.union([
        zod.object({
            theme: zod.enum(['classic', 'terracotta', 'graphite', 'navy', 'slate', 'indigo']),
            layout: zod.enum(['flat', 'tinted_rail', 'canvas', 'inset', 'dark_frame']),
            headline_font: zod.enum(['inter', 'fraunces', 'newsreader', 'hanken_grotesk', 'bricolage_grotesque']),
            colors_light: zod.record(zod.string(), zod.string().regex(userAppearanceOneColorsLightRegExpOne)),
            colors_dark: zod.record(zod.string(), zod.string().regex(userAppearanceOneColorsDarkRegExpOne)),
            is_dark_derivation_enabled: zod.boolean().default(userAppearanceOneIsDarkDerivationEnabledDefault),
        }),
        zod.null(),
    ]),
    job_title: zod.union([zod.string(), zod.null()]),
    is_email_verified: zod.boolean(),
    pending_email: zod.union([zod.email(), zod.null()]),
    owned_workspaces: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        })
    ),
    sso_identities: zod.array(
        zod.object({
            id: zod.uuid(),
            provider: zod.enum(['google']),
            email: zod.email(),
        })
    ),
    permissions: zod.object({
        can_delete_account: zod.boolean(),
        can_create_workspace: zod.boolean(),
    }),
});

export type User = zod.input<typeof User>;
export type UserOutput = zod.output<typeof User>;

export const ErrorCode = zod.enum([
    'not_signed_in',
    'csrf_failed',
    'not_found',
    'owner_only',
    'required',
    'too_long',
    'invalid',
    'invalid_reference',
    'email_taken',
    'too_many_attempts',
    'email_not_sent',
    'email_not_verified',
    'approval_pending',
    'already_approved',
    'wrong_code',
    'code_expired',
    'invitation_for_other_email',
    'slug_taken',
    'terms_not_accepted',
    'owner_cannot_leave',
    'access_disabled',
    'owner_cannot_be_disabled',
    'owner_cannot_delete_account',
    'email_incorrect',
    'sso_denied',
    'sso_expired',
    'sso_email_not_verified',
    'sso_unavailable',
    'already_member',
    'already_invited',
    'already_employee',
    'file_type_not_allowed',
    'file_too_large',
    'image_type_not_allowed',
    'image_not_readable',
    'connection_login_failed',
    'connection_unreachable',
    'connection_host_not_allowed',
    'connection_unsupported_version',
    'connection_api_not_included',
    'feed_not_found',
    'feed_sync_running',
    'input_on_own_connection',
    'webhook_rejected',
    'webhook_payload_invalid',
    'token_not_allowed',
    'token_read_only',
    'bot_taken',
    'oauth_request_invalid',
    'recap_processing',
    'recap_not_publishable',
    'recap_not_shareable',
    'recap_draft_not_discardable',
    'recap_version_not_restorable',
    'source_processing',
    'source_has_no_update',
    'source_not_found_at_provider',
    'link_connection_missing',
    'link_unreadable',
    'link_without_text',
    'source_file_unreadable',
    'client_has_recaps',
    'external_company_linked',
    'project_has_recaps',
    'project_without_client',
    'project_not_of_client',
    'route_overlaps',
    'route_query_invalid',
    'feed_taken',
    'todos_output_taken',
    'todo_output_not_reported',
    'feed_lists_in_use',
    'connection_scope_missing',
    'connection_signed_out',
    'oauth_denied',
    'oauth_admin_consent_required',
    'oauth_other_account',
    'oauth_expired',
    'github_installation_unknown',
    'github_install_requested',
    'not_comment_author',
    'recap_acknowledgers_not_changeable',
    'not_acknowledger',
    'already_acknowledged',
    'not_todo_person',
]);

export type ErrorCode = zod.input<typeof ErrorCode>;
export type ErrorCodeOutput = zod.output<typeof ErrorCode>;

export const ErrorResponse = zod.object({
    code: zod.enum([
        'not_signed_in',
        'csrf_failed',
        'not_found',
        'owner_only',
        'required',
        'too_long',
        'invalid',
        'invalid_reference',
        'email_taken',
        'too_many_attempts',
        'email_not_sent',
        'email_not_verified',
        'approval_pending',
        'already_approved',
        'wrong_code',
        'code_expired',
        'invitation_for_other_email',
        'slug_taken',
        'terms_not_accepted',
        'owner_cannot_leave',
        'access_disabled',
        'owner_cannot_be_disabled',
        'owner_cannot_delete_account',
        'email_incorrect',
        'sso_denied',
        'sso_expired',
        'sso_email_not_verified',
        'sso_unavailable',
        'already_member',
        'already_invited',
        'already_employee',
        'file_type_not_allowed',
        'file_too_large',
        'image_type_not_allowed',
        'image_not_readable',
        'connection_login_failed',
        'connection_unreachable',
        'connection_host_not_allowed',
        'connection_unsupported_version',
        'connection_api_not_included',
        'feed_not_found',
        'feed_sync_running',
        'input_on_own_connection',
        'webhook_rejected',
        'webhook_payload_invalid',
        'token_not_allowed',
        'token_read_only',
        'bot_taken',
        'oauth_request_invalid',
        'recap_processing',
        'recap_not_publishable',
        'recap_not_shareable',
        'recap_draft_not_discardable',
        'recap_version_not_restorable',
        'source_processing',
        'source_has_no_update',
        'source_not_found_at_provider',
        'link_connection_missing',
        'link_unreadable',
        'link_without_text',
        'source_file_unreadable',
        'client_has_recaps',
        'external_company_linked',
        'project_has_recaps',
        'project_without_client',
        'project_not_of_client',
        'route_overlaps',
        'route_query_invalid',
        'feed_taken',
        'todos_output_taken',
        'todo_output_not_reported',
        'feed_lists_in_use',
        'connection_scope_missing',
        'connection_signed_out',
        'oauth_denied',
        'oauth_admin_consent_required',
        'oauth_other_account',
        'oauth_expired',
        'github_installation_unknown',
        'github_install_requested',
        'not_comment_author',
        'recap_acknowledgers_not_changeable',
        'not_acknowledger',
        'already_acknowledged',
        'not_todo_person',
    ]),
    message: zod.string(),
    field: zod.union([zod.string(), zod.null()]),
});

export type ErrorResponse = zod.input<typeof ErrorResponse>;
export type ErrorResponseOutput = zod.output<typeof ErrorResponse>;

export const userUpdateJobTitleOneMax = 150;

export const userUpdateAppearanceOneColorsLightRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const userUpdateAppearanceOneColorsDarkRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const userUpdateAppearanceOneIsDarkDerivationEnabledDefault = true;
export const UserUpdate = zod.object({
    first_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    last_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    display_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    job_title: zod.union([zod.string().max(userUpdateJobTitleOneMax), zod.null()]).optional(),
    language: zod.union([zod.enum(['de', 'en']), zod.null()]).optional(),
    appearance: zod
        .union([
            zod.object({
                theme: zod.enum(['classic', 'terracotta', 'graphite', 'navy', 'slate', 'indigo']),
                layout: zod.enum(['flat', 'tinted_rail', 'canvas', 'inset', 'dark_frame']),
                headline_font: zod.enum(['inter', 'fraunces', 'newsreader', 'hanken_grotesk', 'bricolage_grotesque']),
                colors_light: zod.record(zod.string(), zod.string().regex(userUpdateAppearanceOneColorsLightRegExpOne)),
                colors_dark: zod.record(zod.string(), zod.string().regex(userUpdateAppearanceOneColorsDarkRegExpOne)),
                is_dark_derivation_enabled: zod
                    .boolean()
                    .default(userUpdateAppearanceOneIsDarkDerivationEnabledDefault),
            }),
            zod.null(),
        ])
        .optional(),
});

export type UserUpdate = zod.input<typeof UserUpdate>;
export type UserUpdateOutput = zod.output<typeof UserUpdate>;

export const AccountDeletion = zod.object({
    email: zod.email(),
});

export type AccountDeletion = zod.input<typeof AccountDeletion>;
export type AccountDeletionOutput = zod.output<typeof AccountDeletion>;

export const EmailChangeInput = zod.object({
    email: zod.email(),
});

export type EmailChangeInput = zod.input<typeof EmailChangeInput>;
export type EmailChangeInputOutput = zod.output<typeof EmailChangeInput>;

export const EmailVerificationInput = zod.object({
    code: zod.string().min(1),
});

export type EmailVerificationInput = zod.input<typeof EmailVerificationInput>;
export type EmailVerificationInputOutput = zod.output<typeof EmailVerificationInput>;

export const Inbox = zod.object({
    name: zod.string(),
    url: zod.string(),
});

export type Inbox = zod.input<typeof Inbox>;
export type InboxOutput = zod.output<typeof Inbox>;

export const SignInCodeSent = zod.object({
    inbox: zod.union([
        zod.object({
            name: zod.string(),
            url: zod.string(),
        }),
        zod.null(),
    ]),
});

export type SignInCodeSent = zod.input<typeof SignInCodeSent>;
export type SignInCodeSentOutput = zod.output<typeof SignInCodeSent>;

export const signInCodeInputContinuePathDefault = `/`;
export const signInCodeInputAuthQueryDefault = ``;
export const SignInCodeInput = zod.object({
    continue_path: zod.string().default(signInCodeInputContinuePathDefault),
    auth_query: zod.string().default(signInCodeInputAuthQueryDefault),
    language: zod.enum(['de', 'en']),
    email: zod.email(),
});

export type SignInCodeInput = zod.input<typeof SignInCodeInput>;
export type SignInCodeInputOutput = zod.output<typeof SignInCodeInput>;

export const signInResultUserAppearanceOneColorsLightRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const signInResultUserAppearanceOneColorsDarkRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const signInResultUserAppearanceOneIsDarkDerivationEnabledDefault = true;
export const SignInResult = zod.object({
    user: zod.object({
        id: zod.uuid(),
        first_name: zod.string(),
        last_name: zod.string(),
        display_name: zod.string(),
        email: zod.email(),
        avatar_url: zod.union([zod.string(), zod.null()]),
        is_disabled: zod.boolean(),
        is_deleted: zod.boolean(),
        is_api: zod.boolean(),
        language: zod.enum(['de', 'en']),
        appearance: zod.union([
            zod.object({
                theme: zod.enum(['classic', 'terracotta', 'graphite', 'navy', 'slate', 'indigo']),
                layout: zod.enum(['flat', 'tinted_rail', 'canvas', 'inset', 'dark_frame']),
                headline_font: zod.enum(['inter', 'fraunces', 'newsreader', 'hanken_grotesk', 'bricolage_grotesque']),
                colors_light: zod.record(
                    zod.string(),
                    zod.string().regex(signInResultUserAppearanceOneColorsLightRegExpOne)
                ),
                colors_dark: zod.record(
                    zod.string(),
                    zod.string().regex(signInResultUserAppearanceOneColorsDarkRegExpOne)
                ),
                is_dark_derivation_enabled: zod
                    .boolean()
                    .default(signInResultUserAppearanceOneIsDarkDerivationEnabledDefault),
            }),
            zod.null(),
        ]),
        job_title: zod.union([zod.string(), zod.null()]),
        is_email_verified: zod.boolean(),
        pending_email: zod.union([zod.email(), zod.null()]),
        owned_workspaces: zod.array(
            zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
            })
        ),
        sso_identities: zod.array(
            zod.object({
                id: zod.uuid(),
                provider: zod.enum(['google']),
                email: zod.email(),
            })
        ),
        permissions: zod.object({
            can_delete_account: zod.boolean(),
            can_create_workspace: zod.boolean(),
        }),
    }),
    is_new: zod.boolean(),
    continue_path: zod.string(),
    auth_query: zod.string(),
});

export type SignInResult = zod.input<typeof SignInResult>;
export type SignInResultOutput = zod.output<typeof SignInResult>;

export const SignInCodeVerification = zod.object({
    email: zod.union([zod.email(), zod.null()]).optional(),
    code: zod.union([zod.string(), zod.null()]).optional(),
    token: zod.union([zod.string(), zod.null()]).optional(),
});

export type SignInCodeVerification = zod.input<typeof SignInCodeVerification>;
export type SignInCodeVerificationOutput = zod.output<typeof SignInCodeVerification>;

export const SsoStartResult = zod.object({
    authorize_url: zod.string(),
});

export type SsoStartResult = zod.input<typeof SsoStartResult>;
export type SsoStartResultOutput = zod.output<typeof SsoStartResult>;

export const ssoStartContinuePathDefault = `/`;
export const ssoStartAuthQueryDefault = ``;
export const SsoStart = zod.object({
    continue_path: zod.string().default(ssoStartContinuePathDefault),
    auth_query: zod.string().default(ssoStartAuthQueryDefault),
    language: zod.enum(['de', 'en']),
    email_hint: zod.union([zod.email(), zod.null()]).optional(),
});

export type SsoStart = zod.input<typeof SsoStart>;
export type SsoStartOutput = zod.output<typeof SsoStart>;

export const WorkspaceRole = zod.enum(['owner', 'member', 'employee']);

export type WorkspaceRole = zod.input<typeof WorkspaceRole>;
export type WorkspaceRoleOutput = zod.output<typeof WorkspaceRole>;

export const WorkspaceClient = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
});

export type WorkspaceClient = zod.input<typeof WorkspaceClient>;
export type WorkspaceClientOutput = zod.output<typeof WorkspaceClient>;

export const WorkspacePermissions = zod.object({
    can_edit: zod.boolean(),
    can_delete: zod.boolean(),
    can_manage_members: zod.boolean(),
    can_connect_integrations: zod.boolean(),
    can_leave: zod.boolean(),
    can_manage_email_address: zod.boolean(),
});

export type WorkspacePermissions = zod.input<typeof WorkspacePermissions>;
export type WorkspacePermissionsOutput = zod.output<typeof WorkspacePermissions>;

export const Workspace = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    color_hue: zod.union([zod.int(), zod.null()]),
    logo_url: zod.union([zod.string(), zod.null()]),
    role: zod.enum(['owner', 'member', 'employee']),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    is_access_disabled: zod.boolean(),
    email_address: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_edit: zod.boolean(),
        can_delete: zod.boolean(),
        can_manage_members: zod.boolean(),
        can_connect_integrations: zod.boolean(),
        can_leave: zod.boolean(),
        can_manage_email_address: zod.boolean(),
    }),
});

export type Workspace = zod.input<typeof Workspace>;
export type WorkspaceOutput = zod.output<typeof Workspace>;

export const workspaceCreateInputNameMax = 200;

export const workspaceCreateInputSlugMax = 40;

export const workspaceCreateInputSlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const workspaceCreateInputColorHueOneMin = 0;
export const workspaceCreateInputColorHueOneMax = 359;

export const WorkspaceCreateInput = zod.object({
    name: zod.string().min(1).max(workspaceCreateInputNameMax),
    slug: zod.string().max(workspaceCreateInputSlugMax).regex(workspaceCreateInputSlugRegExp),
    color_hue: zod.union([
        zod.int().min(workspaceCreateInputColorHueOneMin).max(workspaceCreateInputColorHueOneMax),
        zod.null(),
    ]),
    has_accepted_terms: zod.boolean(),
});

export type WorkspaceCreateInput = zod.input<typeof WorkspaceCreateInput>;
export type WorkspaceCreateInputOutput = zod.output<typeof WorkspaceCreateInput>;

export const workspaceInputNameMax = 200;

export const workspaceInputSlugMax = 40;

export const workspaceInputSlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const workspaceInputColorHueOneMin = 0;
export const workspaceInputColorHueOneMax = 359;

export const WorkspaceInput = zod.object({
    name: zod.string().min(1).max(workspaceInputNameMax),
    slug: zod.string().max(workspaceInputSlugMax).regex(workspaceInputSlugRegExp),
    color_hue: zod.union([zod.int().min(workspaceInputColorHueOneMin).max(workspaceInputColorHueOneMax), zod.null()]),
});

export type WorkspaceInput = zod.input<typeof WorkspaceInput>;
export type WorkspaceInputOutput = zod.output<typeof WorkspaceInput>;

export const emailAddressUpdatePrefixMax = 40;

export const emailAddressUpdatePrefixRegExp = new RegExp('^([a-z0-9]+(-[a-z0-9]+)*)?$');

export const EmailAddressUpdate = zod.object({
    prefix: zod.string().max(emailAddressUpdatePrefixMax).regex(emailAddressUpdatePrefixRegExp),
});

export type EmailAddressUpdate = zod.input<typeof EmailAddressUpdate>;
export type EmailAddressUpdateOutput = zod.output<typeof EmailAddressUpdate>;

export const InvitationWorkspace = zod.object({
    name: zod.string(),
    color_hue: zod.union([zod.int(), zod.null()]),
    logo_url: zod.union([zod.string(), zod.null()]),
});

export type InvitationWorkspace = zod.input<typeof InvitationWorkspace>;
export type InvitationWorkspaceOutput = zod.output<typeof InvitationWorkspace>;

export const InvitationPreview = zod.object({
    email: zod.union([zod.email(), zod.null()]),
    workspace: zod.object({
        name: zod.string(),
        color_hue: zod.union([zod.int(), zod.null()]),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
});

export type InvitationPreview = zod.input<typeof InvitationPreview>;
export type InvitationPreviewOutput = zod.output<typeof InvitationPreview>;

export const PendingInvitation = zod.object({
    kind: zod.enum(['member', 'employee']),
    token: zod.string(),
    workspace: zod.object({
        name: zod.string(),
        color_hue: zod.union([zod.int(), zod.null()]),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
    client_name: zod.union([zod.string(), zod.null()]),
});

export type PendingInvitation = zod.input<typeof PendingInvitation>;
export type PendingInvitationOutput = zod.output<typeof PendingInvitation>;

export const EmployeeClient = zod.object({
    name: zod.string(),
});

export type EmployeeClient = zod.input<typeof EmployeeClient>;
export type EmployeeClientOutput = zod.output<typeof EmployeeClient>;

export const EmployeeInvitationPreview = zod.object({
    email: zod.union([zod.email(), zod.null()]),
    client: zod.object({
        name: zod.string(),
    }),
    workspace: zod.object({
        name: zod.string(),
        color_hue: zod.union([zod.int(), zod.null()]),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
});

export type EmployeeInvitationPreview = zod.input<typeof EmployeeInvitationPreview>;
export type EmployeeInvitationPreviewOutput = zod.output<typeof EmployeeInvitationPreview>;

export const PublicClient = zod.object({
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
});

export type PublicClient = zod.input<typeof PublicClient>;
export type PublicClientOutput = zod.output<typeof PublicClient>;

export const PublicProject = zod.object({
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
    client: zod.union([
        zod.object({
            name: zod.string(),
            logo_url: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    workspace: zod.object({
        name: zod.string(),
        color_hue: zod.union([zod.int(), zod.null()]),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
});

export type PublicProject = zod.input<typeof PublicProject>;
export type PublicProjectOutput = zod.output<typeof PublicProject>;

export const inputPageDefault = 1;

export const Input = zod.object({
    page: zod.int().min(1).default(inputPageDefault),
    page_size: zod.union([zod.int().min(1), zod.null()]).optional(),
});

export type Input = zod.input<typeof Input>;
export type InputOutput = zod.output<typeof Input>;

export const RecapVersionSummary = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
});

export type RecapVersionSummary = zod.input<typeof RecapVersionSummary>;
export type RecapVersionSummaryOutput = zod.output<typeof RecapVersionSummary>;

export const PublicRecapListItem = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    published_version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
    }),
});

export type PublicRecapListItem = zod.input<typeof PublicRecapListItem>;
export type PublicRecapListItemOutput = zod.output<typeof PublicRecapListItem>;

export const PagedPublicRecapListItem = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            published_version: zod.object({
                number: zod.int(),
                created_at: zod.iso.datetime({ offset: true }),
            }),
        })
    ),
    count: zod.int(),
});

export type PagedPublicRecapListItem = zod.input<typeof PagedPublicRecapListItem>;
export type PagedPublicRecapListItemOutput = zod.output<typeof PagedPublicRecapListItem>;

export const SourceFileSummary = zod.object({
    id: zod.uuid(),
    file_name: zod.string(),
    is_email_body: zod.boolean(),
    source_id: zod.uuid(),
});

export type SourceFileSummary = zod.input<typeof SourceFileSummary>;
export type SourceFileSummaryOutput = zod.output<typeof SourceFileSummary>;

export const Citation = zod.object({
    id: zod.uuid(),
    quote: zod.string(),
    source_file: zod.union([
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            is_email_body: zod.boolean(),
            source_id: zod.uuid(),
        }),
        zod.null(),
    ]),
});

export type Citation = zod.input<typeof Citation>;
export type CitationOutput = zod.output<typeof Citation>;

export const Decision = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    description: zod.union([zod.string(), zod.null()]),
    citations: zod.array(
        zod.object({
            id: zod.uuid(),
            quote: zod.string(),
            source_file: zod.union([
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    is_email_body: zod.boolean(),
                    source_id: zod.uuid(),
                }),
                zod.null(),
            ]),
        })
    ),
});

export type Decision = zod.input<typeof Decision>;
export type DecisionOutput = zod.output<typeof Decision>;

export const ExtractionStatus = zod.enum(['processing', 'done', 'failed']);

export type ExtractionStatus = zod.input<typeof ExtractionStatus>;
export type ExtractionStatusOutput = zod.output<typeof ExtractionStatus>;

export const RecapAutomation = zod.enum(['on_arrival', 'weekly']);

export type RecapAutomation = zod.input<typeof RecapAutomation>;
export type RecapAutomationOutput = zod.output<typeof RecapAutomation>;

export const RecapSummary = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
});

export type RecapSummary = zod.input<typeof RecapSummary>;
export type RecapSummaryOutput = zod.output<typeof RecapSummary>;

export const ItemLink = zod.object({
    id: zod.uuid(),
    title: zod.union([zod.string(), zod.null()]),
    recap: zod.object({
        id: zod.uuid(),
        public_id: zod.string(),
        slug: zod.string(),
        title: zod.union([zod.string(), zod.null()]),
        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    }),
});

export type ItemLink = zod.input<typeof ItemLink>;
export type ItemLinkOutput = zod.output<typeof ItemLink>;

export const ItemLinks = zod.object({
    supersedes: zod.union([
        zod.object({
            id: zod.uuid(),
            title: zod.union([zod.string(), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
        }),
        zod.null(),
    ]),
    superseded_by: zod.union([
        zod.object({
            id: zod.uuid(),
            title: zod.union([zod.string(), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
        }),
        zod.null(),
    ]),
});

export type ItemLinks = zod.input<typeof ItemLinks>;
export type ItemLinksOutput = zod.output<typeof ItemLinks>;

export const Event = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    description: zod.union([zod.string(), zod.null()]),
    date: zod.iso.date(),
    time: zod.union([zod.iso.time({}), zod.null()]),
    citations: zod.array(
        zod.object({
            id: zod.uuid(),
            quote: zod.string(),
            source_file: zod.union([
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    is_email_body: zod.boolean(),
                    source_id: zod.uuid(),
                }),
                zod.null(),
            ]),
        })
    ),
    links: zod.object({
        supersedes: zod.union([
            zod.object({
                id: zod.uuid(),
                title: zod.union([zod.string(), zod.null()]),
                recap: zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
            }),
            zod.null(),
        ]),
        superseded_by: zod.union([
            zod.object({
                id: zod.uuid(),
                title: zod.union([zod.string(), zod.null()]),
                recap: zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
            }),
            zod.null(),
        ]),
    }),
});

export type Event = zod.input<typeof Event>;
export type EventOutput = zod.output<typeof Event>;

export const ExternalLink = zod.object({
    provider: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    url: zod.string(),
});

export type ExternalLink = zod.input<typeof ExternalLink>;
export type ExternalLinkOutput = zod.output<typeof ExternalLink>;

export const PersonSide = zod.enum(['team', 'client']);

export type PersonSide = zod.input<typeof PersonSide>;
export type PersonSideOutput = zod.output<typeof PersonSide>;

export const UserSummary = zod.object({
    id: zod.uuid(),
    first_name: zod.string(),
    last_name: zod.string(),
    display_name: zod.string(),
    email: zod.union([zod.email(), zod.null()]),
    avatar_url: zod.union([zod.string(), zod.null()]),
    is_disabled: zod.boolean(),
    is_deleted: zod.boolean(),
    is_api: zod.boolean(),
});

export type UserSummary = zod.input<typeof UserSummary>;
export type UserSummaryOutput = zod.output<typeof UserSummary>;

export const Person = zod.object({
    id: zod.uuid(),
    name: zod.string(),
    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
    company: zod.union([zod.string(), zod.null()]),
    avatar_url: zod.union([zod.string(), zod.null()]),
    email: zod.union([zod.string(), zod.null()]),
    job_title: zod.union([zod.string(), zod.null()]),
    is_participant: zod.boolean(),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    citations: zod.array(
        zod.object({
            id: zod.uuid(),
            quote: zod.string(),
            source_file: zod.union([
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    is_email_body: zod.boolean(),
                    source_id: zod.uuid(),
                }),
                zod.null(),
            ]),
        })
    ),
});

export type Person = zod.input<typeof Person>;
export type PersonOutput = zod.output<typeof Person>;

export const PersonSummary = zod.object({
    id: zod.uuid(),
    name: zod.string(),
    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
    company: zod.union([zod.string(), zod.null()]),
    avatar_url: zod.union([zod.string(), zod.null()]),
});

export type PersonSummary = zod.input<typeof PersonSummary>;
export type PersonSummaryOutput = zod.output<typeof PersonSummary>;

export const TodoPermissions = zod.object({
    can_mark_done: zod.boolean(),
});

export type TodoPermissions = zod.input<typeof TodoPermissions>;
export type TodoPermissionsOutput = zod.output<typeof TodoPermissions>;

export const Todo = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    description: zod.union([zod.string(), zod.null()]),
    person: zod.union([
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    is_done: zod.boolean(),
    done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    done_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    citations: zod.array(
        zod.object({
            id: zod.uuid(),
            quote: zod.string(),
            source_file: zod.union([
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    is_email_body: zod.boolean(),
                    source_id: zod.uuid(),
                }),
                zod.null(),
            ]),
        })
    ),
    links: zod.object({
        supersedes: zod.union([
            zod.object({
                id: zod.uuid(),
                title: zod.union([zod.string(), zod.null()]),
                recap: zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
            }),
            zod.null(),
        ]),
        superseded_by: zod.union([
            zod.object({
                id: zod.uuid(),
                title: zod.union([zod.string(), zod.null()]),
                recap: zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
            }),
            zod.null(),
        ]),
    }),
    external_link: zod.union([
        zod.object({
            provider: zod.string(),
            provider_name: zod.union([zod.string(), zod.null()]),
            url: zod.string(),
        }),
        zod.null(),
    ]),
    permissions: zod.object({
        can_mark_done: zod.boolean(),
    }),
});

export type Todo = zod.input<typeof Todo>;
export type TodoOutput = zod.output<typeof Todo>;

export const Topic = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    summary: zod.union([zod.string(), zod.null()]),
    citations: zod.array(
        zod.object({
            id: zod.uuid(),
            quote: zod.string(),
            source_file: zod.union([
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    is_email_body: zod.boolean(),
                    source_id: zod.uuid(),
                }),
                zod.null(),
            ]),
        })
    ),
    decisions: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
        })
    ),
    todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            is_done: zod.boolean(),
            done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            done_by: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            links: zod.object({
                supersedes: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        title: zod.union([zod.string(), zod.null()]),
                        recap: zod.object({
                            id: zod.uuid(),
                            public_id: zod.string(),
                            slug: zod.string(),
                            title: zod.union([zod.string(), zod.null()]),
                            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                        }),
                    }),
                    zod.null(),
                ]),
                superseded_by: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        title: zod.union([zod.string(), zod.null()]),
                        recap: zod.object({
                            id: zod.uuid(),
                            public_id: zod.string(),
                            slug: zod.string(),
                            title: zod.union([zod.string(), zod.null()]),
                            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                        }),
                    }),
                    zod.null(),
                ]),
            }),
            external_link: zod.union([
                zod.object({
                    provider: zod.string(),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    url: zod.string(),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            links: zod.object({
                supersedes: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        title: zod.union([zod.string(), zod.null()]),
                        recap: zod.object({
                            id: zod.uuid(),
                            public_id: zod.string(),
                            slug: zod.string(),
                            title: zod.union([zod.string(), zod.null()]),
                            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                        }),
                    }),
                    zod.null(),
                ]),
                superseded_by: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        title: zod.union([zod.string(), zod.null()]),
                        recap: zod.object({
                            id: zod.uuid(),
                            public_id: zod.string(),
                            slug: zod.string(),
                            title: zod.union([zod.string(), zod.null()]),
                            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                        }),
                    }),
                    zod.null(),
                ]),
            }),
        })
    ),
});

export type Topic = zod.input<typeof Topic>;
export type TopicOutput = zod.output<typeof Topic>;

export const PublicRecapVersion = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
    title: zod.union([zod.string(), zod.null()]),
    summary: zod.union([zod.string(), zod.null()]),
    persons: zod.array(
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            email: zod.union([zod.string(), zod.null()]),
            job_title: zod.union([zod.string(), zod.null()]),
            is_participant: zod.boolean(),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
        })
    ),
    topics: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            summary: zod.union([zod.string(), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            decisions: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                })
            ),
            todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    is_done: zod.boolean(),
                    done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    done_by: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                    external_link: zod.union([
                        zod.object({
                            provider: zod.string(),
                            provider_name: zod.union([zod.string(), zod.null()]),
                            url: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                })
            ),
        })
    ),
});

export type PublicRecapVersion = zod.input<typeof PublicRecapVersion>;
export type PublicRecapVersionOutput = zod.output<typeof PublicRecapVersion>;

export const PublicRecap = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    published_version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
    }),
    version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
        title: zod.union([zod.string(), zod.null()]),
        summary: zod.union([zod.string(), zod.null()]),
        persons: zod.array(
            zod.object({
                id: zod.uuid(),
                name: zod.string(),
                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                company: zod.union([zod.string(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                email: zod.union([zod.string(), zod.null()]),
                job_title: zod.union([zod.string(), zod.null()]),
                is_participant: zod.boolean(),
                user: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        first_name: zod.string(),
                        last_name: zod.string(),
                        display_name: zod.string(),
                        email: zod.union([zod.email(), zod.null()]),
                        avatar_url: zod.union([zod.string(), zod.null()]),
                        is_disabled: zod.boolean(),
                        is_deleted: zod.boolean(),
                        is_api: zod.boolean(),
                    }),
                    zod.null(),
                ]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
            })
        ),
        topics: zod.array(
            zod.object({
                id: zod.uuid(),
                title: zod.string(),
                summary: zod.union([zod.string(), zod.null()]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
                decisions: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                    })
                ),
                todos: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        person: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                name: zod.string(),
                                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                                company: zod.union([zod.string(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                            }),
                            zod.null(),
                        ]),
                        due_date: zod.union([zod.iso.date(), zod.null()]),
                        is_done: zod.boolean(),
                        done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        done_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                first_name: zod.string(),
                                last_name: zod.string(),
                                display_name: zod.string(),
                                email: zod.union([zod.email(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                                is_disabled: zod.boolean(),
                                is_deleted: zod.boolean(),
                                is_api: zod.boolean(),
                            }),
                            zod.null(),
                        ]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                        external_link: zod.union([
                            zod.object({
                                provider: zod.string(),
                                provider_name: zod.union([zod.string(), zod.null()]),
                                url: zod.string(),
                            }),
                            zod.null(),
                        ]),
                        permissions: zod.object({
                            can_mark_done: zod.boolean(),
                        }),
                    })
                ),
                events: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        date: zod.iso.date(),
                        time: zod.union([zod.iso.time({}), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                    })
                ),
            })
        ),
    }),
});

export type PublicRecap = zod.input<typeof PublicRecap>;
export type PublicRecapOutput = zod.output<typeof PublicRecap>;

export const SharedRecap = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    published_version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
    }),
    version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
        title: zod.union([zod.string(), zod.null()]),
        summary: zod.union([zod.string(), zod.null()]),
        persons: zod.array(
            zod.object({
                id: zod.uuid(),
                name: zod.string(),
                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                company: zod.union([zod.string(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                email: zod.union([zod.string(), zod.null()]),
                job_title: zod.union([zod.string(), zod.null()]),
                is_participant: zod.boolean(),
                user: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        first_name: zod.string(),
                        last_name: zod.string(),
                        display_name: zod.string(),
                        email: zod.union([zod.email(), zod.null()]),
                        avatar_url: zod.union([zod.string(), zod.null()]),
                        is_disabled: zod.boolean(),
                        is_deleted: zod.boolean(),
                        is_api: zod.boolean(),
                    }),
                    zod.null(),
                ]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
            })
        ),
        topics: zod.array(
            zod.object({
                id: zod.uuid(),
                title: zod.string(),
                summary: zod.union([zod.string(), zod.null()]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
                decisions: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                    })
                ),
                todos: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        person: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                name: zod.string(),
                                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                                company: zod.union([zod.string(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                            }),
                            zod.null(),
                        ]),
                        due_date: zod.union([zod.iso.date(), zod.null()]),
                        is_done: zod.boolean(),
                        done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        done_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                first_name: zod.string(),
                                last_name: zod.string(),
                                display_name: zod.string(),
                                email: zod.union([zod.email(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                                is_disabled: zod.boolean(),
                                is_deleted: zod.boolean(),
                                is_api: zod.boolean(),
                            }),
                            zod.null(),
                        ]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                        external_link: zod.union([
                            zod.object({
                                provider: zod.string(),
                                provider_name: zod.union([zod.string(), zod.null()]),
                                url: zod.string(),
                            }),
                            zod.null(),
                        ]),
                        permissions: zod.object({
                            can_mark_done: zod.boolean(),
                        }),
                    })
                ),
                events: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        date: zod.iso.date(),
                        time: zod.union([zod.iso.time({}), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                    })
                ),
            })
        ),
    }),
    workspace: zod.object({
        name: zod.string(),
        color_hue: zod.union([zod.int(), zod.null()]),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
    client: zod.union([
        zod.object({
            name: zod.string(),
            logo_url: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    project_name: zod.union([zod.string(), zod.null()]),
});

export type SharedRecap = zod.input<typeof SharedRecap>;
export type SharedRecapOutput = zod.output<typeof SharedRecap>;

export const AuthorizationRequest = zod.object({
    client_id: zod.string(),
    redirect_uri: zod.string(),
    response_type: zod.string(),
    code_challenge: zod.string(),
    code_challenge_method: zod.string(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    scope: zod.union([zod.string(), zod.null()]).optional(),
    resource: zod.union([zod.string(), zod.null()]).optional(),
});

export type AuthorizationRequest = zod.input<typeof AuthorizationRequest>;
export type AuthorizationRequestOutput = zod.output<typeof AuthorizationRequest>;

export const AuthorizationPreview = zod.object({
    client_name: zod.string(),
    redirect_host: zod.string(),
});

export type AuthorizationPreview = zod.input<typeof AuthorizationPreview>;
export type AuthorizationPreviewOutput = zod.output<typeof AuthorizationPreview>;

export const AuthorizationRedirect = zod.object({
    redirect_url: zod.string(),
});

export type AuthorizationRedirect = zod.input<typeof AuthorizationRedirect>;
export type AuthorizationRedirectOutput = zod.output<typeof AuthorizationRedirect>;

export const AuthorizationDecision = zod.object({
    client_id: zod.string(),
    redirect_uri: zod.string(),
    response_type: zod.string(),
    code_challenge: zod.string(),
    code_challenge_method: zod.string(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    scope: zod.union([zod.string(), zod.null()]).optional(),
    resource: zod.union([zod.string(), zod.null()]).optional(),
    workspace_id: zod.uuid(),
    is_read_only: zod.boolean(),
    is_allowed: zod.boolean(),
});

export type AuthorizationDecision = zod.input<typeof AuthorizationDecision>;
export type AuthorizationDecisionOutput = zod.output<typeof AuthorizationDecision>;

export const issueReportInputDescriptionMax = 5000;

export const issueReportInputErrorLogDefault = ``;
export const issueReportInputErrorLogMax = 20000;

export const issueReportInputPageUrlMax = 2000;

export const IssueReportInput = zod.object({
    description: zod.string().min(1).max(issueReportInputDescriptionMax),
    error_log: zod.string().max(issueReportInputErrorLogMax).default(issueReportInputErrorLogDefault),
    page_url: zod.string().min(1).max(issueReportInputPageUrlMax),
    workspace_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type IssueReportInput = zod.input<typeof IssueReportInput>;
export type IssueReportInputOutput = zod.output<typeof IssueReportInput>;

export const MembershipRole = zod.enum(['owner', 'member']);

export type MembershipRole = zod.input<typeof MembershipRole>;
export type MembershipRoleOutput = zod.output<typeof MembershipRole>;

export const MembershipPermissions = zod.object({
    can_remove: zod.boolean(),
    can_transfer: zod.boolean(),
    can_disable: zod.boolean(),
    can_enable: zod.boolean(),
});

export type MembershipPermissions = zod.input<typeof MembershipPermissions>;
export type MembershipPermissionsOutput = zod.output<typeof MembershipPermissions>;

export const Membership = zod.object({
    id: zod.uuid(),
    user: zod.object({
        id: zod.uuid(),
        first_name: zod.string(),
        last_name: zod.string(),
        display_name: zod.string(),
        email: zod.union([zod.email(), zod.null()]),
        avatar_url: zod.union([zod.string(), zod.null()]),
        is_disabled: zod.boolean(),
        is_deleted: zod.boolean(),
        is_api: zod.boolean(),
    }),
    role: zod.enum(['owner', 'member']),
    disabled_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    connection_id: zod.union([zod.uuid(), zod.null()]),
    permissions: zod.object({
        can_remove: zod.boolean(),
        can_transfer: zod.boolean(),
        can_disable: zod.boolean(),
        can_enable: zod.boolean(),
    }),
});

export type Membership = zod.input<typeof Membership>;
export type MembershipOutput = zod.output<typeof Membership>;

export const MembershipUpdate = zod.object({
    role: zod.union([zod.literal('owner'), zod.null()]).optional(),
    is_disabled: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type MembershipUpdate = zod.input<typeof MembershipUpdate>;
export type MembershipUpdateOutput = zod.output<typeof MembershipUpdate>;

export const InvitationPermissions = zod.object({
    can_send: zod.boolean(),
    can_delete: zod.boolean(),
});

export type InvitationPermissions = zod.input<typeof InvitationPermissions>;
export type InvitationPermissionsOutput = zod.output<typeof InvitationPermissions>;

export const Invitation = zod.object({
    id: zod.uuid(),
    email: zod.union([zod.email(), zod.null()]),
    created_at: zod.iso.datetime({ offset: true }),
    token: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_send: zod.boolean(),
        can_delete: zod.boolean(),
    }),
});

export type Invitation = zod.input<typeof Invitation>;
export type InvitationOutput = zod.output<typeof Invitation>;

export const InvitationInput = zod.object({
    email: zod.union([zod.email(), zod.null()]).optional(),
});

export type InvitationInput = zod.input<typeof InvitationInput>;
export type InvitationInputOutput = zod.output<typeof InvitationInput>;

export const ClientSummary = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
});

export type ClientSummary = zod.input<typeof ClientSummary>;
export type ClientSummaryOutput = zod.output<typeof ClientSummary>;

export const ProjectPermissions = zod.object({
    can_delete: zod.boolean(),
    can_manage_email_address: zod.boolean(),
});

export type ProjectPermissions = zod.input<typeof ProjectPermissions>;
export type ProjectPermissionsOutput = zod.output<typeof ProjectPermissions>;

export const Project = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    recap_count: zod.int(),
    waiting_source_count: zod.int(),
    last_recap_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    public_token: zod.union([zod.string(), zod.null()]),
    logo_url: zod.union([zod.string(), zod.null()]),
    drafting_weekday: zod.union([zod.int(), zod.null()]),
    has_changes: zod.boolean(),
    is_starred: zod.boolean(),
    team_scope: zod.enum(['workspace', 'client', 'chosen']),
    members: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    team: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    is_on_team: zod.boolean(),
    client_access: zod.enum(['all', 'chosen']),
    email_address: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_delete: zod.boolean(),
        can_manage_email_address: zod.boolean(),
    }),
});

export type Project = zod.input<typeof Project>;
export type ProjectOutput = zod.output<typeof Project>;

export const ClientExternalCompany = zod.object({
    id: zod.uuid(),
    provider: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    name: zod.string(),
    url: zod.string(),
});

export type ClientExternalCompany = zod.input<typeof ClientExternalCompany>;
export type ClientExternalCompanyOutput = zod.output<typeof ClientExternalCompany>;

export const ClientPermissions = zod.object({
    can_delete: zod.boolean(),
    can_manage_email_address: zod.boolean(),
});

export type ClientPermissions = zod.input<typeof ClientPermissions>;
export type ClientPermissionsOutput = zod.output<typeof ClientPermissions>;

export const Client = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    address: zod.string(),
    description: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
    projects: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            recap_count: zod.int(),
            waiting_source_count: zod.int(),
            last_recap_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            public_token: zod.union([zod.string(), zod.null()]),
            logo_url: zod.union([zod.string(), zod.null()]),
            drafting_weekday: zod.union([zod.int(), zod.null()]),
            has_changes: zod.boolean(),
            is_starred: zod.boolean(),
            team_scope: zod.enum(['workspace', 'client', 'chosen']),
            members: zod.array(
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                })
            ),
            team: zod.array(
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                })
            ),
            is_on_team: zod.boolean(),
            client_access: zod.enum(['all', 'chosen']),
            email_address: zod.union([zod.string(), zod.null()]),
            permissions: zod.object({
                can_delete: zod.boolean(),
                can_manage_email_address: zod.boolean(),
            }),
        })
    ),
    recap_count: zod.int(),
    source_count: zod.int(),
    unfiled_recap_count: zod.int(),
    unfiled_source_count: zod.int(),
    employee_count: zod.int(),
    invited_employee_count: zod.int(),
    drafting_weekday: zod.union([zod.int(), zod.null()]),
    has_changes: zod.boolean(),
    is_starred: zod.boolean(),
    team_scope: zod.enum(['workspace', 'chosen']),
    members: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    team: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    is_on_team: zod.boolean(),
    email_address: zod.union([zod.string(), zod.null()]),
    external_companies: zod.array(
        zod.object({
            id: zod.uuid(),
            provider: zod.string(),
            provider_name: zod.union([zod.string(), zod.null()]),
            name: zod.string(),
            url: zod.string(),
        })
    ),
    permissions: zod.object({
        can_delete: zod.boolean(),
        can_manage_email_address: zod.boolean(),
    }),
});

export type Client = zod.input<typeof Client>;
export type ClientOutput = zod.output<typeof Client>;

export const clientInputNameMax = 200;

export const clientInputSlugMax = 40;

export const clientInputSlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const clientInputDraftingWeekdayOneMin = 0;
export const clientInputDraftingWeekdayOneMax = 6;

export const ClientInput = zod.object({
    name: zod.string().min(1).max(clientInputNameMax),
    slug: zod.string().max(clientInputSlugMax).regex(clientInputSlugRegExp),
    address: zod.string(),
    description: zod.string(),
    drafting_weekday: zod
        .union([zod.int().min(clientInputDraftingWeekdayOneMin).max(clientInputDraftingWeekdayOneMax), zod.null()])
        .optional(),
});

export type ClientInput = zod.input<typeof ClientInput>;
export type ClientInputOutput = zod.output<typeof ClientInput>;

export const StarUpdate = zod.object({
    is_starred: zod.boolean(),
});

export type StarUpdate = zod.input<typeof StarUpdate>;
export type StarUpdateOutput = zod.output<typeof StarUpdate>;

export const ClientTeamUpdate = zod.object({
    team_scope: zod.enum(['workspace', 'chosen']),
    member_ids: zod.array(zod.uuid()),
});

export type ClientTeamUpdate = zod.input<typeof ClientTeamUpdate>;
export type ClientTeamUpdateOutput = zod.output<typeof ClientTeamUpdate>;

export const projectCreateNameMax = 200;

export const projectCreateSlugMax = 40;

export const projectCreateSlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const projectCreateDraftingWeekdayOneMin = 0;
export const projectCreateDraftingWeekdayOneMax = 6;

export const ProjectCreate = zod.object({
    name: zod.string().min(1).max(projectCreateNameMax),
    slug: zod.string().max(projectCreateSlugMax).regex(projectCreateSlugRegExp),
    drafting_weekday: zod
        .union([zod.int().min(projectCreateDraftingWeekdayOneMin).max(projectCreateDraftingWeekdayOneMax), zod.null()])
        .optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type ProjectCreate = zod.input<typeof ProjectCreate>;
export type ProjectCreateOutput = zod.output<typeof ProjectCreate>;

export const ProjectClientUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
});

export type ProjectClientUpdate = zod.input<typeof ProjectClientUpdate>;
export type ProjectClientUpdateOutput = zod.output<typeof ProjectClientUpdate>;

export const projectInputNameMax = 200;

export const projectInputSlugMax = 40;

export const projectInputSlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const projectInputDraftingWeekdayOneMin = 0;
export const projectInputDraftingWeekdayOneMax = 6;

export const ProjectInput = zod.object({
    name: zod.string().min(1).max(projectInputNameMax),
    slug: zod.string().max(projectInputSlugMax).regex(projectInputSlugRegExp),
    drafting_weekday: zod
        .union([zod.int().min(projectInputDraftingWeekdayOneMin).max(projectInputDraftingWeekdayOneMax), zod.null()])
        .optional(),
});

export type ProjectInput = zod.input<typeof ProjectInput>;
export type ProjectInputOutput = zod.output<typeof ProjectInput>;

export const ProjectTeamUpdate = zod.object({
    team_scope: zod.enum(['workspace', 'client', 'chosen']),
    member_ids: zod.array(zod.uuid()),
});

export type ProjectTeamUpdate = zod.input<typeof ProjectTeamUpdate>;
export type ProjectTeamUpdateOutput = zod.output<typeof ProjectTeamUpdate>;

export const ProjectSummary = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
});

export type ProjectSummary = zod.input<typeof ProjectSummary>;
export type ProjectSummaryOutput = zod.output<typeof ProjectSummary>;

export const EmployeePermissions = zod.object({
    can_remove: zod.boolean(),
    can_disable: zod.boolean(),
    can_enable: zod.boolean(),
});

export type EmployeePermissions = zod.input<typeof EmployeePermissions>;
export type EmployeePermissionsOutput = zod.output<typeof EmployeePermissions>;

export const Employee = zod.object({
    id: zod.uuid(),
    user: zod.object({
        id: zod.uuid(),
        first_name: zod.string(),
        last_name: zod.string(),
        display_name: zod.string(),
        email: zod.union([zod.email(), zod.null()]),
        avatar_url: zod.union([zod.string(), zod.null()]),
        is_disabled: zod.boolean(),
        is_deleted: zod.boolean(),
        is_api: zod.boolean(),
    }),
    created_at: zod.iso.datetime({ offset: true }),
    projects: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        })
    ),
    disabled_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    permissions: zod.object({
        can_remove: zod.boolean(),
        can_disable: zod.boolean(),
        can_enable: zod.boolean(),
    }),
});

export type Employee = zod.input<typeof Employee>;
export type EmployeeOutput = zod.output<typeof Employee>;

export const ProjectEmployeesUpdate = zod.object({
    client_access: zod.enum(['all', 'chosen']),
    employee_ids: zod.array(zod.uuid()),
});

export type ProjectEmployeesUpdate = zod.input<typeof ProjectEmployeesUpdate>;
export type ProjectEmployeesUpdateOutput = zod.output<typeof ProjectEmployeesUpdate>;

export const EmployeeUpdate = zod.object({
    is_disabled: zod.boolean(),
});

export type EmployeeUpdate = zod.input<typeof EmployeeUpdate>;
export type EmployeeUpdateOutput = zod.output<typeof EmployeeUpdate>;

export const EmployeeInvitationPermissions = zod.object({
    can_send: zod.boolean(),
    can_delete: zod.boolean(),
});

export type EmployeeInvitationPermissions = zod.input<typeof EmployeeInvitationPermissions>;
export type EmployeeInvitationPermissionsOutput = zod.output<typeof EmployeeInvitationPermissions>;

export const EmployeeInvitation = zod.object({
    id: zod.uuid(),
    email: zod.union([zod.email(), zod.null()]),
    created_at: zod.iso.datetime({ offset: true }),
    token: zod.string(),
    projects: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        })
    ),
    name: zod.string(),
    job_title: zod.string(),
    permissions: zod.object({
        can_send: zod.boolean(),
        can_delete: zod.boolean(),
    }),
});

export type EmployeeInvitation = zod.input<typeof EmployeeInvitation>;
export type EmployeeInvitationOutput = zod.output<typeof EmployeeInvitation>;

export const employeeInvitationInputProjectIdsDefault = [];
export const employeeInvitationInputNameDefault = ``;
export const employeeInvitationInputNameMax = 255;

export const employeeInvitationInputJobTitleDefault = ``;
export const employeeInvitationInputJobTitleMax = 255;

export const EmployeeInvitationInput = zod.object({
    email: zod.union([zod.email(), zod.null()]),
    project_ids: zod.array(zod.uuid()).default(employeeInvitationInputProjectIdsDefault),
    name: zod.string().max(employeeInvitationInputNameMax).default(employeeInvitationInputNameDefault),
    job_title: zod.string().max(employeeInvitationInputJobTitleMax).default(employeeInvitationInputJobTitleDefault),
});

export type EmployeeInvitationInput = zod.input<typeof EmployeeInvitationInput>;
export type EmployeeInvitationInputOutput = zod.output<typeof EmployeeInvitationInput>;

export const SourceFilters = zod.object({
    search: zod.union([zod.string(), zod.null()]).optional(),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]).optional(),
    is_processing: zod.union([zod.boolean(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    has_client: zod.union([zod.boolean(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    has_project: zod.union([zod.boolean(), zod.null()]).optional(),
    is_waiting: zod.union([zod.boolean(), zod.null()]).optional(),
    is_filed: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type SourceFilters = zod.input<typeof SourceFilters>;
export type SourceFiltersOutput = zod.output<typeof SourceFilters>;

export const Email = zod.object({
    id: zod.uuid(),
    from_address: zod.union([zod.string(), zod.null()]),
    from_name: zod.union([zod.string(), zod.null()]),
    to_addresses: zod.array(zod.string()),
    cc_addresses: zod.array(zod.string()),
    subject: zod.union([zod.string(), zod.null()]),
    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
});

export type Email = zod.input<typeof Email>;
export type EmailOutput = zod.output<typeof Email>;

export const Facet = zod.enum([
    'email',
    'meeting',
    'document',
    'task',
    'conversation',
    'calendar',
    'events',
    'todos',
    'recaps',
    'clients',
]);

export type Facet = zod.input<typeof Facet>;
export type FacetOutput = zod.output<typeof Facet>;

export const FeedSummary = zod.object({
    id: zod.uuid(),
    facet: zod.enum([
        'email',
        'meeting',
        'document',
        'task',
        'conversation',
        'calendar',
        'events',
        'todos',
        'recaps',
        'clients',
    ]),
    connection_id: zod.uuid(),
    connection_name: zod.string(),
    connection_user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
});

export type FeedSummary = zod.input<typeof FeedSummary>;
export type FeedSummaryOutput = zod.output<typeof FeedSummary>;

export const SourceKind = zod.enum([
    'upload',
    'email',
    'mobile',
    'document',
    'link',
    'ticket',
    'calendar_event',
    'meeting',
    'conversation',
]);

export type SourceKind = zod.input<typeof SourceKind>;
export type SourceKindOutput = zod.output<typeof SourceKind>;

export const SourceFile = zod.object({
    id: zod.uuid(),
    file_name: zod.string(),
    mime_type: zod.string(),
    url: zod.string(),
    page_count: zod.int(),
    size: zod.int(),
    is_email_body: zod.boolean(),
});

export type SourceFile = zod.input<typeof SourceFile>;
export type SourceFileOutput = zod.output<typeof SourceFile>;

export const SourcePermissions = zod.object({
    can_process: zod.boolean(),
    can_take_update: zod.boolean(),
    can_delete: zod.boolean(),
});

export type SourcePermissions = zod.input<typeof SourcePermissions>;
export type SourcePermissionsOutput = zod.output<typeof SourcePermissions>;

export const SourceListEntry = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
    files: zod.array(
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            mime_type: zod.string(),
            url: zod.string(),
            page_count: zod.int(),
            size: zod.int(),
            is_email_body: zod.boolean(),
        })
    ),
    feed: zod.union([
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            connection_id: zod.uuid(),
            connection_name: zod.string(),
            connection_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    provider: zod.union([zod.string(), zod.null()]),
    provider_name: zod.union([zod.string(), zod.null()]),
    inbound_email: zod.union([zod.string(), zod.null()]),
    extraction_status: zod.enum(['processing', 'done', 'failed']),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    external_url: zod.union([zod.string(), zod.null()]),
    external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    has_update: zod.boolean(),
    permissions: zod.object({
        can_process: zod.boolean(),
        can_take_update: zod.boolean(),
        can_delete: zod.boolean(),
    }),
    is_new: zod.boolean(),
});

export type SourceListEntry = zod.input<typeof SourceListEntry>;
export type SourceListEntryOutput = zod.output<typeof SourceListEntry>;

export const PagedSourceListEntry = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.enum(['processing', 'done', 'failed']),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            external_url: zod.union([zod.string(), zod.null()]),
            external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            has_update: zod.boolean(),
            permissions: zod.object({
                can_process: zod.boolean(),
                can_take_update: zod.boolean(),
                can_delete: zod.boolean(),
            }),
            is_new: zod.boolean(),
        })
    ),
    count: zod.int(),
});

export type PagedSourceListEntry = zod.input<typeof PagedSourceListEntry>;
export type PagedSourceListEntryOutput = zod.output<typeof PagedSourceListEntry>;

export const SourceFileDetail = zod.object({
    id: zod.uuid(),
    file_name: zod.string(),
    mime_type: zod.string(),
    url: zod.string(),
    page_count: zod.int(),
    size: zod.int(),
    is_email_body: zod.boolean(),
    content: zod.union([zod.string(), zod.null()]),
});

export type SourceFileDetail = zod.input<typeof SourceFileDetail>;
export type SourceFileDetailOutput = zod.output<typeof SourceFileDetail>;

export const Source = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
    files: zod.array(
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            mime_type: zod.string(),
            url: zod.string(),
            page_count: zod.int(),
            size: zod.int(),
            is_email_body: zod.boolean(),
            content: zod.union([zod.string(), zod.null()]),
        })
    ),
    feed: zod.union([
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            connection_id: zod.uuid(),
            connection_name: zod.string(),
            connection_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    provider: zod.union([zod.string(), zod.null()]),
    provider_name: zod.union([zod.string(), zod.null()]),
    inbound_email: zod.union([zod.string(), zod.null()]),
    extraction_status: zod.enum(['processing', 'done', 'failed']),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    external_url: zod.union([zod.string(), zod.null()]),
    external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    has_update: zod.boolean(),
    permissions: zod.object({
        can_process: zod.boolean(),
        can_take_update: zod.boolean(),
        can_delete: zod.boolean(),
    }),
    recaps: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
        })
    ),
});

export type Source = zod.input<typeof Source>;
export type SourceOutput = zod.output<typeof Source>;

export const SourcesUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
    source_ids: zod.array(zod.uuid()),
});

export type SourcesUpdate = zod.input<typeof SourcesUpdate>;
export type SourcesUpdateOutput = zod.output<typeof SourcesUpdate>;

export const SourceFromLinkResult = zod.object({
    source: zod.object({
        id: zod.uuid(),
        kind: zod.enum([
            'upload',
            'email',
            'mobile',
            'document',
            'link',
            'ticket',
            'calendar_event',
            'meeting',
            'conversation',
        ]),
        received_at: zod.iso.datetime({ offset: true }),
        email: zod.union([
            zod.object({
                id: zod.uuid(),
                from_address: zod.union([zod.string(), zod.null()]),
                from_name: zod.union([zod.string(), zod.null()]),
                to_addresses: zod.array(zod.string()),
                cc_addresses: zod.array(zod.string()),
                subject: zod.union([zod.string(), zod.null()]),
                received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            }),
            zod.null(),
        ]),
        files: zod.array(
            zod.object({
                id: zod.uuid(),
                file_name: zod.string(),
                mime_type: zod.string(),
                url: zod.string(),
                page_count: zod.int(),
                size: zod.int(),
                is_email_body: zod.boolean(),
                content: zod.union([zod.string(), zod.null()]),
            })
        ),
        feed: zod.union([
            zod.object({
                id: zod.uuid(),
                facet: zod.enum([
                    'email',
                    'meeting',
                    'document',
                    'task',
                    'conversation',
                    'calendar',
                    'events',
                    'todos',
                    'recaps',
                    'clients',
                ]),
                connection_id: zod.uuid(),
                connection_name: zod.string(),
                connection_user: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        first_name: zod.string(),
                        last_name: zod.string(),
                        display_name: zod.string(),
                        email: zod.union([zod.email(), zod.null()]),
                        avatar_url: zod.union([zod.string(), zod.null()]),
                        is_disabled: zod.boolean(),
                        is_deleted: zod.boolean(),
                        is_api: zod.boolean(),
                    }),
                    zod.null(),
                ]),
            }),
            zod.null(),
        ]),
        provider: zod.union([zod.string(), zod.null()]),
        provider_name: zod.union([zod.string(), zod.null()]),
        inbound_email: zod.union([zod.string(), zod.null()]),
        extraction_status: zod.enum(['processing', 'done', 'failed']),
        client: zod.union([
            zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
            }),
            zod.null(),
        ]),
        project: zod.union([
            zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
                client: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        slug: zod.string(),
                        name: zod.string(),
                    }),
                    zod.null(),
                ]),
            }),
            zod.null(),
        ]),
        external_url: zod.union([zod.string(), zod.null()]),
        external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        has_update: zod.boolean(),
        permissions: zod.object({
            can_process: zod.boolean(),
            can_take_update: zod.boolean(),
            can_delete: zod.boolean(),
        }),
        recaps: zod.array(
            zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            })
        ),
    }),
    is_new: zod.boolean(),
});

export type SourceFromLinkResult = zod.input<typeof SourceFromLinkResult>;
export type SourceFromLinkResultOutput = zod.output<typeof SourceFromLinkResult>;

export const sourceFromLinkUrlMax = 2000;

export const SourceFromLink = zod.object({
    url: zod.string().min(1).max(sourceFromLinkUrlMax),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type SourceFromLink = zod.input<typeof SourceFromLink>;
export type SourceFromLinkOutput = zod.output<typeof SourceFromLink>;

export const sourcesFromPickExternalIdsMax = 20;

export const SourcesFromPick = zod.object({
    connection_id: zod.uuid(),
    external_ids: zod.array(zod.string()).min(1).max(sourcesFromPickExternalIdsMax),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type SourcesFromPick = zod.input<typeof SourcesFromPick>;
export type SourcesFromPickOutput = zod.output<typeof SourcesFromPick>;

export const SourceUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type SourceUpdate = zod.input<typeof SourceUpdate>;
export type SourceUpdateOutput = zod.output<typeof SourceUpdate>;

export const RecapFilters = zod.object({
    search: zod.union([zod.string(), zod.null()]).optional(),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]).optional(),
    is_published: zod.union([zod.boolean(), zod.null()]).optional(),
    has_draft: zod.union([zod.boolean(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    has_client: zod.union([zod.boolean(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    has_project: zod.union([zod.boolean(), zod.null()]).optional(),
    is_waiting_for_acknowledgement: zod.union([zod.boolean(), zod.null()]).optional(),
    is_draft: zod.union([zod.boolean(), zod.null()]).optional(),
    source_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type RecapFilters = zod.input<typeof RecapFilters>;
export type RecapFiltersOutput = zod.output<typeof RecapFilters>;

export const SourceSummary = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
});

export type SourceSummary = zod.input<typeof SourceSummary>;
export type SourceSummaryOutput = zod.output<typeof SourceSummary>;

export const RecapDigest = zod.object({
    summary: zod.union([zod.string(), zod.null()]),
    person_count: zod.int(),
    topic_count: zod.int(),
    decision_count: zod.int(),
    todo_count: zod.int(),
    event_count: zod.int(),
});

export type RecapDigest = zod.input<typeof RecapDigest>;
export type RecapDigestOutput = zod.output<typeof RecapDigest>;

export const RecapPermissions = zod.object({
    can_process: zod.boolean(),
    can_edit: zod.boolean(),
    can_publish: zod.boolean(),
    can_discard_draft: zod.boolean(),
    can_change_acknowledgers: zod.boolean(),
    can_create_public_link: zod.boolean(),
    can_delete: zod.boolean(),
});

export type RecapPermissions = zod.input<typeof RecapPermissions>;
export type RecapPermissionsOutput = zod.output<typeof RecapPermissions>;

export const RecapListEntry = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
    title: zod.union([zod.string(), zod.null()]),
    summary: zod.union([zod.string(), zod.null()]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    published_version: zod.union([
        zod.object({
            number: zod.int(),
            created_at: zod.iso.datetime({ offset: true }),
        }),
        zod.null(),
    ]),
    has_draft: zod.boolean(),
    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    acknowledger_count: zod.int(),
    acknowledged_count: zod.int(),
    sources: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
        })
    ),
    digest: zod.object({
        summary: zod.union([zod.string(), zod.null()]),
        person_count: zod.int(),
        topic_count: zod.int(),
        decision_count: zod.int(),
        todo_count: zod.int(),
        event_count: zod.int(),
    }),
    created_at: zod.iso.datetime({ offset: true }),
    permissions: zod.object({
        can_process: zod.boolean(),
        can_edit: zod.boolean(),
        can_publish: zod.boolean(),
        can_discard_draft: zod.boolean(),
        can_change_acknowledgers: zod.boolean(),
        can_create_public_link: zod.boolean(),
        can_delete: zod.boolean(),
    }),
    has_changes: zod.boolean(),
});

export type RecapListEntry = zod.input<typeof RecapListEntry>;
export type RecapListEntryOutput = zod.output<typeof RecapListEntry>;

export const PagedRecapListEntry = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            title: zod.union([zod.string(), zod.null()]),
            summary: zod.union([zod.string(), zod.null()]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.union([
                zod.object({
                    number: zod.int(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            has_draft: zod.boolean(),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            acknowledger_count: zod.int(),
            acknowledged_count: zod.int(),
            sources: zod.array(
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            digest: zod.object({
                summary: zod.union([zod.string(), zod.null()]),
                person_count: zod.int(),
                topic_count: zod.int(),
                decision_count: zod.int(),
                todo_count: zod.int(),
                event_count: zod.int(),
            }),
            created_at: zod.iso.datetime({ offset: true }),
            permissions: zod.object({
                can_process: zod.boolean(),
                can_edit: zod.boolean(),
                can_publish: zod.boolean(),
                can_discard_draft: zod.boolean(),
                can_change_acknowledgers: zod.boolean(),
                can_create_public_link: zod.boolean(),
                can_delete: zod.boolean(),
            }),
            has_changes: zod.boolean(),
        })
    ),
    count: zod.int(),
});

export type PagedRecapListEntry = zod.input<typeof PagedRecapListEntry>;
export type PagedRecapListEntryOutput = zod.output<typeof PagedRecapListEntry>;

export const EmployeeInvitationSummary = zod.object({
    id: zod.uuid(),
    email: zod.email(),
    name: zod.string(),
});

export type EmployeeInvitationSummary = zod.input<typeof EmployeeInvitationSummary>;
export type EmployeeInvitationSummaryOutput = zod.output<typeof EmployeeInvitationSummary>;

export const PersonCandidate = zod.object({
    user: zod.object({
        id: zod.uuid(),
        first_name: zod.string(),
        last_name: zod.string(),
        display_name: zod.string(),
        email: zod.union([zod.email(), zod.null()]),
        avatar_url: zod.union([zod.string(), zod.null()]),
        is_disabled: zod.boolean(),
        is_deleted: zod.boolean(),
        is_api: zod.boolean(),
    }),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
});

export type PersonCandidate = zod.input<typeof PersonCandidate>;
export type PersonCandidateOutput = zod.output<typeof PersonCandidate>;

export const RecapSource = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
    files: zod.array(
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            mime_type: zod.string(),
            url: zod.string(),
            page_count: zod.int(),
            size: zod.int(),
            is_email_body: zod.boolean(),
        })
    ),
});

export type RecapSource = zod.input<typeof RecapSource>;
export type RecapSourceOutput = zod.output<typeof RecapSource>;

export const RecapAcknowledger = zod.object({
    user: zod.object({
        id: zod.uuid(),
        first_name: zod.string(),
        last_name: zod.string(),
        display_name: zod.string(),
        email: zod.union([zod.email(), zod.null()]),
        avatar_url: zod.union([zod.string(), zod.null()]),
        is_disabled: zod.boolean(),
        is_deleted: zod.boolean(),
        is_api: zod.boolean(),
    }),
    has_acknowledged: zod.boolean(),
    acknowledged_version_number: zod.union([zod.int(), zod.null()]),
    acknowledged_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
});

export type RecapAcknowledger = zod.input<typeof RecapAcknowledger>;
export type RecapAcknowledgerOutput = zod.output<typeof RecapAcknowledger>;

export const Recap = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
    title: zod.union([zod.string(), zod.null()]),
    summary: zod.union([zod.string(), zod.null()]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    published_version: zod.union([
        zod.object({
            number: zod.int(),
            created_at: zod.iso.datetime({ offset: true }),
        }),
        zod.null(),
    ]),
    has_draft: zod.boolean(),
    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    acknowledger_count: zod.int(),
    acknowledged_count: zod.int(),
    sources: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
        })
    ),
    digest: zod.object({
        summary: zod.union([zod.string(), zod.null()]),
        person_count: zod.int(),
        topic_count: zod.int(),
        decision_count: zod.int(),
        todo_count: zod.int(),
        event_count: zod.int(),
    }),
    created_at: zod.iso.datetime({ offset: true }),
    permissions: zod.object({
        can_process: zod.boolean(),
        can_edit: zod.boolean(),
        can_publish: zod.boolean(),
        can_discard_draft: zod.boolean(),
        can_change_acknowledgers: zod.boolean(),
        can_create_public_link: zod.boolean(),
        can_delete: zod.boolean(),
    }),
    persons: zod.array(
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            email: zod.union([zod.string(), zod.null()]),
            job_title: zod.union([zod.string(), zod.null()]),
            is_participant: zod.boolean(),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
        })
    ),
    topics: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            summary: zod.union([zod.string(), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            decisions: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                })
            ),
            todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    is_done: zod.boolean(),
                    done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    done_by: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                    external_link: zod.union([
                        zod.object({
                            provider: zod.string(),
                            provider_name: zod.union([zod.string(), zod.null()]),
                            url: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                })
            ),
        })
    ),
    acknowledgers: zod.array(
        zod.object({
            user: zod.object({
                id: zod.uuid(),
                first_name: zod.string(),
                last_name: zod.string(),
                display_name: zod.string(),
                email: zod.union([zod.email(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                is_disabled: zod.boolean(),
                is_deleted: zod.boolean(),
                is_api: zod.boolean(),
            }),
            has_acknowledged: zod.boolean(),
            acknowledged_version_number: zod.union([zod.int(), zod.null()]),
            acknowledged_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    askable_users: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    askable_invitations: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    is_muted: zod.boolean(),
    link_candidates: zod.array(
        zod.object({
            user: zod.object({
                id: zod.uuid(),
                first_name: zod.string(),
                last_name: zod.string(),
                display_name: zod.string(),
                email: zod.union([zod.email(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                is_disabled: zod.boolean(),
                is_deleted: zod.boolean(),
                is_api: zod.boolean(),
            }),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        })
    ),
    public_token: zod.union([zod.string(), zod.null()]),
});

export type Recap = zod.input<typeof Recap>;
export type RecapOutput = zod.output<typeof Recap>;

export const recapCreateTitleOneMax = 500;

export const RecapCreate = zod.object({
    source_file_ids: zod.array(zod.uuid()),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
    title: zod.union([zod.string().min(1).max(recapCreateTitleOneMax), zod.null()]).optional(),
    summary: zod.union([zod.string().min(1), zod.null()]).optional(),
});

export type RecapCreate = zod.input<typeof RecapCreate>;
export type RecapCreateOutput = zod.output<typeof RecapCreate>;

export const recapUpdateTitleOneMax = 500;

export const RecapUpdate = zod.object({
    title: zod.union([zod.string().min(1).max(recapUpdateTitleOneMax), zod.null()]),
    summary: zod.union([zod.string().min(1), zod.null()]),
});

export type RecapUpdate = zod.input<typeof RecapUpdate>;
export type RecapUpdateOutput = zod.output<typeof RecapUpdate>;

export const RecapProjectUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type RecapProjectUpdate = zod.input<typeof RecapProjectUpdate>;
export type RecapProjectUpdateOutput = zod.output<typeof RecapProjectUpdate>;

export const RecapSourceFilesUpdate = zod.object({
    source_file_ids: zod.array(zod.uuid()),
});

export type RecapSourceFilesUpdate = zod.input<typeof RecapSourceFilesUpdate>;
export type RecapSourceFilesUpdateOutput = zod.output<typeof RecapSourceFilesUpdate>;

export const personInputNameMax = 255;

export const personInputCompanyOneMax = 255;

export const personInputJobTitleOneMax = 255;

export const PersonInput = zod.object({
    name: zod.string().min(1).max(personInputNameMax),
    email: zod.union([zod.email(), zod.null()]),
    company: zod.union([zod.string().min(1).max(personInputCompanyOneMax), zod.null()]),
    job_title: zod.union([zod.string().min(1).max(personInputJobTitleOneMax), zod.null()]),
    is_participant: zod.boolean(),
    user_id: zod.union([zod.uuid(), zod.null()]),
});

export type PersonInput = zod.input<typeof PersonInput>;
export type PersonInputOutput = zod.output<typeof PersonInput>;

export const topicInputTitleMax = 500;

export const TopicInput = zod.object({
    title: zod.string().min(1).max(topicInputTitleMax),
    summary: zod.union([zod.string().min(1), zod.null()]),
});

export type TopicInput = zod.input<typeof TopicInput>;
export type TopicInputOutput = zod.output<typeof TopicInput>;

export const movePositionMin = 0;

export const Move = zod.object({
    position: zod.int().min(movePositionMin),
});

export type Move = zod.input<typeof Move>;
export type MoveOutput = zod.output<typeof Move>;

export const decisionInputTitleMax = 500;

export const DecisionInput = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(decisionInputTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
});

export type DecisionInput = zod.input<typeof DecisionInput>;
export type DecisionInputOutput = zod.output<typeof DecisionInput>;

export const itemMovePositionMin = 0;

export const ItemMove = zod.object({
    position: zod.int().min(itemMovePositionMin),
    topic_id: zod.uuid(),
});

export type ItemMove = zod.input<typeof ItemMove>;
export type ItemMoveOutput = zod.output<typeof ItemMove>;

export const todoInputTitleMax = 500;

export const TodoInput = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(todoInputTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    person_id: zod.union([zod.uuid(), zod.null()]),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type TodoInput = zod.input<typeof TodoInput>;
export type TodoInputOutput = zod.output<typeof TodoInput>;

export const TodoDone = zod.object({
    is_done: zod.boolean(),
});

export type TodoDone = zod.input<typeof TodoDone>;
export type TodoDoneOutput = zod.output<typeof TodoDone>;

export const todoExternalLinkInputExternalIdMax = 255;

export const todoExternalLinkInputUrlOneMax = 2000;

export const todoExternalLinkInputUrlOneRegExp = new RegExp('^https://\\S+$');
export const todoExternalLinkInputServiceNameOneMax = 255;

export const TodoExternalLinkInput = zod.object({
    external_id: zod.string().min(1).max(todoExternalLinkInputExternalIdMax),
    url: zod
        .union([zod.string().max(todoExternalLinkInputUrlOneMax).regex(todoExternalLinkInputUrlOneRegExp), zod.null()])
        .optional(),
    service_name: zod.union([zod.string().max(todoExternalLinkInputServiceNameOneMax), zod.null()]).optional(),
});

export type TodoExternalLinkInput = zod.input<typeof TodoExternalLinkInput>;
export type TodoExternalLinkInputOutput = zod.output<typeof TodoExternalLinkInput>;

export const eventInputTitleMax = 500;

export const EventInput = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(eventInputTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    date: zod.iso.date(),
    time: zod.union([zod.iso.time({}), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type EventInput = zod.input<typeof EventInput>;
export type EventInputOutput = zod.output<typeof EventInput>;

export const FieldChange = zod.object({
    field: zod.enum([
        'title',
        'summary',
        'description',
        'name',
        'email',
        'company',
        'job_title',
        'is_participant',
        'user',
        'topic',
        'person',
        'due_date',
        'date',
        'time',
    ]),
    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
});

export type FieldChange = zod.input<typeof FieldChange>;
export type FieldChangeOutput = zod.output<typeof FieldChange>;

export const ItemChange = zod.object({
    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
    id: zod.uuid(),
    title: zod.string(),
    change: zod.enum(['added', 'removed', 'changed']),
    fields: zod.array(
        zod.object({
            field: zod.enum([
                'title',
                'summary',
                'description',
                'name',
                'email',
                'company',
                'job_title',
                'is_participant',
                'user',
                'topic',
                'person',
                'due_date',
                'date',
                'time',
            ]),
            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
        })
    ),
});

export type ItemChange = zod.input<typeof ItemChange>;
export type ItemChangeOutput = zod.output<typeof ItemChange>;

export const RecapChanges = zod.object({
    fields: zod.array(
        zod.object({
            field: zod.enum([
                'title',
                'summary',
                'description',
                'name',
                'email',
                'company',
                'job_title',
                'is_participant',
                'user',
                'topic',
                'person',
                'due_date',
                'date',
                'time',
            ]),
            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
        })
    ),
    items: zod.array(
        zod.object({
            kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
            id: zod.uuid(),
            title: zod.string(),
            change: zod.enum(['added', 'removed', 'changed']),
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
        })
    ),
    is_text_only: zod.boolean(),
});

export type RecapChanges = zod.input<typeof RecapChanges>;
export type RecapChangesOutput = zod.output<typeof RecapChanges>;

export const recapPublishInvitationIdsDefault = [];
export const RecapPublish = zod.object({
    is_acknowledgement_required: zod.boolean(),
    acknowledger_ids: zod.array(zod.uuid()),
    invitation_ids: zod.array(zod.uuid()).default(recapPublishInvitationIdsDefault),
});

export type RecapPublish = zod.input<typeof RecapPublish>;
export type RecapPublishOutput = zod.output<typeof RecapPublish>;

export const SupersedableItem = zod.object({
    kind: zod.enum(['todo', 'event']),
    id: zod.uuid(),
    title: zod.string(),
    topic_title: zod.string(),
    recap: zod.object({
        id: zod.uuid(),
        public_id: zod.string(),
        slug: zod.string(),
        title: zod.union([zod.string(), zod.null()]),
        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    }),
    person_name: zod.union([zod.string(), zod.null()]),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    date: zod.union([zod.iso.date(), zod.null()]),
    time: zod.union([zod.iso.time({}), zod.null()]),
});

export type SupersedableItem = zod.input<typeof SupersedableItem>;
export type SupersedableItemOutput = zod.output<typeof SupersedableItem>;

export const recapAcknowledgersUpdateInvitationIdsDefault = [];
export const RecapAcknowledgersUpdate = zod.object({
    user_ids: zod.array(zod.uuid()),
    invitation_ids: zod.array(zod.uuid()).default(recapAcknowledgersUpdateInvitationIdsDefault),
});

export type RecapAcknowledgersUpdate = zod.input<typeof RecapAcknowledgersUpdate>;
export type RecapAcknowledgersUpdateOutput = zod.output<typeof RecapAcknowledgersUpdate>;

export const RecapAcknowledgement = zod.object({
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    created_at: zod.iso.datetime({ offset: true }),
});

export type RecapAcknowledgement = zod.input<typeof RecapAcknowledgement>;
export type RecapAcknowledgementOutput = zod.output<typeof RecapAcknowledgement>;

export const RecapVersionListItem = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
    published_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    acknowledgements: zod.array(
        zod.object({
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            created_at: zod.iso.datetime({ offset: true }),
        })
    ),
});

export type RecapVersionListItem = zod.input<typeof RecapVersionListItem>;
export type RecapVersionListItemOutput = zod.output<typeof RecapVersionListItem>;

export const RecapVersionPermissions = zod.object({
    can_restore: zod.boolean(),
});

export type RecapVersionPermissions = zod.input<typeof RecapVersionPermissions>;
export type RecapVersionPermissionsOutput = zod.output<typeof RecapVersionPermissions>;

export const RecapVersion = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
    published_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    acknowledgements: zod.array(
        zod.object({
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            created_at: zod.iso.datetime({ offset: true }),
        })
    ),
    title: zod.union([zod.string(), zod.null()]),
    summary: zod.union([zod.string(), zod.null()]),
    persons: zod.array(
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            email: zod.union([zod.string(), zod.null()]),
            job_title: zod.union([zod.string(), zod.null()]),
            is_participant: zod.boolean(),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
        })
    ),
    topics: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            summary: zod.union([zod.string(), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            decisions: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                })
            ),
            todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    is_done: zod.boolean(),
                    done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    done_by: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                    external_link: zod.union([
                        zod.object({
                            provider: zod.string(),
                            provider_name: zod.union([zod.string(), zod.null()]),
                            url: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                })
            ),
        })
    ),
    sources: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
        })
    ),
    permissions: zod.object({
        can_restore: zod.boolean(),
    }),
});

export type RecapVersion = zod.input<typeof RecapVersion>;
export type RecapVersionOutput = zod.output<typeof RecapVersion>;

export const Auth = zod.enum(['password', 'api_key', 'oauth', 'none']);

export type Auth = zod.input<typeof Auth>;
export type AuthOutput = zod.output<typeof Auth>;

export const Provider = zod.object({
    key: zod.string(),
    name: zod.string(),
    is_set_up: zod.boolean(),
    auth: zod.enum(['password', 'api_key', 'oauth', 'none']),
    facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    input_facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    output_facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    allows_own_connections: zod.boolean(),
    allows_workspace_connections: zod.boolean(),
    allows_own_inputs: zod.boolean(),
    own_only_facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    allows_switching_account: zod.boolean(),
    picks_files: zod.boolean(),
    picks_items: zod.boolean(),
    takes_webhooks: zod.boolean(),
    pushes_inputs: zod.boolean(),
    receives_email: zod.boolean(),
    signs_posts: zod.boolean(),
    serves_outputs: zod.boolean(),
    url_patterns: zod.array(zod.string()),
    authorize_url: zod.union([zod.string(), zod.null()]),
    admin_consent_url: zod.union([zod.string(), zod.null()]),
});

export type Provider = zod.input<typeof Provider>;
export type ProviderOutput = zod.output<typeof Provider>;

export const BoardList = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type BoardList = zod.input<typeof BoardList>;
export type BoardListOutput = zod.output<typeof BoardList>;

export const RouteCondition = zod.object({
    field: zod.enum(['senders', 'recipients', 'subject', 'words', 'not_words', 'body', 'file_names', 'lists', 'query']),
    values: zod.array(zod.string()),
    lists: zod.array(
        zod.object({
            id: zod.string(),
            name: zod.string(),
        })
    ),
    query: zod.union([zod.string(), zod.null()]),
});

export type RouteCondition = zod.input<typeof RouteCondition>;
export type RouteConditionOutput = zod.output<typeof RouteCondition>;

export const DraftingMode = zod.enum(['none', 'alone', 'with_waiting']);

export type DraftingMode = zod.input<typeof DraftingMode>;
export type DraftingModeOutput = zod.output<typeof DraftingMode>;

export const FeedRoute = zod.object({
    id: zod.uuid(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    groups: zod.array(
        zod.array(
            zod.object({
                field: zod.enum([
                    'senders',
                    'recipients',
                    'subject',
                    'words',
                    'not_words',
                    'body',
                    'file_names',
                    'lists',
                    'query',
                ]),
                values: zod.array(zod.string()),
                lists: zod.array(
                    zod.object({
                        id: zod.string(),
                        name: zod.string(),
                    })
                ),
                query: zod.union([zod.string(), zod.null()]),
            })
        )
    ),
    drafting: zod.enum(['none', 'alone', 'with_waiting']),
});

export type FeedRoute = zod.input<typeof FeedRoute>;
export type FeedRouteOutput = zod.output<typeof FeedRoute>;

export const IntegrationError = zod.enum([
    'login_failed',
    'unreachable',
    'host_not_allowed',
    'not_found',
    'unsupported_version',
    'api_not_included',
    'sync_failed',
]);

export type IntegrationError = zod.input<typeof IntegrationError>;
export type IntegrationErrorOutput = zod.output<typeof IntegrationError>;

export const FeedPermissions = zod.object({
    can_edit: zod.boolean(),
    can_delete: zod.boolean(),
    can_sync: zod.boolean(),
});

export type FeedPermissions = zod.input<typeof FeedPermissions>;
export type FeedPermissionsOutput = zod.output<typeof FeedPermissions>;

export const Feed = zod.object({
    id: zod.uuid(),
    facet: zod.enum([
        'email',
        'meeting',
        'document',
        'task',
        'conversation',
        'calendar',
        'events',
        'todos',
        'recaps',
        'clients',
    ]),
    is_input: zod.boolean(),
    is_output: zod.boolean(),
    settings: zod.record(zod.string(), zod.unknown()),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    routes: zod.array(
        zod.object({
            id: zod.uuid(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            groups: zod.array(
                zod.array(
                    zod.object({
                        field: zod.enum([
                            'senders',
                            'recipients',
                            'subject',
                            'words',
                            'not_words',
                            'body',
                            'file_names',
                            'lists',
                            'query',
                        ]),
                        values: zod.array(zod.string()),
                        lists: zod.array(
                            zod.object({
                                id: zod.string(),
                                name: zod.string(),
                            })
                        ),
                        query: zod.union([zod.string(), zod.null()]),
                    })
                )
            ),
            drafting: zod.enum(['none', 'alone', 'with_waiting']),
        })
    ),
    is_keeping_unmatched: zod.boolean(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    drafting: zod.enum(['none', 'alone', 'with_waiting']),
    is_syncing: zod.boolean(),
    last_error: zod.union([
        zod.enum([
            'login_failed',
            'unreachable',
            'host_not_allowed',
            'not_found',
            'unsupported_version',
            'api_not_included',
            'sync_failed',
        ]),
        zod.null(),
    ]),
    webhook_url: zod.union([zod.string(), zod.null()]),
    email_address: zod.union([zod.string(), zod.null()]),
    signing_secret: zod.union([zod.string(), zod.null()]),
    subscription_url: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_edit: zod.boolean(),
        can_delete: zod.boolean(),
        can_sync: zod.boolean(),
    }),
});

export type Feed = zod.input<typeof Feed>;
export type FeedOutput = zod.output<typeof Feed>;

export const ConnectionPermissions = zod.object({
    can_edit: zod.boolean(),
    can_delete: zod.boolean(),
    can_pick_items: zod.boolean(),
});

export type ConnectionPermissions = zod.input<typeof ConnectionPermissions>;
export type ConnectionPermissionsOutput = zod.output<typeof ConnectionPermissions>;

export const Connection = zod.object({
    id: zod.uuid(),
    provider: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    name: zod.string(),
    account: zod.union([zod.string(), zod.null()]),
    settings: zod.record(zod.string(), zod.unknown()),
    is_own: zod.boolean(),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    connected_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    feeds: zod.array(
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            is_input: zod.boolean(),
            is_output: zod.boolean(),
            settings: zod.record(zod.string(), zod.unknown()),
            synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            routes: zod.array(
                zod.object({
                    id: zod.uuid(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    groups: zod.array(
                        zod.array(
                            zod.object({
                                field: zod.enum([
                                    'senders',
                                    'recipients',
                                    'subject',
                                    'words',
                                    'not_words',
                                    'body',
                                    'file_names',
                                    'lists',
                                    'query',
                                ]),
                                values: zod.array(zod.string()),
                                lists: zod.array(
                                    zod.object({
                                        id: zod.string(),
                                        name: zod.string(),
                                    })
                                ),
                                query: zod.union([zod.string(), zod.null()]),
                            })
                        )
                    ),
                    drafting: zod.enum(['none', 'alone', 'with_waiting']),
                })
            ),
            is_keeping_unmatched: zod.boolean(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            drafting: zod.enum(['none', 'alone', 'with_waiting']),
            is_syncing: zod.boolean(),
            last_error: zod.union([
                zod.enum([
                    'login_failed',
                    'unreachable',
                    'host_not_allowed',
                    'not_found',
                    'unsupported_version',
                    'api_not_included',
                    'sync_failed',
                ]),
                zod.null(),
            ]),
            webhook_url: zod.union([zod.string(), zod.null()]),
            email_address: zod.union([zod.string(), zod.null()]),
            signing_secret: zod.union([zod.string(), zod.null()]),
            subscription_url: zod.union([zod.string(), zod.null()]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
                can_sync: zod.boolean(),
            }),
        })
    ),
    authorized_facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    has_file_access: zod.boolean(),
    is_syncing: zod.boolean(),
    last_error: zod.union([
        zod.enum([
            'login_failed',
            'unreachable',
            'host_not_allowed',
            'not_found',
            'unsupported_version',
            'api_not_included',
            'sync_failed',
        ]),
        zod.null(),
    ]),
    token_prefix: zod.union([zod.string(), zod.null()]),
    token_used_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    acts_as: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    oauth_client_name: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_edit: zod.boolean(),
        can_delete: zod.boolean(),
        can_pick_items: zod.boolean(),
    }),
});

export type Connection = zod.input<typeof Connection>;
export type ConnectionOutput = zod.output<typeof Connection>;

export const ConnectionCreated = zod.object({
    id: zod.uuid(),
    provider: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    name: zod.string(),
    account: zod.union([zod.string(), zod.null()]),
    settings: zod.record(zod.string(), zod.unknown()),
    is_own: zod.boolean(),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    connected_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    feeds: zod.array(
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            is_input: zod.boolean(),
            is_output: zod.boolean(),
            settings: zod.record(zod.string(), zod.unknown()),
            synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            routes: zod.array(
                zod.object({
                    id: zod.uuid(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    groups: zod.array(
                        zod.array(
                            zod.object({
                                field: zod.enum([
                                    'senders',
                                    'recipients',
                                    'subject',
                                    'words',
                                    'not_words',
                                    'body',
                                    'file_names',
                                    'lists',
                                    'query',
                                ]),
                                values: zod.array(zod.string()),
                                lists: zod.array(
                                    zod.object({
                                        id: zod.string(),
                                        name: zod.string(),
                                    })
                                ),
                                query: zod.union([zod.string(), zod.null()]),
                            })
                        )
                    ),
                    drafting: zod.enum(['none', 'alone', 'with_waiting']),
                })
            ),
            is_keeping_unmatched: zod.boolean(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            drafting: zod.enum(['none', 'alone', 'with_waiting']),
            is_syncing: zod.boolean(),
            last_error: zod.union([
                zod.enum([
                    'login_failed',
                    'unreachable',
                    'host_not_allowed',
                    'not_found',
                    'unsupported_version',
                    'api_not_included',
                    'sync_failed',
                ]),
                zod.null(),
            ]),
            webhook_url: zod.union([zod.string(), zod.null()]),
            email_address: zod.union([zod.string(), zod.null()]),
            signing_secret: zod.union([zod.string(), zod.null()]),
            subscription_url: zod.union([zod.string(), zod.null()]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
                can_sync: zod.boolean(),
            }),
        })
    ),
    authorized_facets: zod.array(
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ])
    ),
    has_file_access: zod.boolean(),
    is_syncing: zod.boolean(),
    last_error: zod.union([
        zod.enum([
            'login_failed',
            'unreachable',
            'host_not_allowed',
            'not_found',
            'unsupported_version',
            'api_not_included',
            'sync_failed',
        ]),
        zod.null(),
    ]),
    token_prefix: zod.union([zod.string(), zod.null()]),
    token_used_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    acts_as: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    oauth_client_name: zod.union([zod.string(), zod.null()]),
    permissions: zod.object({
        can_edit: zod.boolean(),
        can_delete: zod.boolean(),
        can_pick_items: zod.boolean(),
    }),
    token: zod.union([zod.string(), zod.null()]),
});

export type ConnectionCreated = zod.input<typeof ConnectionCreated>;
export type ConnectionCreatedOutput = zod.output<typeof ConnectionCreated>;

export const connectionInputNameOneMax = 200;

export const connectionInputIsOwnDefault = false;
export const ConnectionInput = zod.object({
    provider: zod.string(),
    name: zod.union([zod.string().min(1).max(connectionInputNameOneMax), zod.null()]).optional(),
    is_own: zod.boolean().default(connectionInputIsOwnDefault),
    settings: zod.record(zod.string(), zod.unknown()),
    credentials: zod.record(zod.string(), zod.unknown()),
    bot_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type ConnectionInput = zod.input<typeof ConnectionInput>;
export type ConnectionInputOutput = zod.output<typeof ConnectionInput>;

export const ConnectionTest = zod.object({
    connection_id: zod.union([zod.uuid(), zod.null()]).optional(),
    provider: zod.string(),
    settings: zod.record(zod.string(), zod.unknown()),
    credentials: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
});

export type ConnectionTest = zod.input<typeof ConnectionTest>;
export type ConnectionTestOutput = zod.output<typeof ConnectionTest>;

export const OAuthStartResult = zod.object({
    authorize_url: zod.string(),
});

export type OAuthStartResult = zod.input<typeof OAuthStartResult>;
export type OAuthStartResultOutput = zod.output<typeof OAuthStartResult>;

export const oAuthStartIsOwnDefault = false;
export const oAuthStartFacetsDefault = [];
export const oAuthStartIsForFilesDefault = false;
export const oAuthStartIsForStartDefault = false;
export const OAuthStart = zod.object({
    provider: zod.string(),
    is_own: zod.boolean().default(oAuthStartIsOwnDefault),
    connection_id: zod.union([zod.uuid(), zod.null()]).optional(),
    facets: zod
        .array(
            zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ])
        )
        .default(oAuthStartFacetsDefault),
    is_for_files: zod.boolean().default(oAuthStartIsForFilesDefault),
    is_for_start: zod.boolean().default(oAuthStartIsForStartDefault),
});

export type OAuthStart = zod.input<typeof OAuthStart>;
export type OAuthStartOutput = zod.output<typeof OAuthStart>;

export const PickPlace = zod.object({
    id: zod.string(),
    name: zod.string(),
    depth: zod.int(),
    facet: zod.union([
        zod.enum([
            'email',
            'meeting',
            'document',
            'task',
            'conversation',
            'calendar',
            'events',
            'todos',
            'recaps',
            'clients',
        ]),
        zod.null(),
    ]),
});

export type PickPlace = zod.input<typeof PickPlace>;
export type PickPlaceOutput = zod.output<typeof PickPlace>;

export const pickItemsQuerySearchDefault = ``;
export const PickItemsQuery = zod.object({
    place_id: zod.union([zod.string(), zod.null()]).optional(),
    search: zod.string().default(pickItemsQuerySearchDefault),
});

export type PickItemsQuery = zod.input<typeof PickItemsQuery>;
export type PickItemsQueryOutput = zod.output<typeof PickItemsQuery>;

export const PickItem = zod.object({
    id: zod.string(),
    title: zod.string(),
    sender: zod.union([zod.string(), zod.null()]),
    preview: zod.union([zod.string(), zod.null()]),
    at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    has_attachments: zod.boolean(),
    labels: zod.array(zod.string()),
    due_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    place_name: zod.union([zod.string(), zod.null()]),
    reference: zod.union([zod.string(), zod.null()]),
    is_source: zod.boolean(),
});

export type PickItem = zod.input<typeof PickItem>;
export type PickItemOutput = zod.output<typeof PickItem>;

export const PickerConfig = zod.object({
    provider: zod.string(),
    config: zod.record(zod.string(), zod.unknown()),
});

export type PickerConfig = zod.input<typeof PickerConfig>;
export type PickerConfigOutput = zod.output<typeof PickerConfig>;

export const connectionUpdateNameOneMax = 200;

export const ConnectionUpdate = zod.object({
    name: zod.union([zod.string().min(1).max(connectionUpdateNameOneMax), zod.null()]).optional(),
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    credentials: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
});

export type ConnectionUpdate = zod.input<typeof ConnectionUpdate>;
export type ConnectionUpdateOutput = zod.output<typeof ConnectionUpdate>;

export const ConnectionToken = zod.object({
    token: zod.string(),
});

export type ConnectionToken = zod.input<typeof ConnectionToken>;
export type ConnectionTokenOutput = zod.output<typeof ConnectionToken>;

export const MailFolder = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type MailFolder = zod.input<typeof MailFolder>;
export type MailFolderOutput = zod.output<typeof MailFolder>;

export const Calendar = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type Calendar = zod.input<typeof Calendar>;
export type CalendarOutput = zod.output<typeof Calendar>;

export const TodoList = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type TodoList = zod.input<typeof TodoList>;
export type TodoListOutput = zod.output<typeof TodoList>;

export const Repository = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type Repository = zod.input<typeof Repository>;
export type RepositoryOutput = zod.output<typeof Repository>;

export const JiraProject = zod.object({
    id: zod.string(),
    key: zod.string(),
    name: zod.string(),
    site_id: zod.string(),
    site_name: zod.string(),
    site_url: zod.string(),
});

export type JiraProject = zod.input<typeof JiraProject>;
export type JiraProjectOutput = zod.output<typeof JiraProject>;

export const OdooTag = zod.object({
    id: zod.int(),
    name: zod.string(),
});

export type OdooTag = zod.input<typeof OdooTag>;
export type OdooTagOutput = zod.output<typeof OdooTag>;

export const HubSpotLifecycleStage = zod.object({
    id: zod.string(),
    name: zod.string(),
});

export type HubSpotLifecycleStage = zod.input<typeof HubSpotLifecycleStage>;
export type HubSpotLifecycleStageOutput = zod.output<typeof HubSpotLifecycleStage>;

export const OdooFolder = zod.object({
    id: zod.int(),
    name: zod.string(),
});

export type OdooFolder = zod.input<typeof OdooFolder>;
export type OdooFolderOutput = zod.output<typeof OdooFolder>;

export const OdooProject = zod.object({
    id: zod.int(),
    name: zod.string(),
    customer: zod.union([zod.string(), zod.null()]),
});

export type OdooProject = zod.input<typeof OdooProject>;
export type OdooProjectOutput = zod.output<typeof OdooProject>;

export const feedInputIsKeepingUnmatchedDefault = false;
export const feedInputDraftingDefault = `none`;
export const FeedInput = zod.object({
    facet: zod.enum([
        'email',
        'meeting',
        'document',
        'task',
        'conversation',
        'calendar',
        'events',
        'todos',
        'recaps',
        'clients',
    ]),
    settings: zod.record(zod.string(), zod.unknown()),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.boolean().default(feedInputIsKeepingUnmatchedDefault),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.enum(['none', 'alone', 'with_waiting']).default(feedInputDraftingDefault),
});

export type FeedInput = zod.input<typeof FeedInput>;
export type FeedInputOutput = zod.output<typeof FeedInput>;

export const FeedUpdate = zod.object({
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.union([zod.boolean(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.union([zod.enum(['none', 'alone', 'with_waiting']), zod.null()]).optional(),
});

export type FeedUpdate = zod.input<typeof FeedUpdate>;
export type FeedUpdateOutput = zod.output<typeof FeedUpdate>;

export const routeConditionInputValuesDefault = [];
export const RouteConditionInput = zod.object({
    field: zod.enum(['senders', 'recipients', 'subject', 'words', 'not_words', 'body', 'file_names', 'lists', 'query']),
    values: zod.array(zod.string()).default(routeConditionInputValuesDefault),
    query: zod.union([zod.string(), zod.null()]).optional(),
});

export type RouteConditionInput = zod.input<typeof RouteConditionInput>;
export type RouteConditionInputOutput = zod.output<typeof RouteConditionInput>;

export const feedRouteInputGroupsItemItemValuesDefault = [];
export const feedRouteInputGroupsDefault = [];
export const feedRouteInputDraftingDefault = `none`;
export const FeedRouteInput = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    groups: zod
        .array(
            zod.array(
                zod.object({
                    field: zod.enum([
                        'senders',
                        'recipients',
                        'subject',
                        'words',
                        'not_words',
                        'body',
                        'file_names',
                        'lists',
                        'query',
                    ]),
                    values: zod.array(zod.string()).default(feedRouteInputGroupsItemItemValuesDefault),
                    query: zod.union([zod.string(), zod.null()]).optional(),
                })
            )
        )
        .default(feedRouteInputGroupsDefault),
    drafting: zod.enum(['none', 'alone', 'with_waiting']).default(feedRouteInputDraftingDefault),
});

export type FeedRouteInput = zod.input<typeof FeedRouteInput>;
export type FeedRouteInputOutput = zod.output<typeof FeedRouteInput>;

export const feedRouteUpdateGroupsOneItemItemValuesDefault = [];
export const FeedRouteUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    groups: zod
        .union([
            zod.array(
                zod.array(
                    zod.object({
                        field: zod.enum([
                            'senders',
                            'recipients',
                            'subject',
                            'words',
                            'not_words',
                            'body',
                            'file_names',
                            'lists',
                            'query',
                        ]),
                        values: zod.array(zod.string()).default(feedRouteUpdateGroupsOneItemItemValuesDefault),
                        query: zod.union([zod.string(), zod.null()]).optional(),
                    })
                )
            ),
            zod.null(),
        ])
        .optional(),
    drafting: zod.union([zod.enum(['none', 'alone', 'with_waiting']), zod.null()]).optional(),
});

export type FeedRouteUpdate = zod.input<typeof FeedRouteUpdate>;
export type FeedRouteUpdateOutput = zod.output<typeof FeedRouteUpdate>;

export const RoutePreviewSource = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    sender: zod.union([zod.string(), zod.null()]),
    received_at: zod.iso.datetime({ offset: true }),
    is_match: zod.boolean(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
});

export type RoutePreviewSource = zod.input<typeof RoutePreviewSource>;
export type RoutePreviewSourceOutput = zod.output<typeof RoutePreviewSource>;

export const RouteQueryError = zod.object({
    group: zod.int(),
    condition: zod.int(),
    kind: zod.enum([
        'unclosed_bracket',
        'unexpected_bracket',
        'unclosed_quote',
        'unknown_field',
        'field_in_field',
        'missing_value',
        'dangling_operator',
        'too_long',
    ]),
    position: zod.int(),
    length: zod.int(),
    name: zod.union([zod.string(), zod.null()]),
});

export type RouteQueryError = zod.input<typeof RouteQueryError>;
export type RouteQueryErrorOutput = zod.output<typeof RouteQueryError>;

export const RoutePreview = zod.object({
    sources: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            sender: zod.union([zod.string(), zod.null()]),
            received_at: zod.iso.datetime({ offset: true }),
            is_match: zod.boolean(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    query_error: zod.union([
        zod.object({
            group: zod.int(),
            condition: zod.int(),
            kind: zod.enum([
                'unclosed_bracket',
                'unexpected_bracket',
                'unclosed_quote',
                'unknown_field',
                'field_in_field',
                'missing_value',
                'dangling_operator',
                'too_long',
            ]),
            position: zod.int(),
            length: zod.int(),
            name: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
});

export type RoutePreview = zod.input<typeof RoutePreview>;
export type RoutePreviewOutput = zod.output<typeof RoutePreview>;

export const routePreviewInputGroupsItemItemValuesDefault = [];
export const RoutePreviewInput = zod.object({
    groups: zod.array(
        zod.array(
            zod.object({
                field: zod.enum([
                    'senders',
                    'recipients',
                    'subject',
                    'words',
                    'not_words',
                    'body',
                    'file_names',
                    'lists',
                    'query',
                ]),
                values: zod.array(zod.string()).default(routePreviewInputGroupsItemItemValuesDefault),
                query: zod.union([zod.string(), zod.null()]).optional(),
            })
        )
    ),
    route_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type RoutePreviewInput = zod.input<typeof RoutePreviewInput>;
export type RoutePreviewInputOutput = zod.output<typeof RoutePreviewInput>;

export const ExternalCompanyFilters = zod.object({
    is_suggested: zod.union([zod.boolean(), zod.null()]).optional(),
    search: zod.union([zod.string(), zod.null()]).optional(),
});

export type ExternalCompanyFilters = zod.input<typeof ExternalCompanyFilters>;
export type ExternalCompanyFiltersOutput = zod.output<typeof ExternalCompanyFilters>;

export const ExternalCompany = zod.object({
    id: zod.uuid(),
    connection_id: zod.uuid(),
    provider: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    name: zod.string(),
    url: zod.string(),
    address: zod.string(),
    domains: zod.array(zod.string()),
    contact_count: zod.int(),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    is_dismissed: zod.boolean(),
});

export type ExternalCompany = zod.input<typeof ExternalCompany>;
export type ExternalCompanyOutput = zod.output<typeof ExternalCompany>;

export const PagedExternalCompany = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            connection_id: zod.uuid(),
            provider: zod.string(),
            provider_name: zod.union([zod.string(), zod.null()]),
            name: zod.string(),
            url: zod.string(),
            address: zod.string(),
            domains: zod.array(zod.string()),
            contact_count: zod.int(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            is_dismissed: zod.boolean(),
        })
    ),
    count: zod.int(),
});

export type PagedExternalCompany = zod.input<typeof PagedExternalCompany>;
export type PagedExternalCompanyOutput = zod.output<typeof PagedExternalCompany>;

export const ExternalCompanyUpdate = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    is_dismissed: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type ExternalCompanyUpdate = zod.input<typeof ExternalCompanyUpdate>;
export type ExternalCompanyUpdateOutput = zod.output<typeof ExternalCompanyUpdate>;

export const ExternalContact = zod.object({
    id: zod.uuid(),
    name: zod.string(),
    email: zod.string(),
    job_title: zod.string(),
    company_name: zod.string(),
    provider_name: zod.union([zod.string(), zod.null()]),
    is_employee: zod.boolean(),
    is_invited: zod.boolean(),
});

export type ExternalContact = zod.input<typeof ExternalContact>;
export type ExternalContactOutput = zod.output<typeof ExternalContact>;

export const ActivityFilters = zod.object({
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    recap_id: zod.union([zod.uuid(), zod.null()]).optional(),
    is_new: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type ActivityFilters = zod.input<typeof ActivityFilters>;
export type ActivityFiltersOutput = zod.output<typeof ActivityFilters>;

export const ActivityKind = zod.enum([
    'source_received',
    'source_failed',
    'source_updated',
    'source_processed_again',
    'source_changed',
    'recap_created',
    'recap_drafted',
    'recap_failed',
    'version_published',
    'todo_done',
    'todo_undone',
    'item_superseded',
    'comment_added',
    'recap_acknowledged',
    'acknowledger_removed',
    'recap_processed_again',
    'recap_sources_changed',
    'draft_discarded',
    'version_restored',
    'recap_moved',
    'source_moved',
    'public_link_created',
    'public_link_removed',
    'recap_deleted',
    'source_deleted',
    'client_created',
    'client_renamed',
    'client_deleted',
    'project_created',
    'project_renamed',
    'project_deleted',
    'project_client_changed',
]);

export type ActivityKind = zod.input<typeof ActivityKind>;
export type ActivityKindOutput = zod.output<typeof ActivityKind>;

export const SourceDetail = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
    files: zod.array(
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            mime_type: zod.string(),
            url: zod.string(),
            page_count: zod.int(),
            size: zod.int(),
            is_email_body: zod.boolean(),
        })
    ),
    feed: zod.union([
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            connection_id: zod.uuid(),
            connection_name: zod.string(),
            connection_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    provider: zod.union([zod.string(), zod.null()]),
    provider_name: zod.union([zod.string(), zod.null()]),
    inbound_email: zod.union([zod.string(), zod.null()]),
});

export type SourceDetail = zod.input<typeof SourceDetail>;
export type SourceDetailOutput = zod.output<typeof SourceDetail>;

export const ActivityVersion = zod.object({
    number: zod.int(),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
});

export type ActivityVersion = zod.input<typeof ActivityVersion>;
export type ActivityVersionOutput = zod.output<typeof ActivityVersion>;

export const CommentedItem = zod.enum(['topic', 'decision', 'todo', 'event']);

export type CommentedItem = zod.input<typeof CommentedItem>;
export type CommentedItemOutput = zod.output<typeof CommentedItem>;

export const CommentReplyTo = zod.object({
    id: zod.uuid(),
    author: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    text: zod.string(),
    created_at: zod.iso.datetime({ offset: true }),
});

export type CommentReplyTo = zod.input<typeof CommentReplyTo>;
export type CommentReplyToOutput = zod.output<typeof CommentReplyTo>;

export const CommentPermissions = zod.object({
    can_edit: zod.boolean(),
    can_delete: zod.boolean(),
});

export type CommentPermissions = zod.input<typeof CommentPermissions>;
export type CommentPermissionsOutput = zod.output<typeof CommentPermissions>;

export const Comment = zod.object({
    id: zod.uuid(),
    author: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    text: zod.string(),
    created_at: zod.iso.datetime({ offset: true }),
    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
    item_id: zod.union([zod.uuid(), zod.null()]),
    version_number: zod.union([zod.int(), zod.null()]),
    is_on_draft: zod.boolean(),
    is_reply: zod.boolean(),
    reply_to: zod.union([
        zod.object({
            id: zod.uuid(),
            author: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            text: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
        }),
        zod.null(),
    ]),
    permissions: zod.object({
        can_edit: zod.boolean(),
        can_delete: zod.boolean(),
    }),
});

export type Comment = zod.input<typeof Comment>;
export type CommentOutput = zod.output<typeof Comment>;

export const ActivityListItem = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'source_received',
        'source_failed',
        'source_updated',
        'source_processed_again',
        'source_changed',
        'recap_created',
        'recap_drafted',
        'recap_failed',
        'version_published',
        'todo_done',
        'todo_undone',
        'item_superseded',
        'comment_added',
        'recap_acknowledged',
        'acknowledger_removed',
        'recap_processed_again',
        'recap_sources_changed',
        'draft_discarded',
        'version_restored',
        'recap_moved',
        'source_moved',
        'public_link_created',
        'public_link_removed',
        'recap_deleted',
        'source_deleted',
        'client_created',
        'client_renamed',
        'client_deleted',
        'project_created',
        'project_renamed',
        'project_deleted',
        'project_client_changed',
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    affected_user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    recap: zod.union([
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
        }),
        zod.null(),
    ]),
    source: zod.union([
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    version_number: zod.union([zod.int(), zod.null()]),
    item_title: zod.union([zod.string(), zod.null()]),
    version: zod.union([
        zod.object({
            number: zod.int(),
            is_acknowledgement_required: zod.boolean(),
            changes: zod.union([
                zod.object({
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                    items: zod.array(
                        zod.object({
                            kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                            id: zod.uuid(),
                            title: zod.string(),
                            change: zod.enum(['added', 'removed', 'changed']),
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                        })
                    ),
                    is_text_only: zod.boolean(),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    comment: zod.union([
        zod.object({
            id: zod.uuid(),
            author: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            text: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
            edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
            item_id: zod.union([zod.uuid(), zod.null()]),
            version_number: zod.union([zod.int(), zod.null()]),
            is_on_draft: zod.boolean(),
            is_reply: zod.boolean(),
            reply_to: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
    is_new: zod.boolean(),
});

export type ActivityListItem = zod.input<typeof ActivityListItem>;
export type ActivityListItemOutput = zod.output<typeof ActivityListItem>;

export const PagedActivityListItem = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'source_received',
                'source_failed',
                'source_updated',
                'source_processed_again',
                'source_changed',
                'recap_created',
                'recap_drafted',
                'recap_failed',
                'version_published',
                'todo_done',
                'todo_undone',
                'item_superseded',
                'comment_added',
                'recap_acknowledged',
                'acknowledger_removed',
                'recap_processed_again',
                'recap_sources_changed',
                'draft_discarded',
                'version_restored',
                'recap_moved',
                'source_moved',
                'public_link_created',
                'public_link_removed',
                'recap_deleted',
                'source_deleted',
                'client_created',
                'client_renamed',
                'client_deleted',
                'project_created',
                'project_renamed',
                'project_deleted',
                'project_client_changed',
            ]),
            created_at: zod.iso.datetime({ offset: true }),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            affected_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            recap: zod.union([
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
                zod.null(),
            ]),
            source: zod.union([
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            version_number: zod.union([zod.int(), zod.null()]),
            item_title: zod.union([zod.string(), zod.null()]),
            version: zod.union([
                zod.object({
                    number: zod.int(),
                    is_acknowledgement_required: zod.boolean(),
                    changes: zod.union([
                        zod.object({
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                            items: zod.array(
                                zod.object({
                                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                                    id: zod.uuid(),
                                    title: zod.string(),
                                    change: zod.enum(['added', 'removed', 'changed']),
                                    fields: zod.array(
                                        zod.object({
                                            field: zod.enum([
                                                'title',
                                                'summary',
                                                'description',
                                                'name',
                                                'email',
                                                'company',
                                                'job_title',
                                                'is_participant',
                                                'user',
                                                'topic',
                                                'person',
                                                'due_date',
                                                'date',
                                                'time',
                                            ]),
                                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                        })
                                    ),
                                })
                            ),
                            is_text_only: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    digest: zod.union([
                        zod.object({
                            summary: zod.union([zod.string(), zod.null()]),
                            person_count: zod.int(),
                            topic_count: zod.int(),
                            decision_count: zod.int(),
                            todo_count: zod.int(),
                            event_count: zod.int(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            comment: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
                    item_id: zod.union([zod.uuid(), zod.null()]),
                    version_number: zod.union([zod.int(), zod.null()]),
                    is_on_draft: zod.boolean(),
                    is_reply: zod.boolean(),
                    reply_to: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            author: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                            text: zod.string(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_edit: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
            is_new: zod.boolean(),
        })
    ),
    count: zod.int(),
});

export type PagedActivityListItem = zod.input<typeof PagedActivityListItem>;
export type PagedActivityListItemOutput = zod.output<typeof PagedActivityListItem>;

export const recapCommentCreateTextMax = 10000;

export const RecapCommentCreate = zod.object({
    text: zod.string().min(1).max(recapCommentCreateTextMax),
    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
    item_id: zod.union([zod.uuid(), zod.null()]),
    version_number: zod.union([zod.int(), zod.null()]),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type RecapCommentCreate = zod.input<typeof RecapCommentCreate>;
export type RecapCommentCreateOutput = zod.output<typeof RecapCommentCreate>;

export const sourceCommentCreateTextMax = 10000;

export const SourceCommentCreate = zod.object({
    text: zod.string().min(1).max(sourceCommentCreateTextMax),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type SourceCommentCreate = zod.input<typeof SourceCommentCreate>;
export type SourceCommentCreateOutput = zod.output<typeof SourceCommentCreate>;

export const commentUpdateTextMax = 10000;

export const CommentUpdate = zod.object({
    text: zod.string().min(1).max(commentUpdateTextMax),
});

export type CommentUpdate = zod.input<typeof CommentUpdate>;
export type CommentUpdateOutput = zod.output<typeof CommentUpdate>;

export const StartProject = zod.object({
    name: zod.string(),
    source_ids: zod.array(zod.uuid()),
});

export type StartProject = zod.input<typeof StartProject>;
export type StartProjectOutput = zod.output<typeof StartProject>;

export const StartPerson = zod.object({
    name: zod.string(),
    email: zod.string(),
    job_title: zod.union([zod.string(), zod.null()]),
});

export type StartPerson = zod.input<typeof StartPerson>;
export type StartPersonOutput = zod.output<typeof StartPerson>;

export const StartClientSuggestion = zod.object({
    name: zod.string(),
    domain: zod.string(),
    projects: zod.array(
        zod.object({
            name: zod.string(),
            source_ids: zod.array(zod.uuid()),
        })
    ),
    source_ids: zod.array(zod.uuid()),
    persons: zod.array(
        zod.object({
            name: zod.string(),
            email: zod.string(),
            job_title: zod.union([zod.string(), zod.null()]),
        })
    ),
});

export type StartClientSuggestion = zod.input<typeof StartClientSuggestion>;
export type StartClientSuggestionOutput = zod.output<typeof StartClientSuggestion>;

export const StartEmail = zod.object({
    id: zod.uuid(),
    subject: zod.union([zod.string(), zod.null()]),
    from_name: zod.union([zod.string(), zod.null()]),
    from_address: zod.union([zod.string(), zod.null()]),
    received_at: zod.iso.datetime({ offset: true }),
});

export type StartEmail = zod.input<typeof StartEmail>;
export type StartEmailOutput = zod.output<typeof StartEmail>;

export const StartSuggestions = zod.object({
    status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
    processing_count: zod.int(),
    clients: zod.array(
        zod.object({
            name: zod.string(),
            domain: zod.string(),
            projects: zod.array(
                zod.object({
                    name: zod.string(),
                    source_ids: zod.array(zod.uuid()),
                })
            ),
            source_ids: zod.array(zod.uuid()),
            persons: zod.array(
                zod.object({
                    name: zod.string(),
                    email: zod.string(),
                    job_title: zod.union([zod.string(), zod.null()]),
                })
            ),
        })
    ),
    team: zod.array(
        zod.object({
            name: zod.string(),
            email: zod.string(),
            job_title: zod.union([zod.string(), zod.null()]),
        })
    ),
    unassigned_source_ids: zod.array(zod.uuid()),
    emails: zod.array(
        zod.object({
            id: zod.uuid(),
            subject: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            from_address: zod.union([zod.string(), zod.null()]),
            received_at: zod.iso.datetime({ offset: true }),
        })
    ),
});

export type StartSuggestions = zod.input<typeof StartSuggestions>;
export type StartSuggestionsOutput = zod.output<typeof StartSuggestions>;

export const StartClient = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
});

export type StartClient = zod.input<typeof StartClient>;
export type StartClientOutput = zod.output<typeof StartClient>;

export const StartCreatedClient = zod.object({
    client: zod.object({
        id: zod.uuid(),
        slug: zod.string(),
        name: zod.string(),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
    projects: zod.array(zod.string()),
    persons: zod.array(
        zod.object({
            name: zod.string(),
            email: zod.string(),
            job_title: zod.union([zod.string(), zod.null()]),
        })
    ),
});

export type StartCreatedClient = zod.input<typeof StartCreatedClient>;
export type StartCreatedClientOutput = zod.output<typeof StartCreatedClient>;

export const Start = zod.object({
    step: zod.enum(['forward', 'clients', 'invite', 'publish', 'connect']),
    skipped_steps: zod.array(zod.enum(['clients', 'invite', 'publish'])),
    suggestions: zod.union([
        zod.object({
            status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            processing_count: zod.int(),
            clients: zod.array(
                zod.object({
                    name: zod.string(),
                    domain: zod.string(),
                    projects: zod.array(
                        zod.object({
                            name: zod.string(),
                            source_ids: zod.array(zod.uuid()),
                        })
                    ),
                    source_ids: zod.array(zod.uuid()),
                    persons: zod.array(
                        zod.object({
                            name: zod.string(),
                            email: zod.string(),
                            job_title: zod.union([zod.string(), zod.null()]),
                        })
                    ),
                })
            ),
            team: zod.array(
                zod.object({
                    name: zod.string(),
                    email: zod.string(),
                    job_title: zod.union([zod.string(), zod.null()]),
                })
            ),
            unassigned_source_ids: zod.array(zod.uuid()),
            emails: zod.array(
                zod.object({
                    id: zod.uuid(),
                    subject: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    from_address: zod.union([zod.string(), zod.null()]),
                    received_at: zod.iso.datetime({ offset: true }),
                })
            ),
        }),
        zod.null(),
    ]),
    created_clients: zod.array(
        zod.object({
            client: zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
                logo_url: zod.union([zod.string(), zod.null()]),
            }),
            projects: zod.array(zod.string()),
            persons: zod.array(
                zod.object({
                    name: zod.string(),
                    email: zod.string(),
                    job_title: zod.union([zod.string(), zod.null()]),
                })
            ),
        })
    ),
    drafts: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            title: zod.union([zod.string(), zod.null()]),
            summary: zod.union([zod.string(), zod.null()]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.union([
                zod.object({
                    number: zod.int(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            has_draft: zod.boolean(),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            acknowledger_count: zod.int(),
            acknowledged_count: zod.int(),
            sources: zod.array(
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            digest: zod.object({
                summary: zod.union([zod.string(), zod.null()]),
                person_count: zod.int(),
                topic_count: zod.int(),
                decision_count: zod.int(),
                todo_count: zod.int(),
                event_count: zod.int(),
            }),
            created_at: zod.iso.datetime({ offset: true }),
            permissions: zod.object({
                can_process: zod.boolean(),
                can_edit: zod.boolean(),
                can_publish: zod.boolean(),
                can_discard_draft: zod.boolean(),
                can_change_acknowledgers: zod.boolean(),
                can_create_public_link: zod.boolean(),
                can_delete: zod.boolean(),
            }),
            has_changes: zod.boolean(),
        })
    ),
    can_invite_team: zod.boolean(),
    inbox: zod.union([
        zod.object({
            name: zod.string(),
            url: zod.string(),
        }),
        zod.null(),
    ]),
});

export type Start = zod.input<typeof Start>;
export type StartOutput = zod.output<typeof Start>;

export const HomeTodoPermissions = zod.object({
    can_mark_done: zod.boolean(),
});

export type HomeTodoPermissions = zod.input<typeof HomeTodoPermissions>;
export type HomeTodoPermissionsOutput = zod.output<typeof HomeTodoPermissions>;

export const HomeTodo = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    person: zod.union([
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    recap: zod.object({
        id: zod.uuid(),
        public_id: zod.string(),
        slug: zod.string(),
        title: zod.union([zod.string(), zod.null()]),
        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    }),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    permissions: zod.object({
        can_mark_done: zod.boolean(),
    }),
});

export type HomeTodo = zod.input<typeof HomeTodo>;
export type HomeTodoOutput = zod.output<typeof HomeTodo>;

export const HomeEvent = zod.object({
    id: zod.uuid(),
    title: zod.string(),
    date: zod.iso.date(),
    time: zod.union([zod.iso.time({}), zod.null()]),
    recap: zod.object({
        id: zod.uuid(),
        public_id: zod.string(),
        slug: zod.string(),
        title: zod.union([zod.string(), zod.null()]),
        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
    }),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
});

export type HomeEvent = zod.input<typeof HomeEvent>;
export type HomeEventOutput = zod.output<typeof HomeEvent>;

export const HomeActivity = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'source_received',
        'source_failed',
        'source_updated',
        'source_processed_again',
        'source_changed',
        'recap_created',
        'recap_drafted',
        'recap_failed',
        'version_published',
        'todo_done',
        'todo_undone',
        'item_superseded',
        'comment_added',
        'recap_acknowledged',
        'acknowledger_removed',
        'recap_processed_again',
        'recap_sources_changed',
        'draft_discarded',
        'version_restored',
        'recap_moved',
        'source_moved',
        'public_link_created',
        'public_link_removed',
        'recap_deleted',
        'source_deleted',
        'client_created',
        'client_renamed',
        'client_deleted',
        'project_created',
        'project_renamed',
        'project_deleted',
        'project_client_changed',
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    affected_user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    recap: zod.union([
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
        }),
        zod.null(),
    ]),
    source: zod.union([
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    version_number: zod.union([zod.int(), zod.null()]),
    item_title: zod.union([zod.string(), zod.null()]),
    version: zod.union([
        zod.object({
            number: zod.int(),
            is_acknowledgement_required: zod.boolean(),
            changes: zod.union([
                zod.object({
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                    items: zod.array(
                        zod.object({
                            kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                            id: zod.uuid(),
                            title: zod.string(),
                            change: zod.enum(['added', 'removed', 'changed']),
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                        })
                    ),
                    is_text_only: zod.boolean(),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    comment: zod.union([
        zod.object({
            id: zod.uuid(),
            author: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            text: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
            edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
            item_id: zod.union([zod.uuid(), zod.null()]),
            version_number: zod.union([zod.int(), zod.null()]),
            is_on_draft: zod.boolean(),
            is_reply: zod.boolean(),
            reply_to: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
});

export type HomeActivity = zod.input<typeof HomeActivity>;
export type HomeActivityOutput = zod.output<typeof HomeActivity>;

export const SourceListItem = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    received_at: zod.iso.datetime({ offset: true }),
    email: zod.union([
        zod.object({
            id: zod.uuid(),
            from_address: zod.union([zod.string(), zod.null()]),
            from_name: zod.union([zod.string(), zod.null()]),
            to_addresses: zod.array(zod.string()),
            cc_addresses: zod.array(zod.string()),
            subject: zod.union([zod.string(), zod.null()]),
            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        }),
        zod.null(),
    ]),
    files: zod.array(
        zod.object({
            id: zod.uuid(),
            file_name: zod.string(),
            mime_type: zod.string(),
            url: zod.string(),
            page_count: zod.int(),
            size: zod.int(),
            is_email_body: zod.boolean(),
        })
    ),
    feed: zod.union([
        zod.object({
            id: zod.uuid(),
            facet: zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ]),
            connection_id: zod.uuid(),
            connection_name: zod.string(),
            connection_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    provider: zod.union([zod.string(), zod.null()]),
    provider_name: zod.union([zod.string(), zod.null()]),
    inbound_email: zod.union([zod.string(), zod.null()]),
    extraction_status: zod.enum(['processing', 'done', 'failed']),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    external_url: zod.union([zod.string(), zod.null()]),
    external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
    has_update: zod.boolean(),
    permissions: zod.object({
        can_process: zod.boolean(),
        can_take_update: zod.boolean(),
        can_delete: zod.boolean(),
    }),
});

export type SourceListItem = zod.input<typeof SourceListItem>;
export type SourceListItemOutput = zod.output<typeof SourceListItem>;

export const HomeClientInfo = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
});

export type HomeClientInfo = zod.input<typeof HomeClientInfo>;
export type HomeClientInfoOutput = zod.output<typeof HomeClientInfo>;

export const HomeClient = zod.object({
    health: zod.enum(['overdue', 'needs_recap', 'on_track']),
    open_todo_count: zod.int(),
    overdue_todo_count: zod.int(),
    open_todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    upcoming_event_count: zod.int(),
    upcoming_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    waiting_source_count: zod.int(),
    waiting_sources: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.enum(['processing', 'done', 'failed']),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            external_url: zod.union([zod.string(), zod.null()]),
            external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            has_update: zod.boolean(),
            permissions: zod.object({
                can_process: zod.boolean(),
                can_take_update: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        })
    ),
    client: zod.object({
        id: zod.uuid(),
        slug: zod.string(),
        name: zod.string(),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
});

export type HomeClient = zod.input<typeof HomeClient>;
export type HomeClientOutput = zod.output<typeof HomeClient>;

export const HomeProjectInfo = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
});

export type HomeProjectInfo = zod.input<typeof HomeProjectInfo>;
export type HomeProjectInfoOutput = zod.output<typeof HomeProjectInfo>;

export const HomeProject = zod.object({
    health: zod.enum(['overdue', 'needs_recap', 'on_track']),
    open_todo_count: zod.int(),
    overdue_todo_count: zod.int(),
    open_todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    upcoming_event_count: zod.int(),
    upcoming_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    waiting_source_count: zod.int(),
    waiting_sources: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.enum(['processing', 'done', 'failed']),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            external_url: zod.union([zod.string(), zod.null()]),
            external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            has_update: zod.boolean(),
            permissions: zod.object({
                can_process: zod.boolean(),
                can_take_update: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        })
    ),
    project: zod.object({
        id: zod.uuid(),
        slug: zod.string(),
        name: zod.string(),
        logo_url: zod.union([zod.string(), zod.null()]),
    }),
});

export type HomeProject = zod.input<typeof HomeProject>;
export type HomeProjectOutput = zod.output<typeof HomeProject>;

export const Home = zod.object({
    start: zod.union([
        zod.object({
            step: zod.enum(['forward', 'clients', 'invite', 'publish', 'connect']),
            skipped_steps: zod.array(zod.enum(['clients', 'invite', 'publish'])),
            suggestions: zod.union([
                zod.object({
                    status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    processing_count: zod.int(),
                    clients: zod.array(
                        zod.object({
                            name: zod.string(),
                            domain: zod.string(),
                            projects: zod.array(
                                zod.object({
                                    name: zod.string(),
                                    source_ids: zod.array(zod.uuid()),
                                })
                            ),
                            source_ids: zod.array(zod.uuid()),
                            persons: zod.array(
                                zod.object({
                                    name: zod.string(),
                                    email: zod.string(),
                                    job_title: zod.union([zod.string(), zod.null()]),
                                })
                            ),
                        })
                    ),
                    team: zod.array(
                        zod.object({
                            name: zod.string(),
                            email: zod.string(),
                            job_title: zod.union([zod.string(), zod.null()]),
                        })
                    ),
                    unassigned_source_ids: zod.array(zod.uuid()),
                    emails: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            subject: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            from_address: zod.union([zod.string(), zod.null()]),
                            received_at: zod.iso.datetime({ offset: true }),
                        })
                    ),
                }),
                zod.null(),
            ]),
            created_clients: zod.array(
                zod.object({
                    client: zod.object({
                        id: zod.uuid(),
                        slug: zod.string(),
                        name: zod.string(),
                        logo_url: zod.union([zod.string(), zod.null()]),
                    }),
                    projects: zod.array(zod.string()),
                    persons: zod.array(
                        zod.object({
                            name: zod.string(),
                            email: zod.string(),
                            job_title: zod.union([zod.string(), zod.null()]),
                        })
                    ),
                })
            ),
            drafts: zod.array(
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    title: zod.union([zod.string(), zod.null()]),
                    summary: zod.union([zod.string(), zod.null()]),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    published_version: zod.union([
                        zod.object({
                            number: zod.int(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    has_draft: zod.boolean(),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                    acknowledger_count: zod.int(),
                    acknowledged_count: zod.int(),
                    sources: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            kind: zod.enum([
                                'upload',
                                'email',
                                'mobile',
                                'document',
                                'link',
                                'ticket',
                                'calendar_event',
                                'meeting',
                                'conversation',
                            ]),
                            received_at: zod.iso.datetime({ offset: true }),
                            email: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    from_address: zod.union([zod.string(), zod.null()]),
                                    from_name: zod.union([zod.string(), zod.null()]),
                                    to_addresses: zod.array(zod.string()),
                                    cc_addresses: zod.array(zod.string()),
                                    subject: zod.union([zod.string(), zod.null()]),
                                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    digest: zod.object({
                        summary: zod.union([zod.string(), zod.null()]),
                        person_count: zod.int(),
                        topic_count: zod.int(),
                        decision_count: zod.int(),
                        todo_count: zod.int(),
                        event_count: zod.int(),
                    }),
                    created_at: zod.iso.datetime({ offset: true }),
                    permissions: zod.object({
                        can_process: zod.boolean(),
                        can_edit: zod.boolean(),
                        can_publish: zod.boolean(),
                        can_discard_draft: zod.boolean(),
                        can_change_acknowledgers: zod.boolean(),
                        can_create_public_link: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                    has_changes: zod.boolean(),
                })
            ),
            can_invite_team: zod.boolean(),
            inbox: zod.union([
                zod.object({
                    name: zod.string(),
                    url: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    my_todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    awaited_todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    week_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    next_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    news: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'source_received',
                'source_failed',
                'source_updated',
                'source_processed_again',
                'source_changed',
                'recap_created',
                'recap_drafted',
                'recap_failed',
                'version_published',
                'todo_done',
                'todo_undone',
                'item_superseded',
                'comment_added',
                'recap_acknowledged',
                'acknowledger_removed',
                'recap_processed_again',
                'recap_sources_changed',
                'draft_discarded',
                'version_restored',
                'recap_moved',
                'source_moved',
                'public_link_created',
                'public_link_removed',
                'recap_deleted',
                'source_deleted',
                'client_created',
                'client_renamed',
                'client_deleted',
                'project_created',
                'project_renamed',
                'project_deleted',
                'project_client_changed',
            ]),
            created_at: zod.iso.datetime({ offset: true }),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            affected_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            recap: zod.union([
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
                zod.null(),
            ]),
            source: zod.union([
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            version_number: zod.union([zod.int(), zod.null()]),
            item_title: zod.union([zod.string(), zod.null()]),
            version: zod.union([
                zod.object({
                    number: zod.int(),
                    is_acknowledgement_required: zod.boolean(),
                    changes: zod.union([
                        zod.object({
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                            items: zod.array(
                                zod.object({
                                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                                    id: zod.uuid(),
                                    title: zod.string(),
                                    change: zod.enum(['added', 'removed', 'changed']),
                                    fields: zod.array(
                                        zod.object({
                                            field: zod.enum([
                                                'title',
                                                'summary',
                                                'description',
                                                'name',
                                                'email',
                                                'company',
                                                'job_title',
                                                'is_participant',
                                                'user',
                                                'topic',
                                                'person',
                                                'due_date',
                                                'date',
                                                'time',
                                            ]),
                                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                        })
                                    ),
                                })
                            ),
                            is_text_only: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    digest: zod.union([
                        zod.object({
                            summary: zod.union([zod.string(), zod.null()]),
                            person_count: zod.int(),
                            topic_count: zod.int(),
                            decision_count: zod.int(),
                            todo_count: zod.int(),
                            event_count: zod.int(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            comment: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
                    item_id: zod.union([zod.uuid(), zod.null()]),
                    version_number: zod.union([zod.int(), zod.null()]),
                    is_on_draft: zod.boolean(),
                    is_reply: zod.boolean(),
                    reply_to: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            author: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                            text: zod.string(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_edit: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        })
    ),
    done_this_week_count: zod.int(),
    done_per_day: zod.array(zod.int()),
    received_per_day: zod.array(zod.int()),
    clients: zod.array(
        zod.object({
            health: zod.enum(['overdue', 'needs_recap', 'on_track']),
            open_todo_count: zod.int(),
            overdue_todo_count: zod.int(),
            open_todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    recap: zod.object({
                        id: zod.uuid(),
                        public_id: zod.string(),
                        slug: zod.string(),
                        title: zod.union([zod.string(), zod.null()]),
                        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                    }),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            upcoming_event_count: zod.int(),
            upcoming_events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    recap: zod.object({
                        id: zod.uuid(),
                        public_id: zod.string(),
                        slug: zod.string(),
                        title: zod.union([zod.string(), zod.null()]),
                        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                    }),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            waiting_source_count: zod.int(),
            waiting_sources: zod.array(
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.enum(['processing', 'done', 'failed']),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    external_url: zod.union([zod.string(), zod.null()]),
                    external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    has_update: zod.boolean(),
                    permissions: zod.object({
                        can_process: zod.boolean(),
                        can_take_update: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                })
            ),
            client: zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
                logo_url: zod.union([zod.string(), zod.null()]),
            }),
        })
    ),
    projects: zod.array(
        zod.object({
            health: zod.enum(['overdue', 'needs_recap', 'on_track']),
            open_todo_count: zod.int(),
            overdue_todo_count: zod.int(),
            open_todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    recap: zod.object({
                        id: zod.uuid(),
                        public_id: zod.string(),
                        slug: zod.string(),
                        title: zod.union([zod.string(), zod.null()]),
                        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                    }),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            upcoming_event_count: zod.int(),
            upcoming_events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    recap: zod.object({
                        id: zod.uuid(),
                        public_id: zod.string(),
                        slug: zod.string(),
                        title: zod.union([zod.string(), zod.null()]),
                        extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                    }),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            waiting_source_count: zod.int(),
            waiting_sources: zod.array(
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.enum(['processing', 'done', 'failed']),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    external_url: zod.union([zod.string(), zod.null()]),
                    external_edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    has_update: zod.boolean(),
                    permissions: zod.object({
                        can_process: zod.boolean(),
                        can_take_update: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                })
            ),
            project: zod.object({
                id: zod.uuid(),
                slug: zod.string(),
                name: zod.string(),
                logo_url: zod.union([zod.string(), zod.null()]),
            }),
        })
    ),
});

export type Home = zod.input<typeof Home>;
export type HomeOutput = zod.output<typeof Home>;

export const startClientCreateNameMax = 200;

export const startClientCreateProjectsDefault = [];
export const startClientCreateSourceIdsDefault = [];
export const StartClientCreate = zod.object({
    key: zod.union([zod.string(), zod.null()]).optional(),
    name: zod.string().min(1).max(startClientCreateNameMax),
    projects: zod
        .array(
            zod.object({
                name: zod.string(),
                source_ids: zod.array(zod.uuid()),
            })
        )
        .default(startClientCreateProjectsDefault),
    source_ids: zod.array(zod.uuid()).default(startClientCreateSourceIdsDefault),
});

export type StartClientCreate = zod.input<typeof StartClientCreate>;
export type StartClientCreateOutput = zod.output<typeof StartClientCreate>;

export const startStepPassIsSkippedDefault = false;
export const StartStepPass = zod.object({
    step: zod.enum(['clients', 'invite', 'publish']),
    is_skipped: zod.boolean().default(startStepPassIsSkippedDefault),
});

export type StartStepPass = zod.input<typeof StartStepPass>;
export type StartStepPassOutput = zod.output<typeof StartStepPass>;

export const Attention = zod.object({
    due_todo_count: zod.int(),
    has_overdue_todos: zod.boolean(),
    has_new_home: zod.boolean(),
    has_new_activities: zod.boolean(),
    draft_count: zod.int(),
    has_failed_drafts: zod.boolean(),
    has_new_recaps: zod.boolean(),
    has_new_clients: zod.boolean(),
    unfiled_source_count: zod.int(),
    has_failed_sources: zod.boolean(),
    has_new_sources: zod.boolean(),
    has_failing_feeds: zod.boolean(),
    has_own_failing_feeds: zod.boolean(),
});

export type Attention = zod.input<typeof Attention>;
export type AttentionOutput = zod.output<typeof Attention>;

export const Activity = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'source_received',
        'source_failed',
        'source_updated',
        'source_processed_again',
        'source_changed',
        'recap_created',
        'recap_drafted',
        'recap_failed',
        'version_published',
        'todo_done',
        'todo_undone',
        'item_superseded',
        'comment_added',
        'recap_acknowledged',
        'acknowledger_removed',
        'recap_processed_again',
        'recap_sources_changed',
        'draft_discarded',
        'version_restored',
        'recap_moved',
        'source_moved',
        'public_link_created',
        'public_link_removed',
        'recap_deleted',
        'source_deleted',
        'client_created',
        'client_renamed',
        'client_deleted',
        'project_created',
        'project_renamed',
        'project_deleted',
        'project_client_changed',
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    affected_user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    recap: zod.union([
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
        }),
        zod.null(),
    ]),
    source: zod.union([
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    version_number: zod.union([zod.int(), zod.null()]),
    item_title: zod.union([zod.string(), zod.null()]),
    version: zod.union([
        zod.object({
            number: zod.int(),
            is_acknowledgement_required: zod.boolean(),
            changes: zod.union([
                zod.object({
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                    items: zod.array(
                        zod.object({
                            kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                            id: zod.uuid(),
                            title: zod.string(),
                            change: zod.enum(['added', 'removed', 'changed']),
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                        })
                    ),
                    is_text_only: zod.boolean(),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    comment: zod.union([
        zod.object({
            id: zod.uuid(),
            author: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            text: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
            edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
            item_id: zod.union([zod.uuid(), zod.null()]),
            version_number: zod.union([zod.int(), zod.null()]),
            is_on_draft: zod.boolean(),
            is_reply: zod.boolean(),
            reply_to: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
});

export type Activity = zod.input<typeof Activity>;
export type ActivityOutput = zod.output<typeof Activity>;

export const RecapNews = zod.object({
    news: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'source_received',
                'source_failed',
                'source_updated',
                'source_processed_again',
                'source_changed',
                'recap_created',
                'recap_drafted',
                'recap_failed',
                'version_published',
                'todo_done',
                'todo_undone',
                'item_superseded',
                'comment_added',
                'recap_acknowledged',
                'acknowledger_removed',
                'recap_processed_again',
                'recap_sources_changed',
                'draft_discarded',
                'version_restored',
                'recap_moved',
                'source_moved',
                'public_link_created',
                'public_link_removed',
                'recap_deleted',
                'source_deleted',
                'client_created',
                'client_renamed',
                'client_deleted',
                'project_created',
                'project_renamed',
                'project_deleted',
                'project_client_changed',
            ]),
            created_at: zod.iso.datetime({ offset: true }),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            affected_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            recap: zod.union([
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
                zod.null(),
            ]),
            source: zod.union([
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            version_number: zod.union([zod.int(), zod.null()]),
            item_title: zod.union([zod.string(), zod.null()]),
            version: zod.union([
                zod.object({
                    number: zod.int(),
                    is_acknowledgement_required: zod.boolean(),
                    changes: zod.union([
                        zod.object({
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                            items: zod.array(
                                zod.object({
                                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                                    id: zod.uuid(),
                                    title: zod.string(),
                                    change: zod.enum(['added', 'removed', 'changed']),
                                    fields: zod.array(
                                        zod.object({
                                            field: zod.enum([
                                                'title',
                                                'summary',
                                                'description',
                                                'name',
                                                'email',
                                                'company',
                                                'job_title',
                                                'is_participant',
                                                'user',
                                                'topic',
                                                'person',
                                                'due_date',
                                                'date',
                                                'time',
                                            ]),
                                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                        })
                                    ),
                                })
                            ),
                            is_text_only: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    digest: zod.union([
                        zod.object({
                            summary: zod.union([zod.string(), zod.null()]),
                            person_count: zod.int(),
                            topic_count: zod.int(),
                            decision_count: zod.int(),
                            todo_count: zod.int(),
                            event_count: zod.int(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            comment: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
                    item_id: zod.union([zod.uuid(), zod.null()]),
                    version_number: zod.union([zod.int(), zod.null()]),
                    is_on_draft: zod.boolean(),
                    is_reply: zod.boolean(),
                    reply_to: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            author: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                            text: zod.string(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_edit: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        })
    ),
    changed_item_ids: zod.array(zod.uuid()),
    is_summary_changed: zod.boolean(),
});

export type RecapNews = zod.input<typeof RecapNews>;
export type RecapNewsOutput = zod.output<typeof RecapNews>;

export const NotificationDelivery = zod.enum(['immediately', 'daily', 'never']);

export type NotificationDelivery = zod.input<typeof NotificationDelivery>;
export type NotificationDeliveryOutput = zod.output<typeof NotificationDelivery>;

export const NotificationKind = zod.enum([
    'source_received',
    'source_failed',
    'recap_created',
    'recap_drafted',
    'version_published',
    'todo_ticked',
    'comment_added',
    'acknowledgement_requested',
    'recap_acknowledged',
    'feed_failed',
    'todo_due',
]);

export type NotificationKind = zod.input<typeof NotificationKind>;
export type NotificationKindOutput = zod.output<typeof NotificationKind>;

export const NotificationSetting = zod.object({
    kind: zod.enum([
        'source_received',
        'source_failed',
        'recap_created',
        'recap_drafted',
        'version_published',
        'todo_ticked',
        'comment_added',
        'acknowledgement_requested',
        'recap_acknowledged',
        'feed_failed',
        'todo_due',
    ]),
    delivery: zod.enum(['immediately', 'daily', 'never']),
    default_delivery: zod.enum(['immediately', 'daily', 'never']),
});

export type NotificationSetting = zod.input<typeof NotificationSetting>;
export type NotificationSettingOutput = zod.output<typeof NotificationSetting>;

export const NotificationSettingUpdate = zod.object({
    kind: zod.enum([
        'source_received',
        'source_failed',
        'recap_created',
        'recap_drafted',
        'version_published',
        'todo_ticked',
        'comment_added',
        'acknowledgement_requested',
        'recap_acknowledged',
        'feed_failed',
        'todo_due',
    ]),
    delivery: zod.enum(['immediately', 'daily', 'never']),
});

export type NotificationSettingUpdate = zod.input<typeof NotificationSettingUpdate>;
export type NotificationSettingUpdateOutput = zod.output<typeof NotificationSettingUpdate>;

export const RecapMute = zod.object({
    is_muted: zod.boolean(),
});

export type RecapMute = zod.input<typeof RecapMute>;
export type RecapMuteOutput = zod.output<typeof RecapMute>;

export const TeamMember = zod.object({
    id: zod.uuid(),
    first_name: zod.string(),
    last_name: zod.string(),
    display_name: zod.string(),
    email: zod.union([zod.email(), zod.null()]),
    avatar_url: zod.union([zod.string(), zod.null()]),
    is_disabled: zod.boolean(),
    is_deleted: zod.boolean(),
    is_api: zod.boolean(),
    job_title: zod.union([zod.string(), zod.null()]),
});

export type TeamMember = zod.input<typeof TeamMember>;
export type TeamMemberOutput = zod.output<typeof TeamMember>;

export const EmployeeProject = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    recap_count: zod.int(),
    logo_url: zod.union([zod.string(), zod.null()]),
    team: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
            job_title: zod.union([zod.string(), zod.null()]),
        })
    ),
    email_address: zod.union([zod.string(), zod.null()]),
});

export type EmployeeProject = zod.input<typeof EmployeeProject>;
export type EmployeeProjectOutput = zod.output<typeof EmployeeProject>;

export const EmployeeClientDetail = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    logo_url: zod.union([zod.string(), zod.null()]),
    projects: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            recap_count: zod.int(),
            logo_url: zod.union([zod.string(), zod.null()]),
            team: zod.array(
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                    job_title: zod.union([zod.string(), zod.null()]),
                })
            ),
            email_address: zod.union([zod.string(), zod.null()]),
        })
    ),
    team: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
            job_title: zod.union([zod.string(), zod.null()]),
        })
    ),
    email_address: zod.union([zod.string(), zod.null()]),
});

export type EmployeeClientDetail = zod.input<typeof EmployeeClientDetail>;
export type EmployeeClientDetailOutput = zod.output<typeof EmployeeClientDetail>;

export const EmployeeRecapFilters = zod.object({
    search: zod.union([zod.string(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type EmployeeRecapFilters = zod.input<typeof EmployeeRecapFilters>;
export type EmployeeRecapFiltersOutput = zod.output<typeof EmployeeRecapFilters>;

export const EmployeeRecapListItem = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    published_version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
    }),
    has_changes: zod.boolean(),
});

export type EmployeeRecapListItem = zod.input<typeof EmployeeRecapListItem>;
export type EmployeeRecapListItemOutput = zod.output<typeof EmployeeRecapListItem>;

export const PagedEmployeeRecapListItem = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.object({
                number: zod.int(),
                created_at: zod.iso.datetime({ offset: true }),
            }),
            has_changes: zod.boolean(),
        })
    ),
    count: zod.int(),
});

export type PagedEmployeeRecapListItem = zod.input<typeof PagedEmployeeRecapListItem>;
export type PagedEmployeeRecapListItemOutput = zod.output<typeof PagedEmployeeRecapListItem>;

export const RecapVersionDetail = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
    published_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    acknowledgements: zod.array(
        zod.object({
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            created_at: zod.iso.datetime({ offset: true }),
        })
    ),
    title: zod.union([zod.string(), zod.null()]),
    summary: zod.union([zod.string(), zod.null()]),
    persons: zod.array(
        zod.object({
            id: zod.uuid(),
            name: zod.string(),
            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
            company: zod.union([zod.string(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            email: zod.union([zod.string(), zod.null()]),
            job_title: zod.union([zod.string(), zod.null()]),
            is_participant: zod.boolean(),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
        })
    ),
    topics: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            summary: zod.union([zod.string(), zod.null()]),
            citations: zod.array(
                zod.object({
                    id: zod.uuid(),
                    quote: zod.string(),
                    source_file: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            is_email_body: zod.boolean(),
                            source_id: zod.uuid(),
                        }),
                        zod.null(),
                    ]),
                })
            ),
            decisions: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                })
            ),
            todos: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    person: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            name: zod.string(),
                            side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                            company: zod.union([zod.string(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    due_date: zod.union([zod.iso.date(), zod.null()]),
                    is_done: zod.boolean(),
                    done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    done_by: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                    external_link: zod.union([
                        zod.object({
                            provider: zod.string(),
                            provider_name: zod.union([zod.string(), zod.null()]),
                            url: zod.string(),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_mark_done: zod.boolean(),
                    }),
                })
            ),
            events: zod.array(
                zod.object({
                    id: zod.uuid(),
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    date: zod.iso.date(),
                    time: zod.union([zod.iso.time({}), zod.null()]),
                    citations: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            quote: zod.string(),
                            source_file: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    file_name: zod.string(),
                                    is_email_body: zod.boolean(),
                                    source_id: zod.uuid(),
                                }),
                                zod.null(),
                            ]),
                        })
                    ),
                    links: zod.object({
                        supersedes: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                        superseded_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                title: zod.union([zod.string(), zod.null()]),
                                recap: zod.object({
                                    id: zod.uuid(),
                                    public_id: zod.string(),
                                    slug: zod.string(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    extraction_status: zod.union([
                                        zod.enum(['processing', 'done', 'failed']),
                                        zod.null(),
                                    ]),
                                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                }),
                            }),
                            zod.null(),
                        ]),
                    }),
                })
            ),
        })
    ),
});

export type RecapVersionDetail = zod.input<typeof RecapVersionDetail>;
export type RecapVersionDetailOutput = zod.output<typeof RecapVersionDetail>;

export const EmployeeRecapPermissions = zod.object({
    can_acknowledge: zod.boolean(),
});

export type EmployeeRecapPermissions = zod.input<typeof EmployeeRecapPermissions>;
export type EmployeeRecapPermissionsOutput = zod.output<typeof EmployeeRecapPermissions>;

export const EmployeeRecap = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    published_version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
    }),
    has_changes: zod.boolean(),
    version: zod.object({
        number: zod.int(),
        created_at: zod.iso.datetime({ offset: true }),
        published_by: zod.union([
            zod.object({
                id: zod.uuid(),
                first_name: zod.string(),
                last_name: zod.string(),
                display_name: zod.string(),
                email: zod.union([zod.email(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                is_disabled: zod.boolean(),
                is_deleted: zod.boolean(),
                is_api: zod.boolean(),
            }),
            zod.null(),
        ]),
        is_acknowledgement_required: zod.boolean(),
        changes: zod.union([
            zod.object({
                fields: zod.array(
                    zod.object({
                        field: zod.enum([
                            'title',
                            'summary',
                            'description',
                            'name',
                            'email',
                            'company',
                            'job_title',
                            'is_participant',
                            'user',
                            'topic',
                            'person',
                            'due_date',
                            'date',
                            'time',
                        ]),
                        before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    })
                ),
                items: zod.array(
                    zod.object({
                        kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                        id: zod.uuid(),
                        title: zod.string(),
                        change: zod.enum(['added', 'removed', 'changed']),
                        fields: zod.array(
                            zod.object({
                                field: zod.enum([
                                    'title',
                                    'summary',
                                    'description',
                                    'name',
                                    'email',
                                    'company',
                                    'job_title',
                                    'is_participant',
                                    'user',
                                    'topic',
                                    'person',
                                    'due_date',
                                    'date',
                                    'time',
                                ]),
                                before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            })
                        ),
                    })
                ),
                is_text_only: zod.boolean(),
            }),
            zod.null(),
        ]),
        acknowledgers: zod.array(
            zod.object({
                id: zod.uuid(),
                first_name: zod.string(),
                last_name: zod.string(),
                display_name: zod.string(),
                email: zod.union([zod.email(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                is_disabled: zod.boolean(),
                is_deleted: zod.boolean(),
                is_api: zod.boolean(),
            })
        ),
        invited_acknowledgers: zod.array(
            zod.object({
                id: zod.uuid(),
                email: zod.email(),
                name: zod.string(),
            })
        ),
        acknowledgements: zod.array(
            zod.object({
                user: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        first_name: zod.string(),
                        last_name: zod.string(),
                        display_name: zod.string(),
                        email: zod.union([zod.email(), zod.null()]),
                        avatar_url: zod.union([zod.string(), zod.null()]),
                        is_disabled: zod.boolean(),
                        is_deleted: zod.boolean(),
                        is_api: zod.boolean(),
                    }),
                    zod.null(),
                ]),
                created_at: zod.iso.datetime({ offset: true }),
            })
        ),
        title: zod.union([zod.string(), zod.null()]),
        summary: zod.union([zod.string(), zod.null()]),
        persons: zod.array(
            zod.object({
                id: zod.uuid(),
                name: zod.string(),
                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                company: zod.union([zod.string(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                email: zod.union([zod.string(), zod.null()]),
                job_title: zod.union([zod.string(), zod.null()]),
                is_participant: zod.boolean(),
                user: zod.union([
                    zod.object({
                        id: zod.uuid(),
                        first_name: zod.string(),
                        last_name: zod.string(),
                        display_name: zod.string(),
                        email: zod.union([zod.email(), zod.null()]),
                        avatar_url: zod.union([zod.string(), zod.null()]),
                        is_disabled: zod.boolean(),
                        is_deleted: zod.boolean(),
                        is_api: zod.boolean(),
                    }),
                    zod.null(),
                ]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
            })
        ),
        topics: zod.array(
            zod.object({
                id: zod.uuid(),
                title: zod.string(),
                summary: zod.union([zod.string(), zod.null()]),
                citations: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        quote: zod.string(),
                        source_file: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                file_name: zod.string(),
                                is_email_body: zod.boolean(),
                                source_id: zod.uuid(),
                            }),
                            zod.null(),
                        ]),
                    })
                ),
                decisions: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                    })
                ),
                todos: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        person: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                name: zod.string(),
                                side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                                company: zod.union([zod.string(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                            }),
                            zod.null(),
                        ]),
                        due_date: zod.union([zod.iso.date(), zod.null()]),
                        is_done: zod.boolean(),
                        done_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        done_by: zod.union([
                            zod.object({
                                id: zod.uuid(),
                                first_name: zod.string(),
                                last_name: zod.string(),
                                display_name: zod.string(),
                                email: zod.union([zod.email(), zod.null()]),
                                avatar_url: zod.union([zod.string(), zod.null()]),
                                is_disabled: zod.boolean(),
                                is_deleted: zod.boolean(),
                                is_api: zod.boolean(),
                            }),
                            zod.null(),
                        ]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                        external_link: zod.union([
                            zod.object({
                                provider: zod.string(),
                                provider_name: zod.union([zod.string(), zod.null()]),
                                url: zod.string(),
                            }),
                            zod.null(),
                        ]),
                        permissions: zod.object({
                            can_mark_done: zod.boolean(),
                        }),
                    })
                ),
                events: zod.array(
                    zod.object({
                        id: zod.uuid(),
                        title: zod.string(),
                        description: zod.union([zod.string(), zod.null()]),
                        date: zod.iso.date(),
                        time: zod.union([zod.iso.time({}), zod.null()]),
                        citations: zod.array(
                            zod.object({
                                id: zod.uuid(),
                                quote: zod.string(),
                                source_file: zod.union([
                                    zod.object({
                                        id: zod.uuid(),
                                        file_name: zod.string(),
                                        is_email_body: zod.boolean(),
                                        source_id: zod.uuid(),
                                    }),
                                    zod.null(),
                                ]),
                            })
                        ),
                        links: zod.object({
                            supersedes: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                            superseded_by: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    title: zod.union([zod.string(), zod.null()]),
                                    recap: zod.object({
                                        id: zod.uuid(),
                                        public_id: zod.string(),
                                        slug: zod.string(),
                                        title: zod.union([zod.string(), zod.null()]),
                                        extraction_status: zod.union([
                                            zod.enum(['processing', 'done', 'failed']),
                                            zod.null(),
                                        ]),
                                        automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                                    }),
                                }),
                                zod.null(),
                            ]),
                        }),
                    })
                ),
            })
        ),
    }),
    acknowledgers: zod.array(
        zod.object({
            user: zod.object({
                id: zod.uuid(),
                first_name: zod.string(),
                last_name: zod.string(),
                display_name: zod.string(),
                email: zod.union([zod.email(), zod.null()]),
                avatar_url: zod.union([zod.string(), zod.null()]),
                is_disabled: zod.boolean(),
                is_deleted: zod.boolean(),
                is_api: zod.boolean(),
            }),
            has_acknowledged: zod.boolean(),
            acknowledged_version_number: zod.union([zod.int(), zod.null()]),
            acknowledged_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    changes_since_acknowledged: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    is_muted: zod.boolean(),
    permissions: zod.object({
        can_acknowledge: zod.boolean(),
    }),
});

export type EmployeeRecap = zod.input<typeof EmployeeRecap>;
export type EmployeeRecapOutput = zod.output<typeof EmployeeRecap>;

export const EmployeeRecapVersionListItem = zod.object({
    number: zod.int(),
    created_at: zod.iso.datetime({ offset: true }),
    published_by: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        })
    ),
    invited_acknowledgers: zod.array(
        zod.object({
            id: zod.uuid(),
            email: zod.email(),
            name: zod.string(),
        })
    ),
    acknowledgements: zod.array(
        zod.object({
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            created_at: zod.iso.datetime({ offset: true }),
        })
    ),
});

export type EmployeeRecapVersionListItem = zod.input<typeof EmployeeRecapVersionListItem>;
export type EmployeeRecapVersionListItemOutput = zod.output<typeof EmployeeRecapVersionListItem>;

export const employeeCommentCreateTextMax = 10000;

export const EmployeeCommentCreate = zod.object({
    text: zod.string().min(1).max(employeeCommentCreateTextMax),
    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
    item_id: zod.union([zod.uuid(), zod.null()]),
    version_number: zod.union([zod.int(), zod.null()]),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type EmployeeCommentCreate = zod.input<typeof EmployeeCommentCreate>;
export type EmployeeCommentCreateOutput = zod.output<typeof EmployeeCommentCreate>;

export const EmployeeRecapSummary = zod.object({
    id: zod.uuid(),
    public_id: zod.string(),
    slug: zod.string(),
    title: zod.union([zod.string(), zod.null()]),
    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
});

export type EmployeeRecapSummary = zod.input<typeof EmployeeRecapSummary>;
export type EmployeeRecapSummaryOutput = zod.output<typeof EmployeeRecapSummary>;

export const EmployeeActivityVersion = zod.object({
    number: zod.int(),
    is_acknowledgement_required: zod.boolean(),
    changes: zod.union([
        zod.object({
            fields: zod.array(
                zod.object({
                    field: zod.enum([
                        'title',
                        'summary',
                        'description',
                        'name',
                        'email',
                        'company',
                        'job_title',
                        'is_participant',
                        'user',
                        'topic',
                        'person',
                        'due_date',
                        'date',
                        'time',
                    ]),
                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                })
            ),
            items: zod.array(
                zod.object({
                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                    id: zod.uuid(),
                    title: zod.string(),
                    change: zod.enum(['added', 'removed', 'changed']),
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                })
            ),
            is_text_only: zod.boolean(),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
});

export type EmployeeActivityVersion = zod.input<typeof EmployeeActivityVersion>;
export type EmployeeActivityVersionOutput = zod.output<typeof EmployeeActivityVersion>;

export const EmployeeActivity = zod.object({
    id: zod.uuid(),
    kind: zod.enum([
        'source_received',
        'source_failed',
        'source_updated',
        'source_processed_again',
        'source_changed',
        'recap_created',
        'recap_drafted',
        'recap_failed',
        'version_published',
        'todo_done',
        'todo_undone',
        'item_superseded',
        'comment_added',
        'recap_acknowledged',
        'acknowledger_removed',
        'recap_processed_again',
        'recap_sources_changed',
        'draft_discarded',
        'version_restored',
        'recap_moved',
        'source_moved',
        'public_link_created',
        'public_link_removed',
        'recap_deleted',
        'source_deleted',
        'client_created',
        'client_renamed',
        'client_deleted',
        'project_created',
        'project_renamed',
        'project_deleted',
        'project_client_changed',
    ]),
    created_at: zod.iso.datetime({ offset: true }),
    user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    affected_user: zod.union([
        zod.object({
            id: zod.uuid(),
            first_name: zod.string(),
            last_name: zod.string(),
            display_name: zod.string(),
            email: zod.union([zod.email(), zod.null()]),
            avatar_url: zod.union([zod.string(), zod.null()]),
            is_disabled: zod.boolean(),
            is_deleted: zod.boolean(),
            is_api: zod.boolean(),
        }),
        zod.null(),
    ]),
    recap: zod.union([
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
            automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
        }),
        zod.null(),
    ]),
    source: zod.union([
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'upload',
                'email',
                'mobile',
                'document',
                'link',
                'ticket',
                'calendar_event',
                'meeting',
                'conversation',
            ]),
            received_at: zod.iso.datetime({ offset: true }),
            email: zod.union([
                zod.object({
                    id: zod.uuid(),
                    from_address: zod.union([zod.string(), zod.null()]),
                    from_name: zod.union([zod.string(), zod.null()]),
                    to_addresses: zod.array(zod.string()),
                    cc_addresses: zod.array(zod.string()),
                    subject: zod.union([zod.string(), zod.null()]),
                    received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                }),
                zod.null(),
            ]),
            files: zod.array(
                zod.object({
                    id: zod.uuid(),
                    file_name: zod.string(),
                    mime_type: zod.string(),
                    url: zod.string(),
                    page_count: zod.int(),
                    size: zod.int(),
                    is_email_body: zod.boolean(),
                })
            ),
            feed: zod.union([
                zod.object({
                    id: zod.uuid(),
                    facet: zod.enum([
                        'email',
                        'meeting',
                        'document',
                        'task',
                        'conversation',
                        'calendar',
                        'events',
                        'todos',
                        'recaps',
                        'clients',
                    ]),
                    connection_id: zod.uuid(),
                    connection_name: zod.string(),
                    connection_user: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            provider: zod.union([zod.string(), zod.null()]),
            provider_name: zod.union([zod.string(), zod.null()]),
            inbound_email: zod.union([zod.string(), zod.null()]),
        }),
        zod.null(),
    ]),
    client: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
        }),
        zod.null(),
    ]),
    project: zod.union([
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    version_number: zod.union([zod.int(), zod.null()]),
    item_title: zod.union([zod.string(), zod.null()]),
    version: zod.union([
        zod.object({
            number: zod.int(),
            is_acknowledgement_required: zod.boolean(),
            changes: zod.union([
                zod.object({
                    fields: zod.array(
                        zod.object({
                            field: zod.enum([
                                'title',
                                'summary',
                                'description',
                                'name',
                                'email',
                                'company',
                                'job_title',
                                'is_participant',
                                'user',
                                'topic',
                                'person',
                                'due_date',
                                'date',
                                'time',
                            ]),
                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                        })
                    ),
                    items: zod.array(
                        zod.object({
                            kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                            id: zod.uuid(),
                            title: zod.string(),
                            change: zod.enum(['added', 'removed', 'changed']),
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                        })
                    ),
                    is_text_only: zod.boolean(),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        }),
        zod.null(),
    ]),
    comment: zod.union([
        zod.object({
            id: zod.uuid(),
            author: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            text: zod.string(),
            created_at: zod.iso.datetime({ offset: true }),
            edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
            item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
            item_id: zod.union([zod.uuid(), zod.null()]),
            version_number: zod.union([zod.int(), zod.null()]),
            is_on_draft: zod.boolean(),
            is_reply: zod.boolean(),
            reply_to: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_edit: zod.boolean(),
                can_delete: zod.boolean(),
            }),
        }),
        zod.null(),
    ]),
    digest: zod.union([
        zod.object({
            summary: zod.union([zod.string(), zod.null()]),
            person_count: zod.int(),
            topic_count: zod.int(),
            decision_count: zod.int(),
            todo_count: zod.int(),
            event_count: zod.int(),
        }),
        zod.null(),
    ]),
});

export type EmployeeActivity = zod.input<typeof EmployeeActivity>;
export type EmployeeActivityOutput = zod.output<typeof EmployeeActivity>;

export const PagedEmployeeActivity = zod.object({
    items: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'source_received',
                'source_failed',
                'source_updated',
                'source_processed_again',
                'source_changed',
                'recap_created',
                'recap_drafted',
                'recap_failed',
                'version_published',
                'todo_done',
                'todo_undone',
                'item_superseded',
                'comment_added',
                'recap_acknowledged',
                'acknowledger_removed',
                'recap_processed_again',
                'recap_sources_changed',
                'draft_discarded',
                'version_restored',
                'recap_moved',
                'source_moved',
                'public_link_created',
                'public_link_removed',
                'recap_deleted',
                'source_deleted',
                'client_created',
                'client_renamed',
                'client_deleted',
                'project_created',
                'project_renamed',
                'project_deleted',
                'project_client_changed',
            ]),
            created_at: zod.iso.datetime({ offset: true }),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            affected_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            recap: zod.union([
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
                zod.null(),
            ]),
            source: zod.union([
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            version_number: zod.union([zod.int(), zod.null()]),
            item_title: zod.union([zod.string(), zod.null()]),
            version: zod.union([
                zod.object({
                    number: zod.int(),
                    is_acknowledgement_required: zod.boolean(),
                    changes: zod.union([
                        zod.object({
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                            items: zod.array(
                                zod.object({
                                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                                    id: zod.uuid(),
                                    title: zod.string(),
                                    change: zod.enum(['added', 'removed', 'changed']),
                                    fields: zod.array(
                                        zod.object({
                                            field: zod.enum([
                                                'title',
                                                'summary',
                                                'description',
                                                'name',
                                                'email',
                                                'company',
                                                'job_title',
                                                'is_participant',
                                                'user',
                                                'topic',
                                                'person',
                                                'due_date',
                                                'date',
                                                'time',
                                            ]),
                                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                        })
                                    ),
                                })
                            ),
                            is_text_only: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    digest: zod.union([
                        zod.object({
                            summary: zod.union([zod.string(), zod.null()]),
                            person_count: zod.int(),
                            topic_count: zod.int(),
                            decision_count: zod.int(),
                            todo_count: zod.int(),
                            event_count: zod.int(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            comment: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
                    item_id: zod.union([zod.uuid(), zod.null()]),
                    version_number: zod.union([zod.int(), zod.null()]),
                    is_on_draft: zod.boolean(),
                    is_reply: zod.boolean(),
                    reply_to: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            author: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                            text: zod.string(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_edit: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        })
    ),
    count: zod.int(),
});

export type PagedEmployeeActivity = zod.input<typeof PagedEmployeeActivity>;
export type PagedEmployeeActivityOutput = zod.output<typeof PagedEmployeeActivity>;

export const EmployeeHomeProject = zod.object({
    id: zod.uuid(),
    slug: zod.string(),
    name: zod.string(),
    recap_count: zod.int(),
    recaps: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.object({
                number: zod.int(),
                created_at: zod.iso.datetime({ offset: true }),
            }),
            has_changes: zod.boolean(),
        })
    ),
});

export type EmployeeHomeProject = zod.input<typeof EmployeeHomeProject>;
export type EmployeeHomeProjectOutput = zod.output<typeof EmployeeHomeProject>;

export const EmployeeHome = zod.object({
    my_todos: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            due_date: zod.union([zod.iso.date(), zod.null()]),
            person: zod.union([
                zod.object({
                    id: zod.uuid(),
                    name: zod.string(),
                    side: zod.union([zod.enum(['team', 'client']), zod.null()]),
                    company: zod.union([zod.string(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            permissions: zod.object({
                can_mark_done: zod.boolean(),
            }),
        })
    ),
    week_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    next_events: zod.array(
        zod.object({
            id: zod.uuid(),
            title: zod.string(),
            date: zod.iso.date(),
            time: zod.union([zod.iso.time({}), zod.null()]),
            recap: zod.object({
                id: zod.uuid(),
                public_id: zod.string(),
                slug: zod.string(),
                title: zod.union([zod.string(), zod.null()]),
                extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
            }),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
        })
    ),
    waiting_for_acknowledgement: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.object({
                number: zod.int(),
                created_at: zod.iso.datetime({ offset: true }),
            }),
            has_changes: zod.boolean(),
        })
    ),
    client_recaps: zod.array(
        zod.object({
            id: zod.uuid(),
            public_id: zod.string(),
            slug: zod.string(),
            title: zod.union([zod.string(), zod.null()]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            published_version: zod.object({
                number: zod.int(),
                created_at: zod.iso.datetime({ offset: true }),
            }),
            has_changes: zod.boolean(),
        })
    ),
    projects: zod.array(
        zod.object({
            id: zod.uuid(),
            slug: zod.string(),
            name: zod.string(),
            recap_count: zod.int(),
            recaps: zod.array(
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    project: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                            client: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    slug: zod.string(),
                                    name: zod.string(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    published_version: zod.object({
                        number: zod.int(),
                        created_at: zod.iso.datetime({ offset: true }),
                    }),
                    has_changes: zod.boolean(),
                })
            ),
        })
    ),
});

export type EmployeeHome = zod.input<typeof EmployeeHome>;
export type EmployeeHomeOutput = zod.output<typeof EmployeeHome>;

export const EmployeeAttention = zod.object({
    due_todo_count: zod.int(),
    has_overdue_todos: zod.boolean(),
    has_new_home: zod.boolean(),
    acknowledgement_count: zod.int(),
    has_new_recaps: zod.boolean(),
    has_own_failing_feeds: zod.boolean(),
});

export type EmployeeAttention = zod.input<typeof EmployeeAttention>;
export type EmployeeAttentionOutput = zod.output<typeof EmployeeAttention>;

export const EmployeeRecapNews = zod.object({
    news: zod.array(
        zod.object({
            id: zod.uuid(),
            kind: zod.enum([
                'source_received',
                'source_failed',
                'source_updated',
                'source_processed_again',
                'source_changed',
                'recap_created',
                'recap_drafted',
                'recap_failed',
                'version_published',
                'todo_done',
                'todo_undone',
                'item_superseded',
                'comment_added',
                'recap_acknowledged',
                'acknowledger_removed',
                'recap_processed_again',
                'recap_sources_changed',
                'draft_discarded',
                'version_restored',
                'recap_moved',
                'source_moved',
                'public_link_created',
                'public_link_removed',
                'recap_deleted',
                'source_deleted',
                'client_created',
                'client_renamed',
                'client_deleted',
                'project_created',
                'project_renamed',
                'project_deleted',
                'project_client_changed',
            ]),
            created_at: zod.iso.datetime({ offset: true }),
            user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            affected_user: zod.union([
                zod.object({
                    id: zod.uuid(),
                    first_name: zod.string(),
                    last_name: zod.string(),
                    display_name: zod.string(),
                    email: zod.union([zod.email(), zod.null()]),
                    avatar_url: zod.union([zod.string(), zod.null()]),
                    is_disabled: zod.boolean(),
                    is_deleted: zod.boolean(),
                    is_api: zod.boolean(),
                }),
                zod.null(),
            ]),
            recap: zod.union([
                zod.object({
                    id: zod.uuid(),
                    public_id: zod.string(),
                    slug: zod.string(),
                    title: zod.union([zod.string(), zod.null()]),
                    extraction_status: zod.union([zod.enum(['processing', 'done', 'failed']), zod.null()]),
                    automation: zod.union([zod.enum(['on_arrival', 'weekly']), zod.null()]),
                }),
                zod.null(),
            ]),
            source: zod.union([
                zod.object({
                    id: zod.uuid(),
                    kind: zod.enum([
                        'upload',
                        'email',
                        'mobile',
                        'document',
                        'link',
                        'ticket',
                        'calendar_event',
                        'meeting',
                        'conversation',
                    ]),
                    received_at: zod.iso.datetime({ offset: true }),
                    email: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            from_address: zod.union([zod.string(), zod.null()]),
                            from_name: zod.union([zod.string(), zod.null()]),
                            to_addresses: zod.array(zod.string()),
                            cc_addresses: zod.array(zod.string()),
                            subject: zod.union([zod.string(), zod.null()]),
                            received_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                        }),
                        zod.null(),
                    ]),
                    files: zod.array(
                        zod.object({
                            id: zod.uuid(),
                            file_name: zod.string(),
                            mime_type: zod.string(),
                            url: zod.string(),
                            page_count: zod.int(),
                            size: zod.int(),
                            is_email_body: zod.boolean(),
                        })
                    ),
                    feed: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            facet: zod.enum([
                                'email',
                                'meeting',
                                'document',
                                'task',
                                'conversation',
                                'calendar',
                                'events',
                                'todos',
                                'recaps',
                                'clients',
                            ]),
                            connection_id: zod.uuid(),
                            connection_name: zod.string(),
                            connection_user: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                        }),
                        zod.null(),
                    ]),
                    provider: zod.union([zod.string(), zod.null()]),
                    provider_name: zod.union([zod.string(), zod.null()]),
                    inbound_email: zod.union([zod.string(), zod.null()]),
                }),
                zod.null(),
            ]),
            client: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                }),
                zod.null(),
            ]),
            project: zod.union([
                zod.object({
                    id: zod.uuid(),
                    slug: zod.string(),
                    name: zod.string(),
                    client: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            slug: zod.string(),
                            name: zod.string(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            version_number: zod.union([zod.int(), zod.null()]),
            item_title: zod.union([zod.string(), zod.null()]),
            version: zod.union([
                zod.object({
                    number: zod.int(),
                    is_acknowledgement_required: zod.boolean(),
                    changes: zod.union([
                        zod.object({
                            fields: zod.array(
                                zod.object({
                                    field: zod.enum([
                                        'title',
                                        'summary',
                                        'description',
                                        'name',
                                        'email',
                                        'company',
                                        'job_title',
                                        'is_participant',
                                        'user',
                                        'topic',
                                        'person',
                                        'due_date',
                                        'date',
                                        'time',
                                    ]),
                                    before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                    after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                })
                            ),
                            items: zod.array(
                                zod.object({
                                    kind: zod.enum(['source_file', 'person', 'topic', 'decision', 'todo', 'event']),
                                    id: zod.uuid(),
                                    title: zod.string(),
                                    change: zod.enum(['added', 'removed', 'changed']),
                                    fields: zod.array(
                                        zod.object({
                                            field: zod.enum([
                                                'title',
                                                'summary',
                                                'description',
                                                'name',
                                                'email',
                                                'company',
                                                'job_title',
                                                'is_participant',
                                                'user',
                                                'topic',
                                                'person',
                                                'due_date',
                                                'date',
                                                'time',
                                            ]),
                                            before: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                            after: zod.union([zod.string(), zod.boolean(), zod.null()]),
                                        })
                                    ),
                                })
                            ),
                            is_text_only: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    digest: zod.union([
                        zod.object({
                            summary: zod.union([zod.string(), zod.null()]),
                            person_count: zod.int(),
                            topic_count: zod.int(),
                            decision_count: zod.int(),
                            todo_count: zod.int(),
                            event_count: zod.int(),
                        }),
                        zod.null(),
                    ]),
                }),
                zod.null(),
            ]),
            comment: zod.union([
                zod.object({
                    id: zod.uuid(),
                    author: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            first_name: zod.string(),
                            last_name: zod.string(),
                            display_name: zod.string(),
                            email: zod.union([zod.email(), zod.null()]),
                            avatar_url: zod.union([zod.string(), zod.null()]),
                            is_disabled: zod.boolean(),
                            is_deleted: zod.boolean(),
                            is_api: zod.boolean(),
                        }),
                        zod.null(),
                    ]),
                    text: zod.string(),
                    created_at: zod.iso.datetime({ offset: true }),
                    edited_at: zod.union([zod.iso.datetime({ offset: true }), zod.null()]),
                    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
                    item_id: zod.union([zod.uuid(), zod.null()]),
                    version_number: zod.union([zod.int(), zod.null()]),
                    is_on_draft: zod.boolean(),
                    is_reply: zod.boolean(),
                    reply_to: zod.union([
                        zod.object({
                            id: zod.uuid(),
                            author: zod.union([
                                zod.object({
                                    id: zod.uuid(),
                                    first_name: zod.string(),
                                    last_name: zod.string(),
                                    display_name: zod.string(),
                                    email: zod.union([zod.email(), zod.null()]),
                                    avatar_url: zod.union([zod.string(), zod.null()]),
                                    is_disabled: zod.boolean(),
                                    is_deleted: zod.boolean(),
                                    is_api: zod.boolean(),
                                }),
                                zod.null(),
                            ]),
                            text: zod.string(),
                            created_at: zod.iso.datetime({ offset: true }),
                        }),
                        zod.null(),
                    ]),
                    permissions: zod.object({
                        can_edit: zod.boolean(),
                        can_delete: zod.boolean(),
                    }),
                }),
                zod.null(),
            ]),
            digest: zod.union([
                zod.object({
                    summary: zod.union([zod.string(), zod.null()]),
                    person_count: zod.int(),
                    topic_count: zod.int(),
                    decision_count: zod.int(),
                    todo_count: zod.int(),
                    event_count: zod.int(),
                }),
                zod.null(),
            ]),
        })
    ),
    changed_item_ids: zod.array(zod.uuid()),
    is_summary_changed: zod.boolean(),
});

export type EmployeeRecapNews = zod.input<typeof EmployeeRecapNews>;
export type EmployeeRecapNewsOutput = zod.output<typeof EmployeeRecapNews>;

export const updateMeBodyJobTitleOneMax = 150;

export const updateMeBodyAppearanceOneColorsLightRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateMeBodyAppearanceOneColorsDarkRegExpOne = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateMeBodyAppearanceOneIsDarkDerivationEnabledDefault = true;
export const UpdateMeBody = zod.object({
    first_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    last_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    display_name: zod.union([zod.string().min(1), zod.null()]).optional(),
    job_title: zod.union([zod.string().max(updateMeBodyJobTitleOneMax), zod.null()]).optional(),
    language: zod.union([zod.enum(['de', 'en']), zod.null()]).optional(),
    appearance: zod
        .union([
            zod.object({
                theme: zod.enum(['classic', 'terracotta', 'graphite', 'navy', 'slate', 'indigo']),
                layout: zod.enum(['flat', 'tinted_rail', 'canvas', 'inset', 'dark_frame']),
                headline_font: zod.enum(['inter', 'fraunces', 'newsreader', 'hanken_grotesk', 'bricolage_grotesque']),
                colors_light: zod.record(
                    zod.string(),
                    zod.string().regex(updateMeBodyAppearanceOneColorsLightRegExpOne)
                ),
                colors_dark: zod.record(zod.string(), zod.string().regex(updateMeBodyAppearanceOneColorsDarkRegExpOne)),
                is_dark_derivation_enabled: zod
                    .boolean()
                    .default(updateMeBodyAppearanceOneIsDarkDerivationEnabledDefault),
            }),
            zod.null(),
        ])
        .optional(),
});

export type UpdateMeBody = zod.input<typeof UpdateMeBody>;
export type UpdateMeBodyOutput = zod.output<typeof UpdateMeBody>;

export const DeleteMeBody = zod.object({
    email: zod.email(),
});

export type DeleteMeBody = zod.input<typeof DeleteMeBody>;
export type DeleteMeBodyOutput = zod.output<typeof DeleteMeBody>;

export const UploadMyAvatarBody = zod.object({
    file: zod.instanceof(Blob),
});

export type UploadMyAvatarBody = zod.input<typeof UploadMyAvatarBody>;
export type UploadMyAvatarBodyOutput = zod.output<typeof UploadMyAvatarBody>;

export const ChangeEmailBody = zod.object({
    email: zod.email(),
});

export type ChangeEmailBody = zod.input<typeof ChangeEmailBody>;
export type ChangeEmailBodyOutput = zod.output<typeof ChangeEmailBody>;

export const VerifyEmailBody = zod.object({
    code: zod.string().min(1),
});

export type VerifyEmailBody = zod.input<typeof VerifyEmailBody>;
export type VerifyEmailBodyOutput = zod.output<typeof VerifyEmailBody>;

export const sendSignInCodeBodyContinuePathDefault = `/`;
export const sendSignInCodeBodyAuthQueryDefault = ``;
export const SendSignInCodeBody = zod.object({
    continue_path: zod.string().default(sendSignInCodeBodyContinuePathDefault),
    auth_query: zod.string().default(sendSignInCodeBodyAuthQueryDefault),
    language: zod.enum(['de', 'en']),
    email: zod.email(),
});

export type SendSignInCodeBody = zod.input<typeof SendSignInCodeBody>;
export type SendSignInCodeBodyOutput = zod.output<typeof SendSignInCodeBody>;

export const VerifySignInCodeBody = zod.object({
    email: zod.union([zod.email(), zod.null()]).optional(),
    code: zod.union([zod.string(), zod.null()]).optional(),
    token: zod.union([zod.string(), zod.null()]).optional(),
});

export type VerifySignInCodeBody = zod.input<typeof VerifySignInCodeBody>;
export type VerifySignInCodeBodyOutput = zod.output<typeof VerifySignInCodeBody>;

export const startSsoBodyContinuePathDefault = `/`;
export const startSsoBodyAuthQueryDefault = ``;
export const StartSsoBody = zod.object({
    continue_path: zod.string().default(startSsoBodyContinuePathDefault),
    auth_query: zod.string().default(startSsoBodyAuthQueryDefault),
    language: zod.enum(['de', 'en']),
    email_hint: zod.union([zod.email(), zod.null()]).optional(),
});

export type StartSsoBody = zod.input<typeof StartSsoBody>;
export type StartSsoBodyOutput = zod.output<typeof StartSsoBody>;

export const createWorkspaceBodyNameMax = 200;

export const createWorkspaceBodySlugMax = 40;

export const createWorkspaceBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const createWorkspaceBodyColorHueOneMin = 0;
export const createWorkspaceBodyColorHueOneMax = 359;

export const CreateWorkspaceBody = zod.object({
    name: zod.string().min(1).max(createWorkspaceBodyNameMax),
    slug: zod.string().max(createWorkspaceBodySlugMax).regex(createWorkspaceBodySlugRegExp),
    color_hue: zod.union([
        zod.int().min(createWorkspaceBodyColorHueOneMin).max(createWorkspaceBodyColorHueOneMax),
        zod.null(),
    ]),
    has_accepted_terms: zod.boolean(),
});

export type CreateWorkspaceBody = zod.input<typeof CreateWorkspaceBody>;
export type CreateWorkspaceBodyOutput = zod.output<typeof CreateWorkspaceBody>;

export const updateWorkspaceBodyNameMax = 200;

export const updateWorkspaceBodySlugMax = 40;

export const updateWorkspaceBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const updateWorkspaceBodyColorHueOneMin = 0;
export const updateWorkspaceBodyColorHueOneMax = 359;

export const UpdateWorkspaceBody = zod.object({
    name: zod.string().min(1).max(updateWorkspaceBodyNameMax),
    slug: zod.string().max(updateWorkspaceBodySlugMax).regex(updateWorkspaceBodySlugRegExp),
    color_hue: zod.union([
        zod.int().min(updateWorkspaceBodyColorHueOneMin).max(updateWorkspaceBodyColorHueOneMax),
        zod.null(),
    ]),
});

export type UpdateWorkspaceBody = zod.input<typeof UpdateWorkspaceBody>;
export type UpdateWorkspaceBodyOutput = zod.output<typeof UpdateWorkspaceBody>;

export const UploadWorkspaceLogoBody = zod.object({
    file: zod.instanceof(Blob),
});

export type UploadWorkspaceLogoBody = zod.input<typeof UploadWorkspaceLogoBody>;
export type UploadWorkspaceLogoBodyOutput = zod.output<typeof UploadWorkspaceLogoBody>;

export const updateWorkspaceEmailAddressBodyPrefixMax = 40;

export const updateWorkspaceEmailAddressBodyPrefixRegExp = new RegExp('^([a-z0-9]+(-[a-z0-9]+)*)?$');

export const UpdateWorkspaceEmailAddressBody = zod.object({
    prefix: zod
        .string()
        .max(updateWorkspaceEmailAddressBodyPrefixMax)
        .regex(updateWorkspaceEmailAddressBodyPrefixRegExp),
});

export type UpdateWorkspaceEmailAddressBody = zod.input<typeof UpdateWorkspaceEmailAddressBody>;
export type UpdateWorkspaceEmailAddressBodyOutput = zod.output<typeof UpdateWorkspaceEmailAddressBody>;

export const listPublicRecapsParamsPageDefault = 1;

export const ListPublicRecapsParams = zod.object({
    page: zod.int().min(1).default(listPublicRecapsParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListPublicRecapsParams = zod.input<typeof ListPublicRecapsParams>;
export type ListPublicRecapsParamsOutput = zod.output<typeof ListPublicRecapsParams>;

export const GetAuthorizationParams = zod.object({
    client_id: zod.string(),
    redirect_uri: zod.string(),
    response_type: zod.string(),
    code_challenge: zod.string(),
    code_challenge_method: zod.string(),
    state: zod.string().optional(),
    scope: zod.string().optional(),
    resource: zod.string().optional(),
});

export type GetAuthorizationParams = zod.input<typeof GetAuthorizationParams>;
export type GetAuthorizationParamsOutput = zod.output<typeof GetAuthorizationParams>;

export const DecideAuthorizationBody = zod.object({
    client_id: zod.string(),
    redirect_uri: zod.string(),
    response_type: zod.string(),
    code_challenge: zod.string(),
    code_challenge_method: zod.string(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    scope: zod.union([zod.string(), zod.null()]).optional(),
    resource: zod.union([zod.string(), zod.null()]).optional(),
    workspace_id: zod.uuid(),
    is_read_only: zod.boolean(),
    is_allowed: zod.boolean(),
});

export type DecideAuthorizationBody = zod.input<typeof DecideAuthorizationBody>;
export type DecideAuthorizationBodyOutput = zod.output<typeof DecideAuthorizationBody>;

export const createIssueReportBodyDescriptionMax = 5000;

export const createIssueReportBodyErrorLogDefault = ``;
export const createIssueReportBodyErrorLogMax = 20000;

export const createIssueReportBodyPageUrlMax = 2000;

export const CreateIssueReportBody = zod.object({
    description: zod.string().min(1).max(createIssueReportBodyDescriptionMax),
    error_log: zod.string().max(createIssueReportBodyErrorLogMax).default(createIssueReportBodyErrorLogDefault),
    page_url: zod.string().min(1).max(createIssueReportBodyPageUrlMax),
    workspace_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateIssueReportBody = zod.input<typeof CreateIssueReportBody>;
export type CreateIssueReportBodyOutput = zod.output<typeof CreateIssueReportBody>;

export const UpdateMemberBody = zod.object({
    role: zod.union([zod.literal('owner'), zod.null()]).optional(),
    is_disabled: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type UpdateMemberBody = zod.input<typeof UpdateMemberBody>;
export type UpdateMemberBodyOutput = zod.output<typeof UpdateMemberBody>;

export const CreateInvitationBody = zod.object({
    email: zod.union([zod.email(), zod.null()]).optional(),
});

export type CreateInvitationBody = zod.input<typeof CreateInvitationBody>;
export type CreateInvitationBodyOutput = zod.output<typeof CreateInvitationBody>;

export const createClientBodyNameMax = 200;

export const createClientBodySlugMax = 40;

export const createClientBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const createClientBodyDraftingWeekdayOneMin = 0;
export const createClientBodyDraftingWeekdayOneMax = 6;

export const CreateClientBody = zod.object({
    name: zod.string().min(1).max(createClientBodyNameMax),
    slug: zod.string().max(createClientBodySlugMax).regex(createClientBodySlugRegExp),
    address: zod.string(),
    description: zod.string(),
    drafting_weekday: zod
        .union([
            zod.int().min(createClientBodyDraftingWeekdayOneMin).max(createClientBodyDraftingWeekdayOneMax),
            zod.null(),
        ])
        .optional(),
});

export type CreateClientBody = zod.input<typeof CreateClientBody>;
export type CreateClientBodyOutput = zod.output<typeof CreateClientBody>;

export const updateClientBodyNameMax = 200;

export const updateClientBodySlugMax = 40;

export const updateClientBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const updateClientBodyDraftingWeekdayOneMin = 0;
export const updateClientBodyDraftingWeekdayOneMax = 6;

export const UpdateClientBody = zod.object({
    name: zod.string().min(1).max(updateClientBodyNameMax),
    slug: zod.string().max(updateClientBodySlugMax).regex(updateClientBodySlugRegExp),
    address: zod.string(),
    description: zod.string(),
    drafting_weekday: zod
        .union([
            zod.int().min(updateClientBodyDraftingWeekdayOneMin).max(updateClientBodyDraftingWeekdayOneMax),
            zod.null(),
        ])
        .optional(),
});

export type UpdateClientBody = zod.input<typeof UpdateClientBody>;
export type UpdateClientBodyOutput = zod.output<typeof UpdateClientBody>;

export const StarClientBody = zod.object({
    is_starred: zod.boolean(),
});

export type StarClientBody = zod.input<typeof StarClientBody>;
export type StarClientBodyOutput = zod.output<typeof StarClientBody>;

export const UpdateClientTeamBody = zod.object({
    team_scope: zod.enum(['workspace', 'chosen']),
    member_ids: zod.array(zod.uuid()),
});

export type UpdateClientTeamBody = zod.input<typeof UpdateClientTeamBody>;
export type UpdateClientTeamBodyOutput = zod.output<typeof UpdateClientTeamBody>;

export const UploadClientLogoBody = zod.object({
    file: zod.instanceof(Blob),
});

export type UploadClientLogoBody = zod.input<typeof UploadClientLogoBody>;
export type UploadClientLogoBodyOutput = zod.output<typeof UploadClientLogoBody>;

export const createProjectBodyNameMax = 200;

export const createProjectBodySlugMax = 40;

export const createProjectBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const createProjectBodyDraftingWeekdayOneMin = 0;
export const createProjectBodyDraftingWeekdayOneMax = 6;

export const CreateProjectBody = zod.object({
    name: zod.string().min(1).max(createProjectBodyNameMax),
    slug: zod.string().max(createProjectBodySlugMax).regex(createProjectBodySlugRegExp),
    drafting_weekday: zod
        .union([
            zod.int().min(createProjectBodyDraftingWeekdayOneMin).max(createProjectBodyDraftingWeekdayOneMax),
            zod.null(),
        ])
        .optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateProjectBody = zod.input<typeof CreateProjectBody>;
export type CreateProjectBodyOutput = zod.output<typeof CreateProjectBody>;

export const UpdateProjectClientBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
});

export type UpdateProjectClientBody = zod.input<typeof UpdateProjectClientBody>;
export type UpdateProjectClientBodyOutput = zod.output<typeof UpdateProjectClientBody>;

export const updateProjectBodyNameMax = 200;

export const updateProjectBodySlugMax = 40;

export const updateProjectBodySlugRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');
export const updateProjectBodyDraftingWeekdayOneMin = 0;
export const updateProjectBodyDraftingWeekdayOneMax = 6;

export const UpdateProjectBody = zod.object({
    name: zod.string().min(1).max(updateProjectBodyNameMax),
    slug: zod.string().max(updateProjectBodySlugMax).regex(updateProjectBodySlugRegExp),
    drafting_weekday: zod
        .union([
            zod.int().min(updateProjectBodyDraftingWeekdayOneMin).max(updateProjectBodyDraftingWeekdayOneMax),
            zod.null(),
        ])
        .optional(),
});

export type UpdateProjectBody = zod.input<typeof UpdateProjectBody>;
export type UpdateProjectBodyOutput = zod.output<typeof UpdateProjectBody>;

export const StarProjectBody = zod.object({
    is_starred: zod.boolean(),
});

export type StarProjectBody = zod.input<typeof StarProjectBody>;
export type StarProjectBodyOutput = zod.output<typeof StarProjectBody>;

export const UpdateProjectTeamBody = zod.object({
    team_scope: zod.enum(['workspace', 'client', 'chosen']),
    member_ids: zod.array(zod.uuid()),
});

export type UpdateProjectTeamBody = zod.input<typeof UpdateProjectTeamBody>;
export type UpdateProjectTeamBodyOutput = zod.output<typeof UpdateProjectTeamBody>;

export const UpdateProjectEmployeesBody = zod.object({
    client_access: zod.enum(['all', 'chosen']),
    employee_ids: zod.array(zod.uuid()),
});

export type UpdateProjectEmployeesBody = zod.input<typeof UpdateProjectEmployeesBody>;
export type UpdateProjectEmployeesBodyOutput = zod.output<typeof UpdateProjectEmployeesBody>;

export const UploadProjectLogoBody = zod.object({
    file: zod.instanceof(Blob),
});

export type UploadProjectLogoBody = zod.input<typeof UploadProjectLogoBody>;
export type UploadProjectLogoBodyOutput = zod.output<typeof UploadProjectLogoBody>;

export const updateClientEmailAddressBodyPrefixMax = 40;

export const updateClientEmailAddressBodyPrefixRegExp = new RegExp('^([a-z0-9]+(-[a-z0-9]+)*)?$');

export const UpdateClientEmailAddressBody = zod.object({
    prefix: zod.string().max(updateClientEmailAddressBodyPrefixMax).regex(updateClientEmailAddressBodyPrefixRegExp),
});

export type UpdateClientEmailAddressBody = zod.input<typeof UpdateClientEmailAddressBody>;
export type UpdateClientEmailAddressBodyOutput = zod.output<typeof UpdateClientEmailAddressBody>;

export const updateProjectEmailAddressBodyPrefixMax = 40;

export const updateProjectEmailAddressBodyPrefixRegExp = new RegExp('^([a-z0-9]+(-[a-z0-9]+)*)?$');

export const UpdateProjectEmailAddressBody = zod.object({
    prefix: zod.string().max(updateProjectEmailAddressBodyPrefixMax).regex(updateProjectEmailAddressBodyPrefixRegExp),
});

export type UpdateProjectEmailAddressBody = zod.input<typeof UpdateProjectEmailAddressBody>;
export type UpdateProjectEmailAddressBodyOutput = zod.output<typeof UpdateProjectEmailAddressBody>;

export const UpdateEmployeeBody = zod.object({
    is_disabled: zod.boolean(),
});

export type UpdateEmployeeBody = zod.input<typeof UpdateEmployeeBody>;
export type UpdateEmployeeBodyOutput = zod.output<typeof UpdateEmployeeBody>;

export const createEmployeeInvitationBodyProjectIdsDefault = [];
export const createEmployeeInvitationBodyNameDefault = ``;
export const createEmployeeInvitationBodyNameMax = 255;

export const createEmployeeInvitationBodyJobTitleDefault = ``;
export const createEmployeeInvitationBodyJobTitleMax = 255;

export const CreateEmployeeInvitationBody = zod.object({
    email: zod.union([zod.email(), zod.null()]),
    project_ids: zod.array(zod.uuid()).default(createEmployeeInvitationBodyProjectIdsDefault),
    name: zod.string().max(createEmployeeInvitationBodyNameMax).default(createEmployeeInvitationBodyNameDefault),
    job_title: zod
        .string()
        .max(createEmployeeInvitationBodyJobTitleMax)
        .default(createEmployeeInvitationBodyJobTitleDefault),
});

export type CreateEmployeeInvitationBody = zod.input<typeof CreateEmployeeInvitationBody>;
export type CreateEmployeeInvitationBodyOutput = zod.output<typeof CreateEmployeeInvitationBody>;

export const listSourcesParamsPageDefault = 1;

export const ListSourcesParams = zod.object({
    search: zod.string().optional(),
    extraction_status: zod.enum(['processing', 'done', 'failed']).optional(),
    is_processing: zod.boolean().optional(),
    client_id: zod.uuid().optional(),
    has_client: zod.boolean().optional(),
    project_id: zod.uuid().optional(),
    has_project: zod.boolean().optional(),
    is_waiting: zod.boolean().optional(),
    is_filed: zod.boolean().optional(),
    page: zod.int().min(1).default(listSourcesParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListSourcesParams = zod.input<typeof ListSourcesParams>;
export type ListSourcesParamsOutput = zod.output<typeof ListSourcesParams>;

export const UploadSourceBody = zod.object({
    file: zod.instanceof(Blob),
    kind: zod.enum([
        'upload',
        'email',
        'mobile',
        'document',
        'link',
        'ticket',
        'calendar_event',
        'meeting',
        'conversation',
    ]),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type UploadSourceBody = zod.input<typeof UploadSourceBody>;
export type UploadSourceBodyOutput = zod.output<typeof UploadSourceBody>;

export const UpdateSourcesBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
    source_ids: zod.array(zod.uuid()),
});

export type UpdateSourcesBody = zod.input<typeof UpdateSourcesBody>;
export type UpdateSourcesBodyOutput = zod.output<typeof UpdateSourcesBody>;

export const createSourceFromLinkBodyUrlMax = 2000;

export const CreateSourceFromLinkBody = zod.object({
    url: zod.string().min(1).max(createSourceFromLinkBodyUrlMax),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreateSourceFromLinkBody = zod.input<typeof CreateSourceFromLinkBody>;
export type CreateSourceFromLinkBodyOutput = zod.output<typeof CreateSourceFromLinkBody>;

export const createSourcesFromPickBodyExternalIdsMax = 20;

export const CreateSourcesFromPickBody = zod.object({
    connection_id: zod.uuid(),
    external_ids: zod.array(zod.string()).min(1).max(createSourcesFromPickBodyExternalIdsMax),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreateSourcesFromPickBody = zod.input<typeof CreateSourcesFromPickBody>;
export type CreateSourcesFromPickBodyOutput = zod.output<typeof CreateSourcesFromPickBody>;

export const UpdateSourceBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type UpdateSourceBody = zod.input<typeof UpdateSourceBody>;
export type UpdateSourceBodyOutput = zod.output<typeof UpdateSourceBody>;

export const listRecapsParamsPageDefault = 1;

export const ListRecapsParams = zod.object({
    search: zod.string().optional(),
    extraction_status: zod.enum(['processing', 'done', 'failed']).optional(),
    is_published: zod.boolean().optional(),
    has_draft: zod.boolean().optional(),
    client_id: zod.uuid().optional(),
    has_client: zod.boolean().optional(),
    project_id: zod.uuid().optional(),
    has_project: zod.boolean().optional(),
    is_waiting_for_acknowledgement: zod.boolean().optional(),
    is_draft: zod.boolean().optional(),
    source_id: zod.uuid().optional(),
    page: zod.int().min(1).default(listRecapsParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListRecapsParams = zod.input<typeof ListRecapsParams>;
export type ListRecapsParamsOutput = zod.output<typeof ListRecapsParams>;

export const createRecapFromSourcesBodyTitleOneMax = 500;

export const CreateRecapFromSourcesBody = zod.object({
    source_file_ids: zod.array(zod.uuid()),
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
    title: zod.union([zod.string().min(1).max(createRecapFromSourcesBodyTitleOneMax), zod.null()]).optional(),
    summary: zod.union([zod.string().min(1), zod.null()]).optional(),
});

export type CreateRecapFromSourcesBody = zod.input<typeof CreateRecapFromSourcesBody>;
export type CreateRecapFromSourcesBodyOutput = zod.output<typeof CreateRecapFromSourcesBody>;

export const updateRecapBodyTitleOneMax = 500;

export const UpdateRecapBody = zod.object({
    title: zod.union([zod.string().min(1).max(updateRecapBodyTitleOneMax), zod.null()]),
    summary: zod.union([zod.string().min(1), zod.null()]),
});

export type UpdateRecapBody = zod.input<typeof UpdateRecapBody>;
export type UpdateRecapBodyOutput = zod.output<typeof UpdateRecapBody>;

export const UpdateRecapProjectBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]),
    project_id: zod.union([zod.uuid(), zod.null()]),
});

export type UpdateRecapProjectBody = zod.input<typeof UpdateRecapProjectBody>;
export type UpdateRecapProjectBodyOutput = zod.output<typeof UpdateRecapProjectBody>;

export const UpdateSourceFilesBody = zod.object({
    source_file_ids: zod.array(zod.uuid()),
});

export type UpdateSourceFilesBody = zod.input<typeof UpdateSourceFilesBody>;
export type UpdateSourceFilesBodyOutput = zod.output<typeof UpdateSourceFilesBody>;

export const createPersonBodyNameMax = 255;

export const createPersonBodyCompanyOneMax = 255;

export const createPersonBodyJobTitleOneMax = 255;

export const CreatePersonBody = zod.object({
    name: zod.string().min(1).max(createPersonBodyNameMax),
    email: zod.union([zod.email(), zod.null()]),
    company: zod.union([zod.string().min(1).max(createPersonBodyCompanyOneMax), zod.null()]),
    job_title: zod.union([zod.string().min(1).max(createPersonBodyJobTitleOneMax), zod.null()]),
    is_participant: zod.boolean(),
    user_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreatePersonBody = zod.input<typeof CreatePersonBody>;
export type CreatePersonBodyOutput = zod.output<typeof CreatePersonBody>;

export const updatePersonBodyNameMax = 255;

export const updatePersonBodyCompanyOneMax = 255;

export const updatePersonBodyJobTitleOneMax = 255;

export const UpdatePersonBody = zod.object({
    name: zod.string().min(1).max(updatePersonBodyNameMax),
    email: zod.union([zod.email(), zod.null()]),
    company: zod.union([zod.string().min(1).max(updatePersonBodyCompanyOneMax), zod.null()]),
    job_title: zod.union([zod.string().min(1).max(updatePersonBodyJobTitleOneMax), zod.null()]),
    is_participant: zod.boolean(),
    user_id: zod.union([zod.uuid(), zod.null()]),
});

export type UpdatePersonBody = zod.input<typeof UpdatePersonBody>;
export type UpdatePersonBodyOutput = zod.output<typeof UpdatePersonBody>;

export const createTopicBodyTitleMax = 500;

export const CreateTopicBody = zod.object({
    title: zod.string().min(1).max(createTopicBodyTitleMax),
    summary: zod.union([zod.string().min(1), zod.null()]),
});

export type CreateTopicBody = zod.input<typeof CreateTopicBody>;
export type CreateTopicBodyOutput = zod.output<typeof CreateTopicBody>;

export const updateTopicBodyTitleMax = 500;

export const UpdateTopicBody = zod.object({
    title: zod.string().min(1).max(updateTopicBodyTitleMax),
    summary: zod.union([zod.string().min(1), zod.null()]),
});

export type UpdateTopicBody = zod.input<typeof UpdateTopicBody>;
export type UpdateTopicBodyOutput = zod.output<typeof UpdateTopicBody>;

export const moveTopicBodyPositionMin = 0;

export const MoveTopicBody = zod.object({
    position: zod.int().min(moveTopicBodyPositionMin),
});

export type MoveTopicBody = zod.input<typeof MoveTopicBody>;
export type MoveTopicBodyOutput = zod.output<typeof MoveTopicBody>;

export const createDecisionBodyTitleMax = 500;

export const CreateDecisionBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(createDecisionBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
});

export type CreateDecisionBody = zod.input<typeof CreateDecisionBody>;
export type CreateDecisionBodyOutput = zod.output<typeof CreateDecisionBody>;

export const updateDecisionBodyTitleMax = 500;

export const UpdateDecisionBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(updateDecisionBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
});

export type UpdateDecisionBody = zod.input<typeof UpdateDecisionBody>;
export type UpdateDecisionBodyOutput = zod.output<typeof UpdateDecisionBody>;

export const moveDecisionBodyPositionMin = 0;

export const MoveDecisionBody = zod.object({
    position: zod.int().min(moveDecisionBodyPositionMin),
    topic_id: zod.uuid(),
});

export type MoveDecisionBody = zod.input<typeof MoveDecisionBody>;
export type MoveDecisionBodyOutput = zod.output<typeof MoveDecisionBody>;

export const createTodoBodyTitleMax = 500;

export const CreateTodoBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(createTodoBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    person_id: zod.union([zod.uuid(), zod.null()]),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateTodoBody = zod.input<typeof CreateTodoBody>;
export type CreateTodoBodyOutput = zod.output<typeof CreateTodoBody>;

export const updateTodoBodyTitleMax = 500;

export const UpdateTodoBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(updateTodoBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    person_id: zod.union([zod.uuid(), zod.null()]),
    due_date: zod.union([zod.iso.date(), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type UpdateTodoBody = zod.input<typeof UpdateTodoBody>;
export type UpdateTodoBodyOutput = zod.output<typeof UpdateTodoBody>;

export const moveTodoBodyPositionMin = 0;

export const MoveTodoBody = zod.object({
    position: zod.int().min(moveTodoBodyPositionMin),
    topic_id: zod.uuid(),
});

export type MoveTodoBody = zod.input<typeof MoveTodoBody>;
export type MoveTodoBodyOutput = zod.output<typeof MoveTodoBody>;

export const MarkTodoDoneBody = zod.object({
    is_done: zod.boolean(),
});

export type MarkTodoDoneBody = zod.input<typeof MarkTodoDoneBody>;
export type MarkTodoDoneBodyOutput = zod.output<typeof MarkTodoDoneBody>;

export const reportTodoExternalLinkBodyExternalIdMax = 255;

export const reportTodoExternalLinkBodyUrlOneMax = 2000;

export const reportTodoExternalLinkBodyUrlOneRegExp = new RegExp('^https://\\S+$');
export const reportTodoExternalLinkBodyServiceNameOneMax = 255;

export const ReportTodoExternalLinkBody = zod.object({
    external_id: zod.string().min(1).max(reportTodoExternalLinkBodyExternalIdMax),
    url: zod
        .union([
            zod.string().max(reportTodoExternalLinkBodyUrlOneMax).regex(reportTodoExternalLinkBodyUrlOneRegExp),
            zod.null(),
        ])
        .optional(),
    service_name: zod.union([zod.string().max(reportTodoExternalLinkBodyServiceNameOneMax), zod.null()]).optional(),
});

export type ReportTodoExternalLinkBody = zod.input<typeof ReportTodoExternalLinkBody>;
export type ReportTodoExternalLinkBodyOutput = zod.output<typeof ReportTodoExternalLinkBody>;

export const createEventBodyTitleMax = 500;

export const CreateEventBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(createEventBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    date: zod.iso.date(),
    time: zod.union([zod.iso.time({}), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateEventBody = zod.input<typeof CreateEventBody>;
export type CreateEventBodyOutput = zod.output<typeof CreateEventBody>;

export const updateEventBodyTitleMax = 500;

export const UpdateEventBody = zod.object({
    topic_id: zod.uuid(),
    title: zod.string().min(1).max(updateEventBodyTitleMax),
    description: zod.union([zod.string().min(1), zod.null()]),
    date: zod.iso.date(),
    time: zod.union([zod.iso.time({}), zod.null()]),
    supersedes_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type UpdateEventBody = zod.input<typeof UpdateEventBody>;
export type UpdateEventBodyOutput = zod.output<typeof UpdateEventBody>;

export const moveEventBodyPositionMin = 0;

export const MoveEventBody = zod.object({
    position: zod.int().min(moveEventBodyPositionMin),
    topic_id: zod.uuid(),
});

export type MoveEventBody = zod.input<typeof MoveEventBody>;
export type MoveEventBodyOutput = zod.output<typeof MoveEventBody>;

export const publishRecapBodyInvitationIdsDefault = [];
export const PublishRecapBody = zod.object({
    is_acknowledgement_required: zod.boolean(),
    acknowledger_ids: zod.array(zod.uuid()),
    invitation_ids: zod.array(zod.uuid()).default(publishRecapBodyInvitationIdsDefault),
});

export type PublishRecapBody = zod.input<typeof PublishRecapBody>;
export type PublishRecapBodyOutput = zod.output<typeof PublishRecapBody>;

export const updateAcknowledgersBodyInvitationIdsDefault = [];
export const UpdateAcknowledgersBody = zod.object({
    user_ids: zod.array(zod.uuid()),
    invitation_ids: zod.array(zod.uuid()).default(updateAcknowledgersBodyInvitationIdsDefault),
});

export type UpdateAcknowledgersBody = zod.input<typeof UpdateAcknowledgersBody>;
export type UpdateAcknowledgersBodyOutput = zod.output<typeof UpdateAcknowledgersBody>;

export const createConnectionBodyNameOneMax = 200;

export const createConnectionBodyIsOwnDefault = false;
export const CreateConnectionBody = zod.object({
    provider: zod.string(),
    name: zod.union([zod.string().min(1).max(createConnectionBodyNameOneMax), zod.null()]).optional(),
    is_own: zod.boolean().default(createConnectionBodyIsOwnDefault),
    settings: zod.record(zod.string(), zod.unknown()),
    credentials: zod.record(zod.string(), zod.unknown()),
    bot_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateConnectionBody = zod.input<typeof CreateConnectionBody>;
export type CreateConnectionBodyOutput = zod.output<typeof CreateConnectionBody>;

export const CheckConnectionBody = zod.object({
    connection_id: zod.union([zod.uuid(), zod.null()]).optional(),
    provider: zod.string(),
    settings: zod.record(zod.string(), zod.unknown()),
    credentials: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
});

export type CheckConnectionBody = zod.input<typeof CheckConnectionBody>;
export type CheckConnectionBodyOutput = zod.output<typeof CheckConnectionBody>;

export const startOauthBodyIsOwnDefault = false;
export const startOauthBodyFacetsDefault = [];
export const startOauthBodyIsForFilesDefault = false;
export const startOauthBodyIsForStartDefault = false;
export const StartOauthBody = zod.object({
    provider: zod.string(),
    is_own: zod.boolean().default(startOauthBodyIsOwnDefault),
    connection_id: zod.union([zod.uuid(), zod.null()]).optional(),
    facets: zod
        .array(
            zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ])
        )
        .default(startOauthBodyFacetsDefault),
    is_for_files: zod.boolean().default(startOauthBodyIsForFilesDefault),
    is_for_start: zod.boolean().default(startOauthBodyIsForStartDefault),
});

export type StartOauthBody = zod.input<typeof StartOauthBody>;
export type StartOauthBodyOutput = zod.output<typeof StartOauthBody>;

export const listPickItemsParamsSearchDefault = ``;
export const ListPickItemsParams = zod.object({
    place_id: zod.string().optional(),
    search: zod.string().default(listPickItemsParamsSearchDefault),
});

export type ListPickItemsParams = zod.input<typeof ListPickItemsParams>;
export type ListPickItemsParamsOutput = zod.output<typeof ListPickItemsParams>;

export const updateConnectionBodyNameOneMax = 200;

export const UpdateConnectionBody = zod.object({
    name: zod.union([zod.string().min(1).max(updateConnectionBodyNameOneMax), zod.null()]).optional(),
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    credentials: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
});

export type UpdateConnectionBody = zod.input<typeof UpdateConnectionBody>;
export type UpdateConnectionBodyOutput = zod.output<typeof UpdateConnectionBody>;

export const ListBoardListsParams = zod.object({
    board_url: zod.string(),
});

export type ListBoardListsParams = zod.input<typeof ListBoardListsParams>;
export type ListBoardListsParamsOutput = zod.output<typeof ListBoardListsParams>;

export const createFeedBodyIsKeepingUnmatchedDefault = false;
export const createFeedBodyDraftingDefault = `none`;
export const CreateFeedBody = zod.object({
    facet: zod.enum([
        'email',
        'meeting',
        'document',
        'task',
        'conversation',
        'calendar',
        'events',
        'todos',
        'recaps',
        'clients',
    ]),
    settings: zod.record(zod.string(), zod.unknown()),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.boolean().default(createFeedBodyIsKeepingUnmatchedDefault),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.enum(['none', 'alone', 'with_waiting']).default(createFeedBodyDraftingDefault),
});

export type CreateFeedBody = zod.input<typeof CreateFeedBody>;
export type CreateFeedBodyOutput = zod.output<typeof CreateFeedBody>;

export const UpdateFeedBody = zod.object({
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.union([zod.boolean(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.union([zod.enum(['none', 'alone', 'with_waiting']), zod.null()]).optional(),
});

export type UpdateFeedBody = zod.input<typeof UpdateFeedBody>;
export type UpdateFeedBodyOutput = zod.output<typeof UpdateFeedBody>;

export const updateFeedEmailAddressBodyPrefixMax = 40;

export const updateFeedEmailAddressBodyPrefixRegExp = new RegExp('^([a-z0-9]+(-[a-z0-9]+)*)?$');

export const UpdateFeedEmailAddressBody = zod.object({
    prefix: zod.string().max(updateFeedEmailAddressBodyPrefixMax).regex(updateFeedEmailAddressBodyPrefixRegExp),
});

export type UpdateFeedEmailAddressBody = zod.input<typeof UpdateFeedEmailAddressBody>;
export type UpdateFeedEmailAddressBodyOutput = zod.output<typeof UpdateFeedEmailAddressBody>;

export const createRouteBodyGroupsItemItemValuesDefault = [];
export const createRouteBodyGroupsDefault = [];
export const createRouteBodyDraftingDefault = `none`;
export const CreateRouteBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    groups: zod
        .array(
            zod.array(
                zod.object({
                    field: zod.enum([
                        'senders',
                        'recipients',
                        'subject',
                        'words',
                        'not_words',
                        'body',
                        'file_names',
                        'lists',
                        'query',
                    ]),
                    values: zod.array(zod.string()).default(createRouteBodyGroupsItemItemValuesDefault),
                    query: zod.union([zod.string(), zod.null()]).optional(),
                })
            )
        )
        .default(createRouteBodyGroupsDefault),
    drafting: zod.enum(['none', 'alone', 'with_waiting']).default(createRouteBodyDraftingDefault),
});

export type CreateRouteBody = zod.input<typeof CreateRouteBody>;
export type CreateRouteBodyOutput = zod.output<typeof CreateRouteBody>;

export const updateRouteBodyGroupsOneItemItemValuesDefault = [];
export const UpdateRouteBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    groups: zod
        .union([
            zod.array(
                zod.array(
                    zod.object({
                        field: zod.enum([
                            'senders',
                            'recipients',
                            'subject',
                            'words',
                            'not_words',
                            'body',
                            'file_names',
                            'lists',
                            'query',
                        ]),
                        values: zod.array(zod.string()).default(updateRouteBodyGroupsOneItemItemValuesDefault),
                        query: zod.union([zod.string(), zod.null()]).optional(),
                    })
                )
            ),
            zod.null(),
        ])
        .optional(),
    drafting: zod.union([zod.enum(['none', 'alone', 'with_waiting']), zod.null()]).optional(),
});

export type UpdateRouteBody = zod.input<typeof UpdateRouteBody>;
export type UpdateRouteBodyOutput = zod.output<typeof UpdateRouteBody>;

export const previewRouteBodyGroupsItemItemValuesDefault = [];
export const PreviewRouteBody = zod.object({
    groups: zod.array(
        zod.array(
            zod.object({
                field: zod.enum([
                    'senders',
                    'recipients',
                    'subject',
                    'words',
                    'not_words',
                    'body',
                    'file_names',
                    'lists',
                    'query',
                ]),
                values: zod.array(zod.string()).default(previewRouteBodyGroupsItemItemValuesDefault),
                query: zod.union([zod.string(), zod.null()]).optional(),
            })
        )
    ),
    route_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type PreviewRouteBody = zod.input<typeof PreviewRouteBody>;
export type PreviewRouteBodyOutput = zod.output<typeof PreviewRouteBody>;

export const listExternalCompaniesParamsPageDefault = 1;

export const ListExternalCompaniesParams = zod.object({
    is_suggested: zod.boolean().optional(),
    search: zod.string().optional(),
    page: zod.int().min(1).default(listExternalCompaniesParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListExternalCompaniesParams = zod.input<typeof ListExternalCompaniesParams>;
export type ListExternalCompaniesParamsOutput = zod.output<typeof ListExternalCompaniesParams>;

export const UpdateExternalCompanyBody = zod.object({
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    is_dismissed: zod.union([zod.boolean(), zod.null()]).optional(),
});

export type UpdateExternalCompanyBody = zod.input<typeof UpdateExternalCompanyBody>;
export type UpdateExternalCompanyBodyOutput = zod.output<typeof UpdateExternalCompanyBody>;

export const listActivitiesParamsOrderDefault = `newest`;
export const listActivitiesParamsPageDefault = 1;

export const ListActivitiesParams = zod.object({
    project_id: zod.uuid().optional(),
    client_id: zod.uuid().optional(),
    recap_id: zod.uuid().optional(),
    is_new: zod.boolean().optional(),
    order: zod.enum(['newest', 'oldest']).default(listActivitiesParamsOrderDefault),
    page: zod.int().min(1).default(listActivitiesParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListActivitiesParams = zod.input<typeof ListActivitiesParams>;
export type ListActivitiesParamsOutput = zod.output<typeof ListActivitiesParams>;

export const createRecapCommentBodyTextMax = 10000;

export const CreateRecapCommentBody = zod.object({
    text: zod.string().min(1).max(createRecapCommentBodyTextMax),
    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
    item_id: zod.union([zod.uuid(), zod.null()]),
    version_number: zod.union([zod.int(), zod.null()]),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreateRecapCommentBody = zod.input<typeof CreateRecapCommentBody>;
export type CreateRecapCommentBodyOutput = zod.output<typeof CreateRecapCommentBody>;

export const createSourceCommentBodyTextMax = 10000;

export const CreateSourceCommentBody = zod.object({
    text: zod.string().min(1).max(createSourceCommentBodyTextMax),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreateSourceCommentBody = zod.input<typeof CreateSourceCommentBody>;
export type CreateSourceCommentBodyOutput = zod.output<typeof CreateSourceCommentBody>;

export const updateCommentBodyTextMax = 10000;

export const UpdateCommentBody = zod.object({
    text: zod.string().min(1).max(updateCommentBodyTextMax),
});

export type UpdateCommentBody = zod.input<typeof UpdateCommentBody>;
export type UpdateCommentBodyOutput = zod.output<typeof UpdateCommentBody>;

export const createStartClientBodyNameMax = 200;

export const createStartClientBodyProjectsDefault = [];
export const createStartClientBodySourceIdsDefault = [];
export const CreateStartClientBody = zod.object({
    key: zod.union([zod.string(), zod.null()]).optional(),
    name: zod.string().min(1).max(createStartClientBodyNameMax),
    projects: zod
        .array(
            zod.object({
                name: zod.string(),
                source_ids: zod.array(zod.uuid()),
            })
        )
        .default(createStartClientBodyProjectsDefault),
    source_ids: zod.array(zod.uuid()).default(createStartClientBodySourceIdsDefault),
});

export type CreateStartClientBody = zod.input<typeof CreateStartClientBody>;
export type CreateStartClientBodyOutput = zod.output<typeof CreateStartClientBody>;

export const passStartStepBodyIsSkippedDefault = false;
export const PassStartStepBody = zod.object({
    step: zod.enum(['clients', 'invite', 'publish']),
    is_skipped: zod.boolean().default(passStartStepBodyIsSkippedDefault),
});

export type PassStartStepBody = zod.input<typeof PassStartStepBody>;
export type PassStartStepBodyOutput = zod.output<typeof PassStartStepBody>;

export const reopenStartStepBodyIsSkippedDefault = false;
export const ReopenStartStepBody = zod.object({
    step: zod.enum(['clients', 'invite', 'publish']),
    is_skipped: zod.boolean().default(reopenStartStepBodyIsSkippedDefault),
});

export type ReopenStartStepBody = zod.input<typeof ReopenStartStepBody>;
export type ReopenStartStepBodyOutput = zod.output<typeof ReopenStartStepBody>;

export const UpdateNotificationSettingBody = zod.object({
    kind: zod.enum([
        'source_received',
        'source_failed',
        'recap_created',
        'recap_drafted',
        'version_published',
        'todo_ticked',
        'comment_added',
        'acknowledgement_requested',
        'recap_acknowledged',
        'feed_failed',
        'todo_due',
    ]),
    delivery: zod.enum(['immediately', 'daily', 'never']),
});

export type UpdateNotificationSettingBody = zod.input<typeof UpdateNotificationSettingBody>;
export type UpdateNotificationSettingBodyOutput = zod.output<typeof UpdateNotificationSettingBody>;

export const MuteRecapBody = zod.object({
    is_muted: zod.boolean(),
});

export type MuteRecapBody = zod.input<typeof MuteRecapBody>;
export type MuteRecapBodyOutput = zod.output<typeof MuteRecapBody>;

export const listEmployeeRecapsParamsPageDefault = 1;

export const ListEmployeeRecapsParams = zod.object({
    search: zod.string().optional(),
    project_id: zod.uuid().optional(),
    page: zod.int().min(1).default(listEmployeeRecapsParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListEmployeeRecapsParams = zod.input<typeof ListEmployeeRecapsParams>;
export type ListEmployeeRecapsParamsOutput = zod.output<typeof ListEmployeeRecapsParams>;

export const MarkEmployeeTodoDoneBody = zod.object({
    is_done: zod.boolean(),
});

export type MarkEmployeeTodoDoneBody = zod.input<typeof MarkEmployeeTodoDoneBody>;
export type MarkEmployeeTodoDoneBodyOutput = zod.output<typeof MarkEmployeeTodoDoneBody>;

export const createEmployeeRecapCommentBodyTextMax = 10000;

export const CreateEmployeeRecapCommentBody = zod.object({
    text: zod.string().min(1).max(createEmployeeRecapCommentBodyTextMax),
    item_kind: zod.union([zod.enum(['topic', 'decision', 'todo', 'event']), zod.null()]),
    item_id: zod.union([zod.uuid(), zod.null()]),
    version_number: zod.union([zod.int(), zod.null()]),
    reply_to_id: zod.union([zod.uuid(), zod.null()]),
});

export type CreateEmployeeRecapCommentBody = zod.input<typeof CreateEmployeeRecapCommentBody>;
export type CreateEmployeeRecapCommentBodyOutput = zod.output<typeof CreateEmployeeRecapCommentBody>;

export const updateEmployeeCommentBodyTextMax = 10000;

export const UpdateEmployeeCommentBody = zod.object({
    text: zod.string().min(1).max(updateEmployeeCommentBodyTextMax),
});

export type UpdateEmployeeCommentBody = zod.input<typeof UpdateEmployeeCommentBody>;
export type UpdateEmployeeCommentBodyOutput = zod.output<typeof UpdateEmployeeCommentBody>;

export const listEmployeeRecapActivitiesParamsOrderDefault = `newest`;
export const listEmployeeRecapActivitiesParamsPageDefault = 1;

export const ListEmployeeRecapActivitiesParams = zod.object({
    order: zod.enum(['newest', 'oldest']).default(listEmployeeRecapActivitiesParamsOrderDefault),
    page: zod.int().min(1).default(listEmployeeRecapActivitiesParamsPageDefault),
    page_size: zod.int().min(1).optional(),
});

export type ListEmployeeRecapActivitiesParams = zod.input<typeof ListEmployeeRecapActivitiesParams>;
export type ListEmployeeRecapActivitiesParamsOutput = zod.output<typeof ListEmployeeRecapActivitiesParams>;

export const UpdateEmployeeNotificationSettingBody = zod.object({
    kind: zod.enum([
        'source_received',
        'source_failed',
        'recap_created',
        'recap_drafted',
        'version_published',
        'todo_ticked',
        'comment_added',
        'acknowledgement_requested',
        'recap_acknowledged',
        'feed_failed',
        'todo_due',
    ]),
    delivery: zod.enum(['immediately', 'daily', 'never']),
});

export type UpdateEmployeeNotificationSettingBody = zod.input<typeof UpdateEmployeeNotificationSettingBody>;
export type UpdateEmployeeNotificationSettingBodyOutput = zod.output<typeof UpdateEmployeeNotificationSettingBody>;

export const MuteEmployeeRecapBody = zod.object({
    is_muted: zod.boolean(),
});

export type MuteEmployeeRecapBody = zod.input<typeof MuteEmployeeRecapBody>;
export type MuteEmployeeRecapBodyOutput = zod.output<typeof MuteEmployeeRecapBody>;

export const createEmployeeConnectionBodyNameOneMax = 200;

export const createEmployeeConnectionBodyIsOwnDefault = false;
export const CreateEmployeeConnectionBody = zod.object({
    provider: zod.string(),
    name: zod.union([zod.string().min(1).max(createEmployeeConnectionBodyNameOneMax), zod.null()]).optional(),
    is_own: zod.boolean().default(createEmployeeConnectionBodyIsOwnDefault),
    settings: zod.record(zod.string(), zod.unknown()),
    credentials: zod.record(zod.string(), zod.unknown()),
    bot_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export type CreateEmployeeConnectionBody = zod.input<typeof CreateEmployeeConnectionBody>;
export type CreateEmployeeConnectionBodyOutput = zod.output<typeof CreateEmployeeConnectionBody>;

export const startEmployeeOauthBodyIsOwnDefault = false;
export const startEmployeeOauthBodyFacetsDefault = [];
export const startEmployeeOauthBodyIsForFilesDefault = false;
export const startEmployeeOauthBodyIsForStartDefault = false;
export const StartEmployeeOauthBody = zod.object({
    provider: zod.string(),
    is_own: zod.boolean().default(startEmployeeOauthBodyIsOwnDefault),
    connection_id: zod.union([zod.uuid(), zod.null()]).optional(),
    facets: zod
        .array(
            zod.enum([
                'email',
                'meeting',
                'document',
                'task',
                'conversation',
                'calendar',
                'events',
                'todos',
                'recaps',
                'clients',
            ])
        )
        .default(startEmployeeOauthBodyFacetsDefault),
    is_for_files: zod.boolean().default(startEmployeeOauthBodyIsForFilesDefault),
    is_for_start: zod.boolean().default(startEmployeeOauthBodyIsForStartDefault),
});

export type StartEmployeeOauthBody = zod.input<typeof StartEmployeeOauthBody>;
export type StartEmployeeOauthBodyOutput = zod.output<typeof StartEmployeeOauthBody>;

export const updateEmployeeConnectionBodyNameOneMax = 200;

export const UpdateEmployeeConnectionBody = zod.object({
    name: zod.union([zod.string().min(1).max(updateEmployeeConnectionBodyNameOneMax), zod.null()]).optional(),
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    credentials: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
});

export type UpdateEmployeeConnectionBody = zod.input<typeof UpdateEmployeeConnectionBody>;
export type UpdateEmployeeConnectionBodyOutput = zod.output<typeof UpdateEmployeeConnectionBody>;

export const createEmployeeFeedBodyIsKeepingUnmatchedDefault = false;
export const createEmployeeFeedBodyDraftingDefault = `none`;
export const CreateEmployeeFeedBody = zod.object({
    facet: zod.enum([
        'email',
        'meeting',
        'document',
        'task',
        'conversation',
        'calendar',
        'events',
        'todos',
        'recaps',
        'clients',
    ]),
    settings: zod.record(zod.string(), zod.unknown()),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.boolean().default(createEmployeeFeedBodyIsKeepingUnmatchedDefault),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.enum(['none', 'alone', 'with_waiting']).default(createEmployeeFeedBodyDraftingDefault),
});

export type CreateEmployeeFeedBody = zod.input<typeof CreateEmployeeFeedBody>;
export type CreateEmployeeFeedBodyOutput = zod.output<typeof CreateEmployeeFeedBody>;

export const UpdateEmployeeFeedBody = zod.object({
    settings: zod.union([zod.record(zod.string(), zod.unknown()), zod.null()]).optional(),
    synced_until: zod.union([zod.iso.datetime({ offset: true }), zod.null()]).optional(),
    is_keeping_unmatched: zod.union([zod.boolean(), zod.null()]).optional(),
    client_id: zod.union([zod.uuid(), zod.null()]).optional(),
    project_id: zod.union([zod.uuid(), zod.null()]).optional(),
    drafting: zod.union([zod.enum(['none', 'alone', 'with_waiting']), zod.null()]).optional(),
});

export type UpdateEmployeeFeedBody = zod.input<typeof UpdateEmployeeFeedBody>;
export type UpdateEmployeeFeedBodyOutput = zod.output<typeof UpdateEmployeeFeedBody>;
